import { tokens } from '../tokens'

export const ja = {
    [tokens.common.no_unassigned_sales_channel]: '未割り当ての販売先がありません。',
    [tokens.common.sales_channel_id_sales_channel_address]: '販売先ID、販売先、住所',
    [tokens.common.unassigned_list]: '未割り当てリスト',
    [tokens.common.number_of_sales_channels_monthly_average_order_total]: '{{totalSales}}件の販売先 / 月平均注文金額総{{totalAvgAmt}}計',
    [tokens.common.count]: '個',
    [tokens.common.assigned_sales_office_id]: '割り当てられた売上先ID',
    [tokens.common.sales_office_id_contact_driver_name_assigned_route]: '売上先ID、ドライバーの連絡先、ドライバー名、割り当てられたルート',
    [tokens.common.manager_id]: 'マネージャーID',
    [tokens.common.view_unassigned_managers_only]: '未割り当てマネージャーのみ表示',
    [tokens.common.business_registration_number]: '事業者番号',
    [tokens.common.vehicle_unit]: '台',
    [tokens.common.urgent_dispatch_vehicle]: '緊急配車 {{emrgDsptCnt}}台',
    [tokens.common.max_pinned_notices]: '固定のお知らせは最大6件まで登録可能です。',
    [tokens.common.notice]: 'お知らせ',
    [tokens.common.notice_details]: 'お知らせの詳細',
    [tokens.common.notice_termination_completed]: 'お知らせの終了が完了しました。',
    [tokens.common.category_required]: 'カテゴリーは必須です',
    [tokens.common.fixed]: '固定',
    [tokens.common.list]: 'リスト',
    [tokens.common.return_exchange_code]: '返品・交換コード',
    [tokens.common.no_return_exchange_history]: '返品・交換履歴がありません。',
    [tokens.common.incomplete_return_exchange_history_only]: '未完了の返品・交換履歴のみ表示',
    [tokens.common.sales_place_info_4]: '売上先ID、売上先、返品・交換コード、詳細内容',
    [tokens.common.return_exchange_history]: '返品 & 交換履歴',
    [tokens.common.incomplete]: '未完了',
    [tokens.common.sales_place_info_3]: '売上先ID、売上先、 詳細内容',
    [tokens.common.sales_place_info_2]: '売上先ID、売上先、事業者番号',
    [tokens.common.send_sms]: 'メッセージ送信',
    [tokens.common.no_claim_history_exists]: 'クレーム履歴が存在しません。',
    [tokens.common.view_unprocessed_claims_only]: '未処理のクレームのみ表示',
    [tokens.common.sales_office_id_sales_office_consultation_content]: '売上先ID, 売上先, 相談内容',
    [tokens.common.claim_history]: 'クレーム履歴',
    [tokens.common.minimum_length_9_digits_required]: '9桁以上で入力してください。',
    [tokens.common.representative_name_length_limit]: '代表者名は25文字以下で入力してください。',
    [tokens.common.corporation_name_required]: '取引法人名は必須です。',
    [tokens.common.trading_corporation_id]: '法人ID',
    [tokens.common.trading_corporation_info]: '法人ID, 法人名, 事業者名, 事業者番号',

    [tokens.common.departure_center]: '出荷地センター',
    [tokens.common.unused]: '未使用',
    [tokens.common.not_in_use]: '未使用中',
    [tokens.common.required]: '必要',
    [tokens.common.sales_outlet_registration]: '売上先の登録',
    [tokens.common.sales_outlet_update]: '売上先の修正',
    [tokens.common.error]: 'エラー',
    [tokens.common.error_occurred_during_sales_outlet_save_or_update]: '売上先の保存/修正中にエラーが発生しました。',
    [tokens.common.error_while_saving_or_updating_sales_outlet]: '売上先の保存/修正中にエラーが発生しました',
    [tokens.common.settlement_payment_month_required]: '精算支払月は必須です',
    [tokens.common.sales_place_info]: '売上先ID、売上先、売上先コード',
    [tokens.common.contract_date_is_required]: '契約日付は必須です。',
    [tokens.common.purchase_manager_selection_is_required]: '購入担当者の選択は必須です。',
    [tokens.common.registered_product_count]: '登録商品数',
    [tokens.common.purchase_place_info]: '仕入先ID、仕入先、事業者商号、事業者番号、代表者',
    [tokens.common.public_holiday_name_input]: '祝日名を入力',
    [tokens.common.holiday_start_end_date]: '祝日開始/終了日',
    [tokens.common.end_of_month_payment]: '月末決済',
    [tokens.common.contract_start_end_date]: '契約開始日/契約終了日',
    [tokens.common.trading_corporation]: '取引法人',
    [tokens.common.cannot_exceed_5_characters]: '5文字を超えることはできません。',
    [tokens.common.enter_up_to_20_characters]: '20文字以下で入力してください。',
    [tokens.common.enter_contact_person_2_name_phone_email]: '担当者2を保存するには、名前、連絡先、メールアドレスをすべて入力してください。',
    [tokens.common.brandID_brand_business_number_representative]: '取引先ID, 取引先, 事業者番号, 代表者',
    [tokens.common.contract_termination_completed]: '契約終了処理が完了しました',
    [tokens.common.code_group_deletion_completed]: 'コードグループの削除が完了しました',
    [tokens.common.select_category_change]: '変更するカテゴリを選択',
    [tokens.common.category_classification]: 'カテゴリ区分',
    [tokens.common.count_product]: '個 商品',
    [tokens.common.category_name_required]: 'カテゴリ名は必須です。',
    [tokens.common.category_name_50]: 'カテゴリ名は50文字を超えることはできません。',
    [tokens.common.category_name_required_n]: 'カテゴリ名は必須です。カテゴリ名はn文字以内で入力してください',
    [tokens.common.category_name_duplicate]: 'カテゴリ名が重複しました。',
    [tokens.common.category_code_duplicate]: 'カテゴリコードが重複しました',
    [tokens.common.languageChanged]: 'Language changed',
    [tokens.common.additional_fee]: '加算',
    [tokens.common.additional_payment_amount]: '加算支給額',
    [tokens.common.virtual_account_transaction_history]: 'バーチャル口座取引履歴照会',
    [tokens.common.no_virtual_account_transaction]: 'バーチャル口座取引履歴が存在しません',
    [tokens.common.manage_virtual_accounts]: 'バーチャル口座管理',
    [tokens.common.virtual_account_bulk_registration_completed]: 'バーチャル口座一括登録が完了しました',
    [tokens.common.virtual_account_number]: 'バーチャル口座番号',
    [tokens.common.virtual_account_number_registration]: 'バーチャル口座番号登録',
    [tokens.common.virtual_account_deletion]: 'バーチャル口座削除',
    [tokens.common.virtual_account_deletion_completed]: 'バーチャル口座削除が完了しました',
    [tokens.common.virtual_account_file]: 'バーチャル口座ファイル',
    [tokens.common.virtual_account_cancellation_approval]: 'バーチャル口座解約承認',
    [tokens.common.virtual_account_cancellation_error]: 'バーチャル口座解約中にエラーが発生しました',
    [tokens.common.virtual_account_cancellation_completed]: 'バーチャル口座解約が完了しました',
    [tokens.common.virtual_account_sales_name]: 'バーチャル口座番号売上先売上先名',
    [tokens.common.no_virtual_account_information]: 'バーチャル口座情報が存在しません',
    [tokens.common.available_stock]: '使用可能在庫',
    [tokens.common.available_stock_quantity]: '使用可能在庫数量',
    [tokens.common.available_inventory_stock]: '使用可能在庫',
    [tokens.common.stock_holding]: '在庫ホールディング',
    [tokens.common.stock_holding_quantity]: '在庫保持数量',
    [tokens.common.holding_quantity]: '現在のホールド数量',
    [tokens.common.stock_holding_warning_1]: '在庫を保持する場合、指定した数量分の注文が不可能になる可能性があるため、',
    [tokens.common.stock_holding_warning_2]: 'もう一度慎重に',
    [tokens.common.stock_holding_warning_3]: '確認後進行',
    [tokens.common.stock_holding_warning_4]: 'してください。',
    [tokens.common.individual_brand_sale_price]: '各ブランドの上位グループで個別設定された販売価格',
    [tokens.common.individual_brand_center_sale_price]: '各ブランドの出庫センター別個別設定された販売価格',
    [tokens.common.trunk_main]: '幹線',
    [tokens.common.trunk_label_printing]: '幹線 PLT ラベル出力',
    [tokens.common.trunk_route]: '幹線ルート',
    [tokens.common.trunk_route_detail]: '幹線ルート詳細',
    [tokens.common.trunk_inbound]: '幹線入庫',
    [tokens.common.trunk_inbound_detail]: '幹線入庫詳細',
    [tokens.common.trunk_plt_printing]: '幹線出力',
    [tokens.common.trunk_route_modification]: '幹線ルート修正',
    [tokens.common.trunk_shipment]: '幹線出庫',
    [tokens.common.trunk_code]: '幹線コード',
    [tokens.common.forced_inbound]: '強制入庫',
    [tokens.common.forced_inbound_registration]: '強制入庫登録',
    [tokens.common.forced_inbound_processing_confirmation]: '強制入庫処理確認',
    [tokens.common.forced_entry_registration]: '強制入庫登録',
    [tokens.common.forced_arrival_processing]: '強制入庫処理',
    [tokens.common.average_monthly_order_amount]: '売上先月平均注文金額合計',
    [tokens.common.product]: '商品',
    [tokens.common.assigned_quantity]: '割当数量',
    [tokens.common.box_unit]: '箱',
    [tokens.common.individual_picking_label_printing]: '個別ピッキング紙出力',
    [tokens.common.individual_setting_classification]: '個別設定区分',
    [tokens.common.individual_picking_paper_printing]: '個別ピッキング紙出力',
    [tokens.common.init_date]: '開始日',
    [tokens.common.confirm_early_shipment]: '個の商品の先出庫を指示しますか',
    [tokens.common.confirm_shipment]: '選択された{{totalConfirmShipment}}個の注文を出荷指示しますか？\n\n',
    [tokens.common.adjustment_details]: '個の調整金処理内容',
    [tokens.common.transaction_amount]: '取引金額',
    [tokens.common.transaction_corporation]: '法人名',
    [tokens.common.transaction_classification]: '取引区分',
    [tokens.common.trading_volume]: '取引量',
    [tokens.common.transaction_statement_receipt_method]: '取引明細書受領方式',
    [tokens.common.transaction_statement_recipient]: '取引明細書受取人',
    [tokens.common.transaction_statement_printing]: '取引明細書出力',
    [tokens.common.transaction_statement_printing_options]: '取引明細書出力 - オプション選択',
    [tokens.common.transaction_volume]: '取引物量',
    [tokens.common.company]: '本社',
    [tokens.common.company_selection_required]: '本社選択は必須です',
    [tokens.common.trading_corporation_management]: '本社管理',
    [tokens.common.trading_corporation_registration]: '法人登録',
    [tokens.common.select_trading_corporation]: '取引法人選択',
    [tokens.common.trading_corporation_selection_required]: '取引法人選択は必須です',
    [tokens.common.trading_corporation_edit_and_registration]: '取引法人修正',
    [tokens.common.trading_corporation_name_input]: '取引法人名は30何文字以内で入力してください',
    [tokens.common.duplicate_trading_corporation_name]: '取引法人名が重複しています',
    [tokens.common.trading_corporation_required]: '取引法人は必須です',
    [tokens.common.transaction_type]: '取引種類',
    [tokens.common.trading_date]: '取引日',
    [tokens.common.transaction_serial_number]: '取引シリアル番号',
    [tokens.common.transaction_date_time]: '取引日時',
    [tokens.common.transaction_date]: '取引日付',
    [tokens.common.post_transaction_balance]: '取引後残高',
    [tokens.common.case_count]: '件',
    [tokens.common.case_processing]: '件ずつ処理',
    [tokens.common.delete_faq_prompt]: '件のよくある質問を削除するにはパスワードを入力してください',
    [tokens.common.search]: '検索',
    [tokens.common.no_search_results]: '検索結果なし',
    [tokens.common.search_results]: '検索結果です',
    [tokens.common.search_area]: '検索領域',
    [tokens.common.no_searched_history]: '検索された履歴がありません',
    [tokens.common.enter_search_term]: '検索語を入力してください',
    [tokens.common.required_payment_month]: '決済月は必須です',
    [tokens.common.required_payment_date]: '決済日は必須です',
    [tokens.common.monthly_payment]: '決済毎月 日',
    [tokens.common.payment_amount_1]: '決済金額',
    [tokens.common.payment_status]: '決済状態',
    [tokens.common.overdue_payment_only]: '決済状態 - 未納履歴のみ表示',
    [tokens.common.payment_based_on_month]: '決済月基準',
    [tokens.common.payment_date_adjustment]: '決済日調整',
    [tokens.common.payment_date]: '決済日',
    [tokens.common.warning]: '警告',
    [tokens.common.gyeongnam]: '慶南',
    [tokens.common.stopover]: '経由地',
    [tokens.common.contract]: '契約',
    [tokens.common.contract_date]: '契約日',
    [tokens.common.contract_status]: '契約状態',
    [tokens.common.contract_start_and_end_date]: '契約開始 / 終了日',
    [tokens.common.contract_start_date_required]: '契約開始日は必須です',
    [tokens.common.contract_information]: '契約情報',
    [tokens.common.contract_termination]: '契約終了',
    [tokens.common.contract_termination_password_required]: '契約終了処理を希望する場合はパスワードを入力してください',
    [tokens.common.contract_end_date]: '契約終了日',
    [tokens.common.contract_end_date_required]: '契約終了日は必須です',
    [tokens.common.contract_attached_documents]: '契約添付書類',
    [tokens.common.contract_type]: '契約形態',
    [tokens.common.contract_type_payment_date]: '契約形態 / 決済日',
    [tokens.common.contract_type_payment_date]: '契約形態/決済日',
    [tokens.common.contract_type_collateral_type]: '契約形態 / 担保タイプ',
    [tokens.common.contract_type_required]: '契約形態は必須です',
    [tokens.common.account_password]: 'アカウントパスワード',
    [tokens.common.account_password_required]: 'アカウントパスワードは入力必須です',
    [tokens.common.account_registration]: '口座登録',
    [tokens.common.account_cancellation]: '口座登録解約',
    [tokens.common.account_deletion]: '口座削除',
    [tokens.common.account_balance]: '口座残高',
    [tokens.common.account_issuance_date]: '口座発行日時',
    [tokens.common.account_number]: '口座番号',
    [tokens.common.account_number_required]: '口座番号は必須です',
    [tokens.common.account_status]: '口座状態',
    [tokens.common.customer_list_1]: '顧客リスト',
    [tokens.common.customer_consultation_details]: '顧客相談詳細',
    [tokens.common.customer_consultation_history]: '売上先相談履歴',
    [tokens.common.customer_notice_completed]: '顧客案内完了チェックは必須です',
    [tokens.common.fix_notice]: '固定通知として登録',
    [tokens.common.fixed_sale_price_input]: '固定販売価格入力',
    [tokens.common.fixed_price]: '固定価格',
    [tokens.common.fixed_price_recommendation]: '固定価(格推奨販売価格)',
    [tokens.common.fixed_price_required]: '固定価格は必須です',
    [tokens.common.supplier_information]: 'サプライヤー情報',
    [tokens.common.notification_registration]: '通知登録',
    [tokens.common.notification_termination]: '通知終了',
    [tokens.common.notice_contents]: '通知内容',
    [tokens.common.announcement_management]: 'お知らせ管理',
    [tokens.common.announcement_termination_password_required]: 'お知らせ表示を終了するにはパスワードを入力してください',
    [tokens.common.public_holiday_period]: '祝日期間',
    [tokens.common.public_holiday_date_selection_required]: '祝日の日付選択は必須です',
    [tokens.common.public_holiday_registration]: '祝日登録',
    [tokens.common.public_holiday_name]: '祝日名',
    [tokens.common.public_holiday_name_required]: '祝日名は必須です',
    [tokens.common.taxation_status]: '課税有無',
    [tokens.common.tax_inclusion]: '課税時付加価値税を含む',
    [tokens.common.exchange_return_screen]: '交換返品受付画面',
    [tokens.common.exchange_processing_new_order_required]: '交換処理時には新規注文を必ず登録してください',
    [tokens.common.purchase_manager]: '購買担当者',
    [tokens.common.purchase_manager_information]: '購買担当者情報',
    [tokens.common.purchase_manager_search]: '購買担当者検索',
    [tokens.common.search_select_purchase_manager]: '購入担当者を検索/選択してください',
    [tokens.common.purchase_profit_rate]: '購買利益率',
    [tokens.common.purchase_profit_rate_prompt]: '購買利益率入力',
    [tokens.common.purchase_profit_rate_change_reservation_completed]: '購買利益率変更予約が完了しました',
    [tokens.common.division]: '区分',
    [tokens.common.classification_code_required]: '区分コード選択は必須です',
    [tokens.common.zone]: '区域',
    [tokens.common.variable_assignment_with_destructuring]: '構造分解割当で変数設定',
    [tokens.common.select_nation]: '国を選択',
    [tokens.common.country_required]: '国は必須です',
    [tokens.common.citizens]: '国民',
    [tokens.common.recommended_price]: '推奨販売価格',
    [tokens.common.set_recommended_price]: '推奨販売価格設定',
    [tokens.common.recommended_selling_price]: '推奨販売価格',
    [tokens.common.recommended_selling_price_settings]: '推奨販売価格設定区分',
    [tokens.common.authority_group]: '権限グループ',
    [tokens.common.select_authority_group]: '権限グループ選択',
    [tokens.common.authority_group_required]: '権限グループは必須です',
    [tokens.common.permission_group]: '権限グループ',
    [tokens.common.attribution]: '帰責',
    [tokens.common.attribution_amount]: '帰責金額',
    [tokens.common.attribution_selection]: '帰責選択',
    [tokens.common.attribution_selection_required]: '帰責選択は必須です',
    [tokens.common.attributable_amount]: '帰責金額',
    [tokens.common.your_fault_required]: '帰責は選択必須です',
    [tokens.common.your_fault_mandatory]: '帰責は必須です',
    [tokens.common.select_fault]: '帰責を選択してください',
    [tokens.common.specifications]: '規格',
    [tokens.common.specifications_required]: '規格は必須です',
    [tokens.common.enter_specifications]: '規格入力',
    [tokens.common.regulation]: '規制',
    [tokens.common.set_regulation_period]: '規制期間設定',
    [tokens.common.future_date_only_for_regulation]: '規制期間は未来の日付でのみ登録可能です',
    [tokens.common.bulk_regulation]: '規制一括登録',
    [tokens.common.regulation_status]: '規制状態',
    [tokens.common.view_regulation_items_only]: '規制設定商品のみ表示',
    [tokens.common.regulation_timestamp]: '規制設定日時',
    [tokens.common.regulation_termination]: '規制終了',
    [tokens.common.irreversible_regulation_termination]: '規制終了処理時はデータ復元が不可能です',
    [tokens.common.regulation_period]: '規制期間',
    [tokens.common.regulation_start]: '規制開始',
    [tokens.common.regulation_scheduled]: '規制予定',
    [tokens.common.regulation_end]: '規制終了',
    [tokens.common.regulation_in_progress]: '規制中',
    [tokens.common.proceed_anyway]: 'それでも進行しますか',
    [tokens.common.proceed_with_process]: 'それでも処理しますか',
    [tokens.common.cancel_recovery]: 'それでも回収をキャンセルしますか',
    [tokens.common.gold]: '金',
    [tokens.common.amount]: '金額',
    [tokens.common.amount_change_history]: '金額変更履歴',
    [tokens.common.enter_amount]: '金額入力',
    [tokens.common.amount_required]: '金額入力は必須です',
    [tokens.common.period]: '期間',
    [tokens.common.period_regulation]: '期間規制',
    [tokens.common.register_period_regulation]: '期間規制登録',
    [tokens.common.period_inquiry]: '期間照会',
    [tokens.common.period_regulation_status]: '期間規制有無',
    [tokens.common.period_query]: '期間照会',
    [tokens.common.function]: '機能',
    [tokens.common.final]: '期末',
    [tokens.common.basic]: '基本',
    [tokens.common.basic_info]: '基本情報',
    [tokens.common.basic_profit_rate]: '基本販売利益率',
    [tokens.common.basic_rate_of_profit]: '基本利益率',
    [tokens.common.enter_driver_details]: 'ドライバーの名前と電話番号を入力してください',
    [tokens.common.existing_contract_restoration]: '既存契約情報が復元されます',
    [tokens.common.standard_recommended_price]: '基準推奨販売価格',
    [tokens.common.reference_date]: '基準日',
    [tokens.common.reference_date_price]: '基準日販売価格',
    [tokens.common.foundation]: '基礎',
    [tokens.common.emergency_dispatch_driver_registration]: '緊急配車ドライバー登録',
    [tokens.common.emergency_dispatch_driver_registration_complete]: '緊急配車ドライバー登録が完了しました',
    [tokens.common.emergency_shipment]: '緊急出荷',
    [tokens.common.emergency_shipment_detail]: '緊急出荷詳細',
    [tokens.common.emergency_shipment_request_complete]: '緊急出荷申請が完了しました',
    [tokens.common.emergency_shipment_complete]: '貨物出荷が完了しました',
    [tokens.common.no_emergency_shipment_requests]: '緊急出荷申請履歴がありません',
    [tokens.common.cancel_emergency_shipment_request]: '緊急出荷申請キャンセル',
    [tokens.common.emergency_shipment_history]: '緊急出荷履歴',
    [tokens.common.emergency_shipment_registration]: '緊急出荷受付',
    [tokens.common.emergency_shipment_processing]: '緊急出荷処理',
    [tokens.common.emergency_shipment_issue_processing]: '緊急出荷処理イシュープロセス',
    [tokens.common.emergency_dispatch]: '緊急配車',
    [tokens.common.emergency_dispatch_driver]: '緊急配車ドライバー',
    [tokens.common.emergency_dispatch_driver_contact]: '緊急配車ドライバー連絡先',
    [tokens.common.no_emergency_dispatch_records]: '緊急配車履歴がありません',
    [tokens.common.emergency_dispatch_registration]: '緊急配車登録',
    [tokens.common.emergency_dispatch_route]: '緊急配車ルート',
    [tokens.common.emergency_dispatch_list]: '緊急配車リスト',
    [tokens.common.emergency_dispatch_cost]: '緊急配車費用',
    [tokens.common.emergency_dispatch_status]: '緊急配車有無',
    [tokens.common.urgent_delivery]: '緊急出庫',
    [tokens.common.urgent_delivery_1]: '緊急出庫',
    [tokens.common.no_urgent_delivery_records]: '緊急出庫履歴がありません',
    [tokens.common.urgent_delivery_shipment_label]: '緊急出庫配送ラベル',
    [tokens.common.urgent_delivery_cost]: '緊急出庫費用',
    [tokens.common.urgent_delivery_detail]: '緊急出庫詳細',
    [tokens.common.urgent_delivery_item_count]: '緊急出庫商品数',
    [tokens.common.no_urgent_delivery_history]: '緊急出庫履歴がありません',
    [tokens.common.emergency_delivery_cost_required]: '緊急出庫時の配送費用は入力必須です',
    [tokens.common.emergency_delivery_contact_required]: '緊急出庫時の配送ドライバーの電話番号は入力必須です',
    [tokens.common.urgent_delivery_date]: '緊急出庫日',
    [tokens.common.view_my_claim_history]: '私の担当クレーム履歴のみ表示',
    [tokens.common.view_my_urgent_shipment_history]: '私の緊急出庫履歴のみ表示',
    [tokens.common.view_my_pending_cases]: '私の処理中履歴のみ表示',
    [tokens.common.date_1]: '日付',
    [tokens.common.date_selection_start_end]: '日付選択(開始->終了)',
    [tokens.common.payment_deadline_extension]: '納付期限延長',
    [tokens.common.payment_deadline_extension_notice]: '納付期限延長時には、延長終了日まで未納処理が猶予されます',
    [tokens.common.payment_deadline_extension_end_date]: '納付期限延長終了日',
    [tokens.common.payment_extension]: '納付延長',
    [tokens.common.payment_amount_2]: '納付金額',
    [tokens.common.payment_due_date]: '納付期限',
    [tokens.common.payment_due_date_required]: '納付期限延長終了日は必須です',
    [tokens.common.payment_extension_completed]: '納付期限延長が完了しました',
    [tokens.common.my_notifications_only]: '自分が登録した通知のみ表示',
    [tokens.common.history_quantity_and_amount]: '履歴数量金額',
    [tokens.common.content]: '内容',
    [tokens.common.no_content]: '内容なし',
    [tokens.common.content_max_length]: '内容は2000何文字以内です',
    [tokens.common.content_max_length_prompt]: '内容は何文字以内で入力してください',
    [tokens.common.content_required]: '内容は必須です',
    [tokens.common.tomorrow]: '明日',
    [tokens.common.frozen]: '冷凍',
    [tokens.common.refrigerated]: '冷蔵',
    [tokens.common.year_month]: '年 月',
    [tokens.common.annual_disposal_rate]: '年間廃棄率',
    [tokens.common.exposure]: '露出',
    [tokens.common.exposure_change]: '露出変更',
    [tokens.common.exposure_period]: '露出期間',
    [tokens.common.exposure_change_completed]: '露出変更が完了しました',
    [tokens.common.exposure_status_change]: '露出状態変更',
    [tokens.common.cumulative_arrears]: '累積未納金額',
    [tokens.common.double_check_file]: '再度ファイルをご確認ください',
    [tokens.common.double_check_and_proceed]: '再度確認してから処理を行ってください',
    [tokens.common.file_name_to_download]: 'ダウンロードされるファイル名',
    [tokens.common.unit_price]: '単価',
    [tokens.common.unit_price_order_information]: '単価・発注情報',
    [tokens.common.no_unit_price_change_history]: '単価変更履歴がありません',
    [tokens.common.unit_price_change_date_time]: '単価変更日時',
    [tokens.common.unit_price_change_info]: '単価変更情報',
    [tokens.common.unit_price_information]: '単価情報',
    [tokens.common.unit_price_adjustment_history]: '単価調整履歴照会',
    [tokens.common.unit_price_history]: '単価履歴',
    [tokens.common.unit_price_application_date_selection]: '単価適用日選択',
    [tokens.common.unit]: '単位',
    [tokens.common.unit_specifications]: '単位規格',
    [tokens.common.close]: '閉じる',
    [tokens.common.chicken_breast]: '鶏胸肉ハリム',
    [tokens.common.person_in_charge]: '担当者',
    [tokens.common.person_in_charge_selection]: '担当者選択',
    [tokens.common.person_in_charge_contact]: '担当者連絡先',
    [tokens.common.person_in_charge_contact_required]: '担当者連絡先は必須です',
    [tokens.common.person_in_charge_contact_prompt]: '担当者連絡先は必須です',
    [tokens.common.person_in_charge_contact_max_length_prompt]: '担当者連絡先は何文字以内で入力してください',
    [tokens.common.person_in_charge_email]: '担当者メールアドレス',
    [tokens.common.person_in_charge_email_required]: '担当者メールアドレスは必須です',
    [tokens.common.person_in_charge_email_required_2]: 'メール形式が正しくありません',
    [tokens.common.save_person_in_charge_info]: '担当者を保存したい場合は、名前、連絡先、メールアドレスをすべて入力してください',
    [tokens.common.person_in_charge_information]: '担当者情報',
    [tokens.common.enter_person_in_charge_info]: '担当者情報を入力してください',
    [tokens.common.name_of_person_in_charge_required]: '担当者名は20何文字以内で入力してください',
    [tokens.common.name_of_person_in_charge_required_short]: '担当者名は必須です',
    [tokens.common.collateral_start_end_date]: '担保開始/終了日',
    [tokens.common.collateral_start_date_required]: '担保開始日は必須です',
    [tokens.common.collateral_amount_required]: '担保設定金額は必須です',
    [tokens.common.collateral_type_amount]: '担保タイプ / 設定金額',
    [tokens.common.collateral_type_amount]: '担保タイプ/設定金額',
    [tokens.common.collateral_end_date_required]: '担保終了日は必須です',
    [tokens.common.collateral_commencement]: '担保開始',
    [tokens.common.collateral_status]: '担保状態',
    [tokens.common.collateral_type]: '担保タイプ',
    [tokens.common.collateral_credit_limit]: '担保タイプ / 信用限度',
    [tokens.common.collateral_type_required]: '担保タイプは必須です',
    [tokens.common.collateral_termination]: '担保終了',
    [tokens.common.answer]: '回答',
    [tokens.common.answer_required]: '回答は必須です',
    [tokens.common.this_month_inbound]: '今月の入庫',
    [tokens.common.this_month_outbound]: '今月の出庫',
    [tokens.common.delivery_status_today]: '当日配送状況',
    [tokens.common.daegu_branch]: '大邱部',
    [tokens.common.standby]: '待機',
    [tokens.common.large_company_usage]: '大企業使用有無',
    [tokens.common.large_company_integration_needed]: '大企業連動必要有無',
    [tokens.common.large_company_code_entry]: '大企業コード入力',
    [tokens.common.corporate_code_and_large_company_required]: '大企業と大企業コードは必須です',
    [tokens.common.large_company_sales_code]: '大企業売上先コード',
    [tokens.common.large_company_usage_status]: '大企業使用状況',
    [tokens.common.large_company_product_code]: '大企業商品コード',
    [tokens.common.large_company_product_code_required]: '大企業商品コードは必須です',
    [tokens.common.large_company_integration_needed_status]: '大企業連動必要状況',
    [tokens.common.duplicate_large_company]: '大企業は重複できません',
    [tokens.common.large_company_code]: '大企業コード',
    [tokens.common.duplicate_corporate_code]: '大企業コードは重複できません',
    [tokens.common.corporate_code_required]: '大企業コードは必須です',
    [tokens.common.bulk_upload]: '一括アップロード',
    [tokens.common.bulk_registration]: '一括登録',
    [tokens.common.uppercase_only]: '大文字のみ入力可能です',
    [tokens.common.major_category]: '大分類',
    [tokens.common.major_category_selection]: '大分類選択',
    [tokens.common.major_category_middle_category]: '大分類 - 中分類',
    [tokens.common.major_category_required]: '大分類カテゴリーは必須です',
    [tokens.common.major_category_required_short]: '大分類は必須です',
    [tokens.common.representative_email]: '代表メール',
    [tokens.common.representative_email_address_1]: '代表メールアドレス',
    [tokens.common.representative_email_required_1]: '代表メールは必須です',
    [tokens.common.representative_email_required_2]: '代表メール形式が正しくありません',
    [tokens.common.representative_email_format_invalid]: '代表メールは必須です メール形式が正しくありません',
    [tokens.common.representative_email_address_2]: '代表メールアドレス',
    [tokens.common.representative]: '代表者',
    [tokens.common.representative_contact]: '代表者連絡先',
    [tokens.common.representative_contact_required_2]: '代表者連絡先は必須です',
    [tokens.common.representative_contact_prompt]: '代表者連絡先は何文字以内で入力してください',
    [tokens.common.representative_name]: '代表者名',
    [tokens.common.representative_name_contact]: '代表者名 / 連絡先',
    [tokens.common.representative_name_required]: '代表者名は必須です',
    [tokens.common.representative_name_prompt]: '代表者名は何文字以内で入力してください',
    [tokens.common.representative_email_required]: '代表者メールは必須です',
    [tokens.common.same_as_representative_info]: '代表者情報と同じ',
    [tokens.common.representative_full_name]: '代表者氏名',
    [tokens.common.representative_contact_info]: '代表者連絡先情報',
    [tokens.common.representative_name_short]: '代表者名',
    [tokens.common.see_more]: 'もっと見る',
    [tokens.common.data_too_large_for_excel_download]: 'データが多すぎてExcelのダウンロードができません',
    [tokens.common.data_invalid]: 'データが有効ではありません',
    [tokens.common.door_lock]: 'ドアロック',
    [tokens.common.arrival_location_code]: '到着ロケーションコード',
    [tokens.common.arrival_center]: '到着センター',
    [tokens.common.destination]: '到着地',
    [tokens.common.destination_contact_name_prompt]: '到着地担当者名は50何文字以内で入力してください',
    [tokens.common.destination_contact_name_max_length]: '到着地担当者名は最大2何文字まで入力してください',
    [tokens.common.destination_contact_name_required]: '到着地担当者名は必須です',
    [tokens.common.destination_center_required]: '到着地センターを必ず選択してください',
    [tokens.common.destination_contact_required]: '到着地連絡先は必須です',
    [tokens.common.destination_information]: '到着地情報',
    [tokens.common.destination_address]: '到着地住所',
    [tokens.common.destination_center]: '到着地センター',
    [tokens.common.dock_number]: 'ドック番号',
    [tokens.common.dongicheon]: '東利川',
    [tokens.common.same_purchase_vendor_settlement]: '同じ仕入先の仕入れ内容のみで精算書を作成できます。確認して再選択してください',
    [tokens.common.same_sales_vendor_assigned]: '同じ売上先({{salesPlace}})が割り当てられています',
    [tokens.common.same_brand_sales_only]: '同じブランド内の接続売上先に限り可能です',
    [tokens.common.cannot_select_same_time]: '同じ時間を選択できません。再選択してください',
    [tokens.common.registration]: '登録',
    [tokens.common.registration_completed]: '登録が完了しました',
    [tokens.common.registered_product]: '登録商品',
    [tokens.common.registered_product_order_history_excel_download]: '登録商品注文履歴Excelダウンロード',
    [tokens.common.registration_edit]: '登録/修正',
    [tokens.common.registration_confirmation_needed]: '登録後必ず確認',
    [tokens.common.no_registered_corporation]: '登録された取引法人がありません',
    [tokens.common.no_registered_notifications]: '登録された通知事項がありません',
    [tokens.common.no_registered_locations]: '登録されたロケーションがありません',
    [tokens.common.no_registered_managers]: '登録されたマネージャーがありません',
    [tokens.common.no_registered_sales_clients]: '登録された売上先がありません',
    [tokens.common.no_registered_brands]: '登録された取引先がありません',
    [tokens.common.no_registered_consultation_history]: '登録された相談履歴がありません',
    [tokens.common.no_registered_product_regulations]: '登録された商品規制が存在しません',
    [tokens.common.no_registered_products]: '登録された商品がありません',
    [tokens.common.no_registered_faqs]: '登録されたよくある質問がありません',
    [tokens.common.no_registered_inventory_history]: '登録された在庫履歴がありません',
    [tokens.common.no_registered_inventory_adjustment_history]: '登録された在庫調整履歴がありません',
    [tokens.common.no_registered_inventory_items]: '登録された在庫項目がありません',
    [tokens.common.no_registered_inventory_audit_history]: '登録された在庫監査履歴がありません',
    [tokens.common.no_registered_inventory_audit_items]: '登録された在庫監査項目がありません',
    [tokens.common.registration_date]: '登録日',
    [tokens.common.registration_timestamp]: '登録日時',
    [tokens.common.registrant]: '登録者',
    [tokens.common.careful_before_registration]: '登録前に慎重に検討してから登録してください',
    [tokens.common.label]: 'ラベル',
    [tokens.common.label_generation]: 'ラベル生成',
    [tokens.common.no_label_generation_or_quantity_invalid]: 'ラベル生成対象がないか、ラベル数量が不正です',
    [tokens.common.label_quantity]: 'ラベル数量',
    [tokens.common.label_quantity_count]: 'ラベル数量 個',
    [tokens.common.label_reprint]: 'ラベル再出力',
    [tokens.common.label_printing]: 'ラベル出力',
    [tokens.common.print_label]: 'ラベルを出力しますか？',
    [tokens.common.label_print_button]: '[PLTラベル出力]ボタンでラベル生成作業を行ってください',
    [tokens.common.label_code]: 'ラベルコード',
    [tokens.common.number_of_labels]: 'ラベル数',
    [tokens.common.route]: 'ルート',
    [tokens.common.route_management]: 'ルート管理',
    [tokens.common.route_list]: 'ルートリスト',
    [tokens.common.route_assignment]: 'ルート割り当て',
    [tokens.common.route_assignment_completed]: 'ルート割り当てが完了しました',
    [tokens.common.route_deletion]: 'ルート削除',
    [tokens.common.route_details]: 'ルート詳細',
    [tokens.common.route_selection]: 'ルート選択',
    [tokens.common.route_addition]: 'ルート追加',
    [tokens.common.no_route]: 'ルートがありません',
    [tokens.common.route_deletion_confirmation]: 'ルートを削除しますか',
    [tokens.common.route_name]: 'ルート名',
    [tokens.common.route_name_entry]: 'ルート名を入力して保存してください',
    [tokens.common.route_name_required]: 'ルート名を入力してください',
    [tokens.common.route_assignment_short]: 'ルート割り当て',
    [tokens.common.lag]: 'ラグ',
    [tokens.common.log_out]: 'ログアウト',
    [tokens.common.log_out_button]: 'ログアウトする場合はこのボタンを押してください',
    [tokens.common.location_management]: 'ロケーション管理',
    [tokens.common.location_classification]: 'ロケーション区分',
    [tokens.common.location_zone]: 'ロケーション区域',
    [tokens.common.location_label_printing]: 'ロケーションラベル出力',
    [tokens.common.location_label_reprinting]: 'ロケーションラベル再出力',
    [tokens.common.location_label_printing_short]: 'ロケーションラベル出力',
    [tokens.common.location_list]: 'ロケーションリスト',
    [tokens.common.location_alias]: 'ロケーション名',
    [tokens.common.location_barcode_scan]: 'ロケーションのバーコードをスキャンしてロケーション情報を登録してください',
    [tokens.common.location_details]: 'ロケーション詳細',
    [tokens.common.location_option]: 'ロケーションオプション',
    [tokens.common.location_position]: 'ロケーション位置',
    [tokens.common.location_auto_sort]: 'ロケーション位置順に自動ソートされます',
    [tokens.common.location_name]: 'ロケーション名',
    [tokens.common.location_name_input]: 'ロケーション名入力',
    [tokens.common.location_name_prompt]: 'ロケーション名を入力してください',
    [tokens.common.location_add]: 'ロケーション追加',
    [tokens.common.location_code]: 'ロケーションコード',
    [tokens.common.location_code_product_name]: 'ロケーションコード商品名',
    [tokens.common.location_label_code]: 'ロケーションラベルコード',
    [tokens.common.location_label_location_code]: 'ロケーションラベルコード ロケーションコード',
    [tokens.common.location_status]: 'ロケーション状態',
    [tokens.common.location_disposal_qty]: 'ロケーションの廃棄予定数量のみ表示',
    [tokens.common.location_address]: 'ロケーション住所',
    [tokens.common.create_prompt]: 'を生成してください',
    [tokens.common.select_prompt]: 'を選択してください',
    [tokens.common.exclude_shipment_processed]: 'を除く出庫を正常に処理しました',
    [tokens.common.lead_time]: 'リードタイム',
    [tokens.common.lead_time_prevention]: 'リードタイムが超過している場合は当日入庫を防止するため',
    [tokens.common.lead_time_required]: 'リードタイムは必須です',
    [tokens.common.input_only]: 'のみ入力',
    [tokens.common.word]: '単語',
    [tokens.common.end_of_month]: '月末',
    [tokens.common.tax_and_non_tax]: '免/課税',
    [tokens.common.tax]: '課税',
    [tokens.common.non_tax]: '免税',
    [tokens.common.manager]: 'マネージャー',
    [tokens.common.manager_search]: 'マネージャー検索',
    [tokens.common.manager_management]: 'マネージャー管理',
    [tokens.common.manager_registration]: 'マネージャー登録',
    [tokens.common.manager_detail]: 'マネージャー詳細',
    [tokens.common.manager_selection]: 'マネージャー選択',
    [tokens.common.manager_update]: 'マネージャー修正',
    [tokens.common.manager_name]: 'マネージャー名',
    [tokens.common.manager_name_contact]: 'マネージャー名 / 連絡先',
    [tokens.common.manager_name_below_limit]: 'マネージャー名は50何文字以内で入力してください',
    [tokens.common.manager_name_above_limit]: 'マネージャー名は最大2何文字まで入力してください',
    [tokens.common.manager_name_required]: 'マネージャー名は必須です',
    [tokens.common.manager_phone]: 'マネージャー, 電話番号',
    [tokens.common.manager_info]: 'マネージャー情報',
    [tokens.common.manager_management_overview]: 'マネージャー管理',
    [tokens.common.search_select_manager]: 'マネージャーを検索/選択してください',
    [tokens.common.register_manager_prompt]: 'マネージャーを登録してください',
    [tokens.common.select_manager_prompt]: 'マネージャーを選択してください',
    [tokens.common.select_manager_required]: 'マネージャーは必須です',
    [tokens.common.manager_name_label]: 'マネージャー名',
    [tokens.common.manager_name_alternate]: 'マネージャー名前',
    [tokens.common.manager_save]: 'マネージャー保存',
    [tokens.common.manager_info_overview]: 'マネージャー情報',
    [tokens.common.every_month]: '毎月',
    [tokens.common.settlement_start_date]: '毎月の精算が始まる基準日',
    [tokens.common.purchase_period]: '仕入期間',
    [tokens.common.purchase_details]: '仕入内容',
    [tokens.common.purchase_count]: '仕入内容数',
    [tokens.common.purchase_positive_details]: '仕入プラス内容',
    [tokens.common.no_purchase_positive_details]: '仕入プラス内容が存在しません',
    [tokens.common.purchase_settlement]: '仕入精算',
    [tokens.common.purchase_invoice_resend_complete]: '仕入精算書の再送信が完了しました',
    [tokens.common.purchase_invoice_delete]: '仕入精算書削除',
    [tokens.common.purchase_invoice_delete_complete]: '仕入精算書削除が完了しました',
    [tokens.common.purchase_invoice_edit_complete]: '仕入精算書修正が完了しました',
    [tokens.common.purchase_invoice_confirm_all]: '仕入精算書一括確定',
    [tokens.common.purchase_invoice_confirm]: '仕入精算書確認',
    [tokens.common.purchase_invoice_finalize]: '仕入精算書確定',
    [tokens.common.purchase_invoice_finalize_complete]: '仕入精算書の確定が完了しました',
    [tokens.common.total_purchase_amount]: '仕入後の総額',
    [tokens.common.purchase_price]: '販売価格',
    [tokens.common.purchase_price_taxable]: '販売価格 / 課税有無',
    [tokens.common.purchase_price_change]: '販売価格変更',
    [tokens.common.bulk_purchase_price_change]: '販売価格変更の一括登録は一度に最大 {{totalBulkPurchasePriceChange}}件まで可能です',
    [tokens.common.purchase_price_change_warning]:
        '販売価格の変更は、在庫台帳の精算などデータエラーに影響を与える可能性があるため、必要な場合に限り再度確認して処理してください',
    [tokens.common.purchase_price_reservation]: '販売価格変更予約',
    [tokens.common.purchase_price_reservation_details]: '販売価格変更予約履歴',
    [tokens.common.no_purchase_price_reservation_details]: '販売価格変更予約履歴がありません',
    [tokens.common.bulk_purchase_price_reservation]: '販売価格変更予約の一括登録',
    [tokens.common.purchase_price_reservation_complete]: '販売価格変更予約が完了しました',
    [tokens.common.purchase_price_registration]: '販売価格予約登録',
    [tokens.common.bulk_purchase_price_change_file]: '販売価格一括変更予約 Excel ファイル',
    [tokens.common.bulk_purchase_price_edit]: '販売価格一括修正',
    [tokens.common.bulk_purchase_price_reservation_complete]: '販売価格一括予約登録が完了しました',
    [tokens.common.bulk_purchase_price_adjustment]: '販売価格一括調整',
    [tokens.common.purchase_price_input]: '販売価格入力',
    [tokens.common.purchase_price_required]: '販売価格は必須です',
    [tokens.common.purchase_price_can_not_minus]: '販売価格は負数にできません',
    [tokens.common.purchase_cost]: '仕入原価',
    [tokens.common.purchase_settlement_details]: '仕入精算履歴が存在しません',
    [tokens.common.empty_page_purchase_history]: '仕入れ履歴が存在しません',
    [tokens.common.purchaser]: '仕入先',
    [tokens.common.purchaser_id]: '仕入先 ID',
    [tokens.common.purchaser_search]: '仕入先検索',
    [tokens.common.purchaser_holiday_registration]: '仕入先の休日登録',
    [tokens.common.purchaser_management]: '仕入先管理',
    [tokens.common.purchaser_buyer]: '仕入先の / 購買担当者',
    [tokens.common.purchaser_liability_amount]: '仕入先の帰責金額',
    [tokens.common.purchaser_liability_amount_currency]: '仕入先の帰責金額（円）',
    [tokens.common.purchaser_liability_return]: '仕入先の責任による場合、帰責金額で返品履歴が生成されます',
    [tokens.common.purchaser_same_standard]: '仕入先基準同一',
    [tokens.common.purchaser_contact]: '仕入先担当者',
    [tokens.common.purchaser_contact_info]: '仕入先担当者情報',
    [tokens.common.purchaser_contact_info_1]: '仕入先担当者1)情報',
    [tokens.common.purchaser_contact_info_2]: '仕入先担当者2)情報',
    [tokens.common.purchaser_registration]: '仕入先登録',
    [tokens.common.purchaser_deadline_adjustment]: '仕入先締切時間一括調整',
    [tokens.common.no_purchaser_list]: '仕入先リストが存在しません',
    [tokens.common.purchaser_selection]: '仕入先選択',
    [tokens.common.purchaser_edit]: '仕入先修正',
    [tokens.common.purchaser_incoming_schedule]: '仕入先入庫予定書',
    [tokens.common.purchaser_info]: '仕入先情報',
    [tokens.common.purchaser_holiday_registration_complete]: '仕入先の休日登録が完了しました',
    [tokens.common.purchaser_holiday_deletion_complete]: '仕入先の休日削除が完了しました',
    [tokens.common.purchaser_holiday_info]: '仕入先の休日情報',
    [tokens.common.purchaser_required]: '仕入先は必須です',
    [tokens.common.purchaser_manager]: '仕入先担当者',
    [tokens.common.search_select_purchaser]: '仕入先を検索して選択してください',
    [tokens.common.purchaser_visibility_toggle]: '{{purchaserForExposureOrNo}}件の仕入先を本当に{{exposureOrNo}}に切り替えますか？',
    [tokens.common.purchaser_name]: '仕入先名',
    [tokens.common.purchaser_name_required]: '仕入先名は必須です',
    [tokens.common.purchaser_name_duplicate]: '仕入先名が重複しています',
    [tokens.common.no_items_registered_in_purchaser]: '仕入先に登録された商品がありません',
    [tokens.common.purchaser_direct_delivery]: '仕入先から各店舗への直送',
    [tokens.common.purchaser_info_overview]: '仕入先情報',
    [tokens.common.sales_reflection]: '売上反映',
    [tokens.common.no_sales_report]: '売上申告履歴が存在しません',
    [tokens.common.sales_report_pending]: '売上申告待機履歴',
    [tokens.common.sales_transfer]: '売上移管',
    [tokens.common.sales_invoice]: '売上精算書',
    [tokens.common.sales_invoice_updated]: '売上精算書の更新が完了しました',
    [tokens.common.sales_invoice_resend_complete]: '売上精算書のメール再送信が完了しました',
    [tokens.common.sales_invoice_deleted]: '売上精算書削除',
    [tokens.common.sales_invoice_delete_complete]: '売上精算書の削除が完了しました',
    [tokens.common.sales_invoice_confirm_all]: '売上精算書一括確定',
    [tokens.common.sales_invoice_finalize]: '売上精算書確定',
    [tokens.common.sales_invoice_finalize_complete]: '売上精算書の確定が完了しました',
    [tokens.common.sales_price_reservation]: '売上価格一括変更•予約',
    [tokens.common.sales_price_edit_excel_file]: '売上価格一括修正 - Excel ファイル',
    [tokens.common.unit_sales_price_management]: '売上単価管理',
    [tokens.common.unit_sales_price_reservation]: '売上単価変更予約登録は一度に最大 {{maxUnitSalesPriceReservation}}件まで可能です',
    [tokens.common.unit_sales_price_bulk_change]: '売上単価一括変更',
    [tokens.common.unit_sales_price_bulk_complete]: '売上単価一括変更登録が完了しました',
    [tokens.common.unit_sales_price_query]: '売上単価照会',
    [tokens.common.reflection_of_sales]: '売上反映',
    [tokens.common.sales_transfer_order_selection]: '売上移管対象の注文を一つ以上選択してください',
    [tokens.common.sales_transfer_irreversible]: '売上移管が完了すると元に戻すことはできません。再度確認して処理してください。',
    [tokens.common.sales_profit_margin_1]: '売上利益率',
    [tokens.common.sales_settlement_details]: '売上精算履歴が存在しません',
    [tokens.common.customer]: '売上先',
    [tokens.common.customer_id]: '売上先 ID',
    [tokens.common.customer_search]: '売上先検索',
    [tokens.common.customer_management]: '売上先管理',
    [tokens.common.customer_purchasing_agent]: '売上先の購買担当者',
    [tokens.common.customer_classification_brand]: '売上先分類 / ブランド',
    [tokens.common.customer_classification_type]: '売上先区分 / 業態 / 業種',
    [tokens.common.customer_classification_required]: '売上先分類は必須です',
    [tokens.common.customer_driver_contact]: '売上先のドライバー連絡先 ドライバー名 配送ルート',
    [tokens.common.customer_contact]: '売上先担当者連絡先',
    [tokens.common.customer_contact_name]: '売上先担当者名',
    [tokens.common.customer_contact_email]: '売上先担当者メールアドレス',
    [tokens.common.customer_contact_info]: '売上先担当者情報',
    [tokens.common.customer_contact_info_1]: '売上先担当者1)情報',
    [tokens.common.customer_contact_info_2]: '売上先担当者2)情報',
    [tokens.common.customer_bulk_registration_limit]: '売上先一括登録は一度に最大 {{customerBulkRegistrationLimit}}件まで可能です',
    [tokens.common.customer_bulk_registration_complete]: '売上先一括登録が完了しました',
    [tokens.common.customer_registration]: '売上先登録',
    [tokens.common.customer_bulk_registration]: '売上先一括登録',
    [tokens.common.customer_route_management]: '売上先ルート追加/削除は12時～19時の間のみ可能です',
    [tokens.common.customer_list_2]: '売上先リスト',
    [tokens.common.customer_virtual_account]: '売上先のバーチャル口座番号',
    [tokens.common.customer_return_exchange_code]: '売上先の返品/交換コード詳細内容',
    [tokens.common.customer_business_id]: '売上先の事業者番号',
    [tokens.common.customer_representative]: '売上先の事業者番号代表者',
    [tokens.common.customer_consultation_notes]: '売上先の相談内容',
    [tokens.common.customer_details]: '売上先の詳細内容',
    [tokens.common.customer_address]: '売上先の住所',
    [tokens.common.customer_delivery_date]: '売上先配送日',
    [tokens.common.customer_brand]: '売上先ブランド',
    [tokens.common.customer_selection]: '売上先選択',
    [tokens.common.customer_edit_registration]: '売上先修正売上先登録',
    [tokens.common.customer_avg_monthly_order]: '売上先の月平均総注文金額',
    [tokens.common.customer_info]: '売上先情報',
    [tokens.common.customer_info_bulk_adjustment]: '売上先情報一括調整',
    [tokens.common.customer_info_excel_file]: '売上先情報 Excel ファイル',
    [tokens.common.customer_settlement]: '売上先精算',
    [tokens.common.customer_total_refund]: '売上先総返金額',
    [tokens.common.customer_addition]: '売上先追加',
    [tokens.common.customer_refund_amount]: '売上先返金額',
    [tokens.common.customer_classification]: '売上先分類',
    [tokens.common.search_select_customer]: '売上先を検索し/て選択してください',
    [tokens.common.customer_selection_required]: '売上先を選択してください',
    [tokens.common.customer_selection_prompt]: '売上先を選択してください',
    [tokens.common.customer_add_prompt]: '売上先を追加してください',
    [tokens.common.customer_name]: '売上先名',
    [tokens.common.customer_name_entry_limit]: '売上先名は50何文字以内で入力してください',
    [tokens.common.customer_name_required]: '売上先名は必須です',
    [tokens.common.customer_name_duplicate]: '売上先名が重複しています',
    [tokens.common.number_of_sales_outlets]: '売上先数',
    [tokens.common.customer_preorder_cancellation]: '売上先で事前に注文した内容はキャンセルできません',
    [tokens.common.customer_order_handling]: '売上先で商品注文時',
    [tokens.common.customer_inbound_routing]: '売上先の出庫センターごとに指定された入庫センターに商品が入庫されます',
    [tokens.common.menu_delete]: 'メニュー削除',
    [tokens.common.menu_delete_success]: 'メニュー削除に成功しました',
    [tokens.common.menu_create_success]: 'メニュー生成に成功しました',
    [tokens.common.memo]: 'メモ',
    [tokens.common.message_required]: 'メッセージ内容は必須です',
    [tokens.common.message_input_prompt]: 'メッセージ内容を入力してください',
    [tokens.common.document]: '文書',
    [tokens.common.delete_success]: '削除に成功しました',
    [tokens.common.logistic_code]: '物流コード',
    [tokens.common.select_checkbox_list]: 'リストのチェックボックスを選択',
    [tokens.common.non_payment]: '未納',
    [tokens.common.non_payment_price]: '未納 {{nonPaymentPrice}} 円',
    [tokens.common.return_history]: '返品履歴',
    [tokens.common.return_type]: '返品タイプ',
    [tokens.common.return_code]: '返品コード',
    [tokens.common.return_quantity]: '返品数量',
    [tokens.common.return_reason]: '返品理由',
    [tokens.common.empty_page_return_history]: '返品履歴が存在しません',
    [tokens.common.report_return_quantity]: '返回量',
    [tokens.common.occurrence_date]: '発生日',
    [tokens.common.purchase.order]: '発注',
    [tokens.common.purchase.order_possible_days]: '発注可能曜日',
    [tokens.common.purchase.order_holidays_registration]: '発注可能曜日以外の別途休日を登録します',
    [tokens.common.purchase.order_classification]: '発注区分',
    [tokens.common.purchase.order_classification_required]: '発注区分は必須です',
    [tokens.common.purchase.order_amount]: '発注金額',
    [tokens.common.purchase.order_details]: '発注内容',
    [tokens.common.purchase.order_details_not_available]: '発注内容がありません',
    [tokens.common.purchase.order_unit]: '発注単位',
    [tokens.common.purchase.order_request_sent_to_supplier]: '発注登録時に該当商品の仕入先へ発注依頼書が送信されます',
    [tokens.common.purchase.order_lead_time]: '発注リードタイム',
    [tokens.common.purchase.order_deadline_time]: '発注締切時間',
    [tokens.common.purchase.order_expired_warning]: '発注締切時間を過ぎた商品が含まれています。発注商品を再度確認してください。',
    [tokens.common.purchase.order_multiple_units]: '発注倍数',
    [tokens.common.purchase.order_products]: '発注商品',
    [tokens.common.purchase.order_product_classification]: '発注商品区分',
    [tokens.common.purchase.order_inactive_product_warning]: '発注商品の中に未使用の商品が含まれています。発注を続行しますか？',
    [tokens.common.purchase.order_quantity_input]: '発注数量入力',
    [tokens.common.purchase.order_request_information]: '発注依頼情報',
    [tokens.common.purchase.order_request_form_details]: '発注依頼書詳細',
    [tokens.common.purchase.order_request_form_edit]: '発注依頼書修正',
    [tokens.common.purchase.order_request_form_edit_to_supplier]: '発注依頼書修正時に該当商品の仕入先へ',
    [tokens.common.purchase.order_request_form_updated]: '発注依頼書が修正されました',
    [tokens.common.purchase.order_request_form_selection]: '発注依頼書を選択してください',
    [tokens.common.purchase.order_request_date]: '発注依頼日',
    [tokens.common.purchase.order_warehouse_receipt_settings]: '発注/入庫設定',
    [tokens.common.purchase.order_warehouse_receipt_check_required]: '発注/入庫設定は1つ以上チェックする必要があります',
    [tokens.common.purchase.order_warehouse_receipt_time_required]: '発注/入庫センター設定時に商品入庫センター/入庫予定時間は必須です',
    [tokens.common.purchase.order_receipt_quantity]: '発注入庫時の受領数量',
    [tokens.common.purchase.order_receipt_information]: '発注入庫情報',
    [tokens.common.purchase.order_information]: '発注情報',
    [tokens.common.purchase.order_view_permission]: '発注照会許可',
    [tokens.common.purchase.order_cancellation_1]: '発注キャンセル',
    [tokens.common.purchase.order_cancellation_include_history]: '発注キャンセル履歴を含む',
    [tokens.common.purchase.order_notes]: '発注特記事項',
    [tokens.common.purchase.order_available]: '発注可能商品区分',
    [tokens.common.purchase.order_available_days_select]: '発注可能曜日選択',
    [tokens.common.purchase.order_available_days_required]: '発注可能曜日は必須です',
    [tokens.common.purchase.ordering_category]: '発注区分',
    [tokens.common.purchase.ordering_calendar]: '発注カレンダー',
    [tokens.common.purchase.deadline_for_ordering_weekend_minutes_required]: '発注締切(週末) -分は必須です',
    [tokens.common.purchase.deadline_for_ordering_weekend_hours_required]: '発注締切(週末) -時間は必須です',
    [tokens.common.purchase.deadline_for_ordering_weekday_minutes_required]: '発注締切(平日) -分は必須です',
    [tokens.common.purchase.deadline_for_ordering_weekday_hours_required]: '発注締切(平日) -時間は必須です',
    [tokens.common.purchase.order_multiple]: '発注倍数',
    [tokens.common.purchase.order_status]: '発注状態',
    [tokens.common.purchase.order_quantity]: '発注数量',
    [tokens.common.purchase.order_quantity_unit]: '発注数量/単位',
    [tokens.common.purchase.order_quantity_order_unit]: '発注数量 / 発注単位',
    [tokens.common.purchase.order_request]: '発注依頼',
    [tokens.common.purchase.order_request_cancellation_available]: '発注依頼状態のみ発注キャンセルが可能です',
    [tokens.common.purchase.order_request_internal_states]: '発注依頼状態コード 内部 発注依頼 発注キャンセル 入庫待機 入庫確認 入庫完了 入庫確定',
    [tokens.common.purchase.order_request_form_search]: '発注依頼書検索',
    [tokens.common.purchase.order_request_form_select]: '発注依頼書選択',
    [tokens.common.purchase.order_request_form_code]: '発注依頼書コード',
    [tokens.common.purchase.order_request_date_select]: '発注依頼日選択',
    [tokens.common.purchase.order_date]: '発注日',
    [tokens.common.purchase.order_date_lead_time]: '発注日{{purchaseLeadDay}}からセンター入庫までの期間',
    [tokens.common.purchase.order_date_and_time]: '発注日時',
    [tokens.common.purchase.orderer]: '発注者',
    [tokens.common.purchase.orderer_search]: '発注者検索',
    [tokens.common.purchase.orderer_select_prompt]: '発注者を検索し/て選択してください',
    [tokens.common.purchase.orderer_information]: '発注者情報',
    [tokens.common.purchase.order_cancellation_2]: '発注キャンセル',
    [tokens.common.purchase.order_cancellation_confirmed]: '発注キャンセルが完了しました',
    [tokens.common.purchase.ordering_code]: '発注コード',
    [tokens.common.purchase.ordering_code_product]: '発注コード 発注商品',
    [tokens.common.publication_date]: '発行日',
    [tokens.common.date_of_publication]: '発行日付',
    [tokens.common.banner_photo]: 'バナー写真',
    [tokens.common.delivery]: '配送',
    [tokens.common.delivery_driver_phone]: '配送ドライバーの電話番号',
    [tokens.common.delivery_person_in_charge]: '配送担当者',
    [tokens.common.delivery_manager]: '配送マネージャー',
    [tokens.common.delivery_cost]: '配送費用',
    [tokens.common.delivery_photo]: '配送写真',
    [tokens.common.delivery_no_photo]: '配送写真がありません',
    [tokens.common.delivery_entry_method_1]: '配送時の進入方法',
    [tokens.common.delivery_expected_date]: '配送予定日',
    [tokens.common.delivery_completed]: '配送完了',
    [tokens.common.delivery_no_completion_records]: '配送完了履歴がありません',
    [tokens.common.delivery_day_selection_1]: '配送曜日選択',
    [tokens.common.delivery_day_adjustment]: '配送曜日調整',
    [tokens.common.delivery_day_required]: '配送曜日は必須です',
    [tokens.common.delivery_information]: '配送情報',
    [tokens.common.delivery_departure_info]: '配送出庫情報',
    [tokens.common.delivery_area_info]: '配送地域情報',
    [tokens.common.delivery_notes]: '配送特記事項',
    [tokens.common.delivery_schedule_day]: '配送形態 / 配送曜日',
    [tokens.common.delivery_type_selection]: '配送形態選択',
    [tokens.common.delivery_area_selection]: '配送地域選択',
    [tokens.common.delivery_center_departure]: '配送形態 / 出庫センター',
    [tokens.common.delivery_person_selection]: '配送担当者選択',
    [tokens.common.delivery_manager_line_code]: '配送マネージャー幹線コード',
    [tokens.common.delivery_non_delivery_days]: '配送不可曜日',
    [tokens.common.non_delivery_days]: '配送不可曜日',
    [tokens.common.delivery_photo_confirmation]: '配送写真を確認できます',
    [tokens.common.delivery_status]: '配送状態',
    [tokens.common.delivery_quantity]: '配送数量',
    [tokens.common.delivery_excess_quantity]: '配送数量超過',
    [tokens.common.expected_delivery_date]: '配送予定日',
    [tokens.common.delivery_complete]: '配送完了',
    [tokens.common.delivery_complete_unsettled_orders_only]: '配送完了および未精算注文のみ可能です',
    [tokens.common.delivery_partial]: '部分配送完了',
    [tokens.common.delivery_loaded]: '積荷完了',
    [tokens.common.delivery_issue_unprocessable]: '配送完了および正常状態の案件はイシュー処理不可',
    [tokens.common.delivery_completion_datetime]: '配送完了日時',
    [tokens.common.delivery_completed_date]: '配送完了日',
    [tokens.common.delivery_day]: '配送曜日',
    [tokens.common.delivery_day_selection_2]: '配送曜日選択',
    [tokens.common.delivery_type]: '配送タイプ',
    [tokens.common.delivery_vehicle_number]: '配送タイプ / 車両番号',
    [tokens.common.delivery_date]: '配送日',
    [tokens.common.delivery_date_return_policy]: '配送日が現在の月と異なるため返品交換受付ができません',
    [tokens.common.shipper]: '配送者',
    [tokens.common.preparing_for_delivery]: '配送準備中',
    [tokens.common.in_delivery]: '配送中',
    [tokens.common.delivery_address_photo_upload]: '配送先写真アップロード',
    [tokens.common.delivery_address_photo_attachment]: '配送先写真添付',
    [tokens.common.delivery_address]: '配送先住所',
    [tokens.common.delivery_address_direct_input]: '配送先住所直接入力',
    [tokens.common.delivery_address_required]: '配送先住所は必須です',
    [tokens.common.postal_code_must_be_7_digits]: '郵便番号は7桁で入力してください。',
    [tokens.common.delivery_address_photo]: '配送先添付写真',
    [tokens.common.shipping_address_road_name]: '配送先基本住所(道路名)',
    [tokens.common.shipping_address_jibun]: '配送先基本住所(地番)',
    [tokens.common.detailed_delivery_address]: '配送先詳細住所',
    [tokens.common.shipping_address_zip_code]: '配送先郵便番号',
    [tokens.common.delivery_address_same_check]: '配送先住所同一確認',
    [tokens.common.delivery_entry_method_2]: '配送進入方法',
    [tokens.common.special_delivery_information]: '配送特記事項',
    [tokens.common.delivery_form]: '配送形態',
    [tokens.common.delivery_form_required]: '配送形態は必須です',
    [tokens.common.number_of_deliveries]: '配送回数',
    [tokens.common.drainage]: '排水',
    [tokens.common.drainage_order]: '排水発注',
    [tokens.common.assignment]: '配分',
    [tokens.common.assignment_route]: '配分ルート',
    [tokens.common.assignment_sales_location]: '配分売上先',
    [tokens.common.assignment_datetime]: '配分日時',
    [tokens.common.assignment_date_selection]: '配分日付選択',
    [tokens.common.assignor]: '配分者',
    [tokens.common.arrangement_success]: '配置実行成功',
    [tokens.common.arrangement_failure]: '配置実行失敗',
    [tokens.common.placement_confirmation]: '配置を実行しますか？ 既存の実行時間帯で実行しない場合、問題が発生する可能性があります。',
    [tokens.common.placement_prompt]: '配置を実行しますか',
    [tokens.common.button_document_add]: 'ボタンをクリックして文書を追加 (20MB以下、最大10個)',
    [tokens.common.button_photo_add]: 'ボタンをクリックして写真を追加（{{lessCapacity}}以下、最大{{maxFileCount}}件）',
    [tokens.common.button_file_upload]: 'ボタンをクリックしてファイルをアップロードしてください',
    [tokens.common.button_event]: 'ボタンイベント',
    [tokens.common.number_1]: '番号',
    [tokens.common.universal_product]: '汎用商品',
    [tokens.common.bay]: 'ベイ',
    [tokens.common.bay_rack]: 'ベイ / ラック',
    [tokens.common.change]: '変更',
    [tokens.common.change_amount_input]: '変更金額入力',
    [tokens.common.change_purchase_price]: '変更販売価格',
    [tokens.common.change_reason]: '変更理由',
    [tokens.common.change_reason_input]: '変更理由入力',
    [tokens.common.change_cancel_ignore]: '変更を無視してキャンセルしますか',
    [tokens.common.change_no_modifications]: '変更内容がありません',
    [tokens.common.change_not_applied]: '変更が適用されていません。変更を無視してキャンセルしますか',
    [tokens.common.change_not_effective]: '変更が適用されませんでした',
    [tokens.common.change_reservation]: '変更予約',
    [tokens.common.change_expected_purchase_margin]: '変更予定仕入利益率',
    [tokens.common.change_expected_date]: '変更予定日',
    [tokens.common.change_history_purchase_price]: '変更履歴 仕入価格',
    [tokens.common.change_datetime]: '変更日時',
    [tokens.common.change_effective_date_1]: '変更適用日',
    [tokens.common.change_effective_date_limit]: '変更適用日は[当日 +1]から最大 3ヶ月まで可能です',
    [tokens.common.change_effective_date_required]: '変更適用日は必須です',
    [tokens.common.change_before]: '変更前',
    [tokens.common.change_before_amount]: '変更前金額',
    [tokens.common.change_immediate_settlement]: '変更即時に精算金額が修正されます。保存を続行しますか？',
    [tokens.common.change_departure_center_selection]: '変更 出庫センター選択',
    [tokens.common.change_category]: '変更カテゴリー',
    [tokens.common.change_sales_margin]: '変更販売利益率',
    [tokens.common.change_after]: '変更後',
    [tokens.common.change_after_amount]: '変更後金額',
    [tokens.common.changed_no_records]: '変更された履歴がありません',
    [tokens.common.changed_no_changes]: '変更された内容がありません',
    [tokens.common.changed_credit_limit_reset]: '変更された信用限度金額は変更前の金額まで支払われると自動復元されます',
    [tokens.common.change_reservation_deleted]: '変更予約の削除が完了しました',
    [tokens.common.change_reservation_completed]: '変更予約が完了しました',
    [tokens.common.change_completed]: '変更が完了しました',
    [tokens.common.change_history]: '変更履歴',
    [tokens.common.changer]: '変更者',
    [tokens.common.change_effective_date_2]: '変更適用日',
    [tokens.common.change_amount_variation]: '変動金額',
    [tokens.common.change_rate]: '変動率',
    [tokens.common.conversion]: '変換数量',
    [tokens.common.conversion_quantity]: '変換数量',
    [tokens.common.custody_inventory]: '保管在庫',
    [tokens.common.storage_inventory]: '保管在庫',
    [tokens.common.storage_inventory_receiving_center]: '(保管在庫)入庫センター',
    [tokens.common.storage_inventory_auto_order_status]: '(保管在庫)自動発注有無',
    [tokens.common.storage_inventory_no_auto_order]: '保管在庫は自動発注を選択できません',
    [tokens.common.storage_inventory_quantity]: '保管在庫量',
    [tokens.common.storage_order_cancel_possible]: '保管在庫のみ発注キャンセルが可能です',
    [tokens.common.supplement_quantity]: '補充数量',
    [tokens.common.supplement_order]: '補充指示',
    [tokens.common.supplement_order_list]: '補充指示リスト',
    [tokens.common.supplementary_quantity]: '補充数量',
    [tokens.common.value_added_tax]: '消費税',
    [tokens.common.partially_not_received]: '部分未入庫',
    [tokens.common.partial_delivery]: '部分配送',
    [tokens.common.partial_loading_unloading]: '部分積載/未積載',
    [tokens.common.partial_completion]: '部分完了',
    [tokens.common.inventory_slump]: '不振在庫',
    [tokens.common.inventory_date]: '在庫日付',
    [tokens.common.no_sluggish_inventory]: '不振在庫がありません',
    [tokens.common.minute]: '分',
    [tokens.common.minute_input_limit]: '00 ~ 59分まで入力してください',
    [tokens.common.classification]: '分類',
    [tokens.common.location_distribution]: '分配ロケーション',
    [tokens.common.location_distribution_info]: '分配ロケーション情報',
    [tokens.common.unnecessary]: '不要',
    [tokens.common.brand]: '取引先',
    [tokens.common.brand_name]: '取引先名',
    [tokens.common.brand_search]: '取引先検索',
    [tokens.common.brand_contract_end]: '取引先契約終了時、下位売上先もすべて契約終了されます',
    [tokens.common.brand_management]: '取引先管理',
    [tokens.common.brand_exposure_products]: '取引先露出商品',
    [tokens.common.brand_contact_info]: '取引先担当者1)情報',
    [tokens.common.brand_contact_info_2]: '取引先担当者2)情報',
    [tokens.common.brand_registration]: '取引先登録',
    [tokens.common.brand_revenue_percentage]: 'ブランド売上額の',
    [tokens.common.brand_business_number]: 'ブランド ブランド事業者番号 代表者',
    [tokens.common.brand_selection]: '取引先選択',
    [tokens.common.brand_edit]: 'ブランド修正',
    [tokens.common.brand_information_1]: '取引先情報',
    [tokens.common.brand_settlement]: '取引先決済',
    [tokens.common.brand_settlement_classification]: '取引先決済区分',
    [tokens.common.brand_settlement_payment_date]: '取引先決済基準/決済日',
    [tokens.common.brand_no_settlement_records]: 'ブランド決済履歴が存在しません',
    [tokens.common.brand_statement_resent]: 'ブランド決済書のメール再送信が完了しました',
    [tokens.common.brand_statement_batch_confirm]: 'ブランド決済書一括確定',
    [tokens.common.brand_statement_confirmed]: 'ブランド決済書の確定が完了しました',
    [tokens.common.brand_ID_1]: '取引先ID',
    [tokens.common.brand_mandatory]: '取引先は必須です',
    [tokens.common.brand_manager]: 'ブランド担当者',
    [tokens.common.brand_search_prompt]: '取引先を検索して選択してください',
    [tokens.common.brand_name]: '取引先名',
    [tokens.common.brand_name_length_limit]: '取引先名は何文字以内で入力してください',
    [tokens.common.brand_name_mandatory]: '取引先名は必須です',
    [tokens.common.brand_name_duplicate]: '取引先名が重複しています',
    [tokens.common.brand_ID_2]: '取引先ID',
    [tokens.common.brand_information_2]: '取引先情報',
    [tokens.common.note]: '備考',
    [tokens.common.note_requests]: '備考要求事項',
    [tokens.common.password]: 'パスワード',
    [tokens.common.password_input]: 'パスワード入力',
    [tokens.common.password_mismatch_1]: 'パスワードが一致しません',
    [tokens.common.password_match_1]: 'パスワードが一致します',
    [tokens.common.password_registration_condition]: 'パスワードが一致しなければ登録できません',
    [tokens.common.password_enter_prompt]: 'パスワードを入力してください',
    [tokens.common.expense]: '費用',
    [tokens.common.cost_input_prompt]: '費用を入力してください',
    [tokens.common.non_member]: '非会員',
    [tokens.common.non_member_consultation_history]: '非会員の相談履歴のみ表示',
    [tokens.common.business_registration_address]: '事業登録証上の住所',
    [tokens.common.business_registration_number_1]: '事業者登録番号',
    [tokens.common.business_number_duplicate_1]: '事業者登録番号が重複しています',
    [tokens.common.business_number_length]: '事業者登録番号は13何文字です',
    [tokens.common.business_number_mandatory]: '事業者登録番号は必須です',
    [tokens.common.business_registration_number_length]: '事業者登録番号は何文字です',
    [tokens.common.business_registration_zip_code]: '事業登録証上の郵便番号',
    [tokens.common.business_number]: '事業者番号',
    [tokens.common.business_name_registration]: '事業者名称',
    [tokens.common.business_name_number_registration]: '事業者名称 / 登録番号',
    [tokens.common.business_name_length_limit]: '事業者名称は30何文字以内で入力してください',
    [tokens.common.business_name_mandatory]: '事業者名称は必須です',
    [tokens.common.business_name_input_prompt]: '事業者名称を入力してください',
    [tokens.common.business_name_required]: '事業者名称は必須です.',
    [tokens.common.business_name_mandatory_full]: '事業者名称は30何文字以内で入力してください',
    [tokens.common.business_name_duplicate_1]: '事業者名称が重複しています',
    [tokens.common.business_type_1]: '事業者タイプ',
    [tokens.common.business_registration_number_2]: '事業者登録番号',
    [tokens.common.business_number_duplicate_2]: '事業者登録番号が重複しています',
    [tokens.common.business_registration_address_standard]: '事業者登録証上の住所',
    [tokens.common.business_registration_address_same]: '事業者登録証上の住所と同じ',
    [tokens.common.business_registration_address_mandatory]: '事業者登録証上の住所は必須です',
    [tokens.common.business_registration_road_name]: '事業者登録証上の道路名',
    [tokens.common.business_registration_detailed_address]: '事業者登録証上の詳細住所',
    [tokens.common.business_registration_jibun]: '事業者登録証上の地番',
    [tokens.common.business_number_input_limit]: '事業者番号は10何文字で入力してください',
    [tokens.common.business_number_mandatory_input]: '事業者番号を必ず入力してください',
    [tokens.common.business_name]: '事業者名称',
    [tokens.common.business_name_duplicate_2]: '事業者名称が重複しています',
    [tokens.common.business_name_label]: '事業者名称ラベル',
    [tokens.common.business_type_2]: '事業者タイプ',
    [tokens.common.use]: '使用',
    [tokens.common.exceed_storage_rate]: '使用積載率超過',
    [tokens.common.use_conversion]: '使用変換',
    [tokens.common.use_status]: '使用有無',
    [tokens.common.user_selection]: 'ユーザー選択',
    [tokens.common.username]: 'ユーザー名',
    [tokens.common.user_information]: 'ユーザー情報',
    [tokens.common.use_conversion_unuse]: '使用から未使用に変換',
    [tokens.common.in_use]: '使用中',
    [tokens.common.reason]: '理由',
    [tokens.common.reason_content]: '理由内容',
    [tokens.common.reason_detail_input]: '理由詳細入力',
    [tokens.common.reason_selection]: '理由選択',
    [tokens.common.reason_input]: '理由入力',
    [tokens.common.reason_input_confirmation]: '理由入力確定処理',
    [tokens.common.reason_mandatory]: '理由は必須です',
    [tokens.common.reason_selection_prompt]: '理由を選択してください',
    [tokens.common.enter_reason]: '理由を入力してください',
    [tokens.common.inbound_expected_bulk_registration_completed]: '入庫予定書一括登録が完了しました。',
    [tokens.common.excel_file]: 'EXCELファイル',
    [tokens.common.picture]: '写真',
    [tokens.common.picture_upload]: '写真アップロード',
    [tokens.common.delete]: '削除',
    [tokens.common.deleted]: '削除されました',
    [tokens.common.delete_complete]: '削除完了',
    [tokens.common.delete_completed]: '削除が完了しました',
    [tokens.common.delete_status]: '削除有無',
    [tokens.common.mountainous_district]: '山地',
    [tokens.common.acknowledged_above_content]: '上記内容を確認しました',
    [tokens.common.top_summary]: '上部要約',
    [tokens.common.counsel_category]: '相談区分',
    [tokens.common.counsel_details]: '相談履歴',
    [tokens.common.no_counsel_details]: '相談履歴がありません',
    [tokens.common.counsel_content]: '相談内容',
    [tokens.common.counsel_content_required]: '相談内容は必須です',
    [tokens.common.counsel_registration]: '相談登録',
    [tokens.common.counsel_detail]: '相談詳細',
    [tokens.common.counsel_status_change_completed]: '相談状態の変更が完了しました',
    [tokens.common.counsel_type]: '相談タイプ',
    [tokens.common.counsel_type_detail_required]: '相談タイプの詳細は必須です',
    [tokens.common.counsel_type_required]: '相談タイプは必須です',
    [tokens.common.counsel_datetime]: '相談日時',
    [tokens.common.counsel_processing_datetime]: '相談(処理)日時',
    [tokens.common.counsel_processing_date]: '相談(処理)日',
    [tokens.common.consultation_category]: '相談区分',
    [tokens.common.consultation_details]: '相談内容',
    [tokens.common.consultation_details_enter]: '相談内容を入力してください',
    [tokens.common.consultation_type]: '相談タイプ',
    [tokens.common.consultation_type_selection]: '相談タイプを選択してください',
    [tokens.common.consultation_date]: '相談日',
    [tokens.common.consultation_datetime]: '相談日時',
    [tokens.common.consultation_status_datetime]: '相談日時 / 状態',
    [tokens.common.counselor]: '相談者',
    [tokens.common.counselor_selection]: '相談者選択',
    [tokens.common.particular]: '詳細',
    [tokens.common.particular_details]: '詳細履歴',
    [tokens.common.particular_content]: '詳細内容',
    [tokens.common.particular_content_required]: '詳細内容は必須です',
    [tokens.common.particular_content_enter]: '詳細内容を入力してください',
    [tokens.common.particular_reason_enter]: '詳細理由を入力してください',
    [tokens.common.particular_edit]: '詳細修正',
    [tokens.common.particular_address]: '詳細住所',
    [tokens.common.detailed_reason]: '詳細理由',
    [tokens.common.detailed_type]: '詳細タイプ',
    [tokens.common.detailed_type_selection]: '詳細タイプを選択してください',
    [tokens.common.details_information]: '詳細情報',
    [tokens.common.detailed_address_required]: '詳細住所は必須です',
    [tokens.common.loading_inspection]: '積載検査中',
    [tokens.common.loading_waiting]: '積載待機',
    [tokens.common.loading_in_progress]: '積載待機中',
    [tokens.common.no_loading_jobs]: '積載待機中の作業はありません',
    [tokens.common.loading_ready]: '積載準備完了 & 入庫指示',
    [tokens.common.loading_inspection_datetime]: '積載検査日時',
    [tokens.common.situation]: '状態',
    [tokens.common.situation_change]: '状態変更',
    [tokens.common.situation_change_completed]: '状態変更が完了しました',
    [tokens.common.situation_selection]: '状態選択',
    [tokens.common.register_in_state]: '状態で登録',
    [tokens.common.goods]: '商品',
    [tokens.common.goods_id]: '商品 ID',
    [tokens.common.goods_individual_registration]: '商品個別登録',
    [tokens.common.goods_search_popup]: '商品検索ポップアップ',
    [tokens.common.goods_management]: '商品管理',
    [tokens.common.lot_management]: 'LOT管理',
    [tokens.common.package_management]: 'パッケージ管理',
    [tokens.common.package_registration]: 'パッケージ登録',
    [tokens.common.update_package]: 'パッケージ修正',
    [tokens.common.package]: 'パッケージ',
    [tokens.common.goods_search]: '商品照会',
    [tokens.common.package_component_goods_list]: '構成商品リスト',
    [tokens.common.package_component_goods_required]: 'パッケージ構成商品は必須です',
    [tokens.common.composition_code]: '構成コード',
    [tokens.common.composition_code_select]: '構成コード選択',
    [tokens.common.config_code_outbound_instruction]: '構成コード出庫指示',
    [tokens.common.confirm_config_code_shipment]: '{{count}}件の注文を出庫指示します。',
    [tokens.common.bulk_inspection_single_outbcnt_only]: '一括検収は一つの出庫回次のみ可能です。',
    [tokens.common.bulk_inspection_by_outbcnt_confirm]: '出庫回次 {{outbCnt}} 全体を一括検収します。',
    [tokens.common.bulk_inspection_search_outbcnt]: '出庫回次を検索するか、項目を選択してください。',
    [tokens.common.bulk_inspection_with_invoice_confirm]: '送り状の一括出力も一緒に行いますか？',
    [tokens.common.normal_inspection_outbound_complete]: '通常検品 出荷完了',
    [tokens.common.batch_inspection_outbound_complete]: '一括検品 出荷完了',
    [tokens.common.existing_outbound_complete]: '既存 出荷完了',
    [tokens.common.outbound_complete_irreversible_warning]: '出荷完了処理は取り消しできません。',
    [tokens.common.outbound_complete_target_count]: '対象注文: {{count}}件',
    [tokens.common.outbound_complete_confirm]: '{{count}}件の注文を出荷完了処理します。取り消しできません。',
    [tokens.common.select_outbound_round]: '出荷回次を選択してください',
    [tokens.common.no_outbound_complete_target]: '出荷完了可能な対象がありません。',
    [tokens.common.partial_inspection_warning]: '部分検品 {{partialCount}}件 / 未検品 {{notInspectedCount}}件が含まれています。検品完了の{{completedCount}}件のみ出荷完了処理されます。',
    [tokens.common.not_allowed_order_code]: '選択した注文に含まれないピッキングコードです。',
    [tokens.common.please_select_order]: '注文を選択してください。',
    [tokens.common.package_type]: 'パッケージタイプ',
    [tokens.common.package_id]: 'パッケージID',
    [tokens.common.package_code]: 'パッケージコード',
    [tokens.common.package_name]: 'パッケージ名',
    [tokens.common.package_type_required]: 'パッケージタイプの選択は必須です',
    [tokens.common.package_name_required]: 'パッケージ名は必須です',
    [tokens.common.no_registered_packages]: '登録されたパッケージがありません。',
    [tokens.common.goods_regulation_management]: '商品規制管理',
    [tokens.common.goods_regulation_registration_completed]: '商品規制登録が完了しました',
    [tokens.common.goods_period_regulation_bulk_registration]: '商品期間規制一括登録',
    [tokens.common.goods_period_regulation_registration]: '商品期間規制登録',
    [tokens.common.goods_date_excel]: '商品日付区分Excel',
    [tokens.common.contact_goods_manager]: '商品担当者に問い合わせてください',
    [tokens.common.goods_bulk_registration]: '商品一括登録',
    [tokens.common.goods_bulk_registration_limit]: '商品一括登録は一度に最大 {{totalGoodsBulkRegistration}}件まで可能です',
    [tokens.common.goods_bulk_registration_completed]: '商品一括登録が完了しました',
    [tokens.common.lot_bulk_registration]: 'LOT一括登録',
    [tokens.common.lot_bulk_registration_limit]: 'LOT一括登録は一度に最大{{totalGoodsBulkRegistration}}個まで可能です',
    [tokens.common.goods_bulk_edit]: '商品一括修正',
    [tokens.common.goods_bulk_expected_inbound]: '入庫予定書一括登録',
    [tokens.common.goods_second_image]: '商品2番目の画像',
    [tokens.common.goods_bulk_register]: '商品登録 - 一括',
    [tokens.common.goods_inbound_expected_bulk_register]: '入庫予定書一括登録',
    [tokens.common.goods_list_deletion_restriction]: '商品リストがある場合、削除できません',
    [tokens.common.no_goods_list]: '商品リストが存在しません',
    [tokens.common.goods_order_notes]: '商品および発注特記事項',
    [tokens.common.goods_order]: '商品発注',
    [tokens.common.goods_order_completed]: '商品発注が完了しました',
    [tokens.common.goods_inbound_plan_completed]: '入庫予定書の登録が完了しました。',
    [tokens.common.goods_photo]: '商品写真',
    [tokens.common.goods_photo_registration]: '商品写真登録',
    [tokens.common.goods_photo_upload]: '商品写真アップロード',
    [tokens.common.goods_photo_notes]: '商品写真・特記事項',
    [tokens.common.goods_status]: '商品状態',
    [tokens.common.goods_status_change_completed]: '商品状態の変更が完了しました',
    [tokens.common.goods_status_batch_change]: '商品状態一括変更',
    [tokens.common.goods_lot_delete_change]: '商品LOT一括削除',
    [tokens.common.goods_status_change_restriction]: '使用に変更できない商品が存在します',
    [tokens.common.goods_product]: '商品',
    [tokens.common.goods_name]: '商品名',
    [tokens.common.goods_product_name_supplier]: '商品名 仕入先',
    [tokens.common.goods_selection]: '商品選択',
    [tokens.common.goods_selection_then_input]: '商品選択後に入力してください',
    [tokens.common.goods_count]: '商品数',
    [tokens.common.goods_edit_register]: '商品修正 商品登録',
    [tokens.common.goods_start_end_date]: '商品開始日 終了日',
    [tokens.common.goods_type_brand]: '商品タイプ / ブランド',
    [tokens.common.goods_type_required]: '商品タイプは必須です',
    [tokens.common.goods_batch_edit]: '商品一括修正',
    [tokens.common.goods_batch_info_change_completed]: '商品一括情報変更が完了しました',
    [tokens.common.goods_receiving_center]: '商品入庫センター',
    [tokens.common.goods_receiving]: '商品入庫',
    [tokens.common.goods_exposure_settings]: '商品全体の露出設定',
    [tokens.common.goods_info_file]: '商品情報 EXCEL ファイル',
    [tokens.common.lot_info_file]: 'LOT情報EXCELファイル',
    [tokens.common.goods_order_unit]: '商品注文単位',
    [tokens.common.goods_order_unit_specification]: '商品注文単位 / 規格',
    [tokens.common.goods_order_unit_required]: '商品注文単位は必須です',
    [tokens.common.goods_order_unit_conversion_quantity_input]: '商品注文単位に基づく {{quantityAccordingToUnit}} 変換数量を入力してください',
    [tokens.common.goods_order_unit_spec]: '商品注文単位規格',
    [tokens.common.goods_first_image]: '商品1番目の画像',
    [tokens.common.goods_additional_edit]: '商品追加/修正',
    [tokens.common.goods_category]: '商品カテゴリ',
    [tokens.common.goods_category_change]: '商品カテゴリ変更',
    [tokens.common.goods_category_sales_margin_change_record]: '商品カテゴリごとの販売利益率変更履歴',
    [tokens.common.goods_category_sales_margin_setting]: '商品カテゴリごとの販売利益率設定',
    [tokens.common.goods_category_sales_margin_set]: '商品カテゴリごとの販売利益率を設定します',
    [tokens.common.goods_item_code_product_name]: '商品コード 商品名',
    [tokens.common.goods_particulars]: '商品特記事項',
    [tokens.common.goods_temperature_1]: '商品温度',
    [tokens.common.goods_temperature_2]: '温度',
    [tokens.common.goods_temperature_origin]: '商品温度 / 原産地',
    [tokens.common.goods_temperature_required]: '商品温度は必須です',
    [tokens.common.product_specifications]: '商品規格',
    [tokens.common.product_name]: '商品名',
    [tokens.common.product_name_input]: '商品名を入力してください',
    [tokens.common.product_name_length_limit]: '商品名は何 {{productNameLengthLimit}}文字以内で作成してください',
    [tokens.common.product_name_required]: '商品名は必須です',
    [tokens.common.sku_code_required]: 'SKUコードは必須です。',
    [tokens.common.split_string_info]: 'カンマ区切り(,)での複数検索',
    [tokens.common.product_number]: '商品番号',
    [tokens.common.product_adjustment_by_item_reason]: '商品ごとの調整金額 調整理由',
    [tokens.common.product_adjustment_case]: '商品ごとの調整金額の場合',
    [tokens.common.product_order_details]: '商品ごとの注文履歴',
    [tokens.common.product_order_details_excel_download]: '商品ごとの注文履歴Excelダウンロード',
    [tokens.common.product_status]: '商品状態',
    [tokens.common.product_selection]: '商品選択',
    [tokens.common.lot_bulk_register]: 'LOT登録-一括',
    [tokens.common.number_of_products]: '商品数',
    [tokens.common.product_id]: '商品ID',
    [tokens.common.product_id_details]: '商品ID 商品名 仕入価格 推奨販売価格 設定区分 購入利益率 固定価格 推奨販売価格 変更適用日',
    [tokens.common.total_sku_count]: '総SKU数',
    [tokens.common.total_quantity]: '総数量',
    [tokens.common.missing_outb_id_error]: '出荷ID(outbId)がない商品があります。データを再取得してください。',
    [tokens.common.product_type]: '商品タイプ',
    [tokens.common.product_exposure_switch_prompt]: '商品を {{exposureOrNo}} に切り替えますか',
    [tokens.common.product_exposure_priority]: '商品の販売価格は以下の優先順位に従って自動的に表示されます',
    [tokens.common.setting_overall_product_exposure]: '商品全体露出設定',
    [tokens.common.product_information]: '商品情報',
    [tokens.common.product_order_unit]: '商品注文単位',
    [tokens.common.product_category_code]: '商品カテゴリコード',
    [tokens.common.product_code]: '商品コード',
    [tokens.common.mutual]: '相互',
    [tokens.common.repayment]: '返済',
    [tokens.common.refresh]: '更新',
    [tokens.common.sprout]: 'スプラウト',
    [tokens.common.sprout_customer_emergency_shipment_only]: 'スプラウト顧客緊急出荷履歴のみ表示',
    [tokens.common.sprout_customer_return_exchange_only]: 'スプラウト顧客返品/交換履歴のみ表示',
    [tokens.common.sprout_customer_consultation_history_only]: 'スプラウト顧客相談履歴のみ表示',
    [tokens.common.sprout_customers_only]: 'スプラウト顧客のみ表示',
    [tokens.common.sprout_customer_claims_only]: 'スプラウト顧客のクレームのみ表示',
    [tokens.common.omission]: '省略',
    [tokens.common.generation]: '生成',
    [tokens.common.creation_completed]: '生成が完了しました',
    [tokens.common.creation_date]: '生成日',
    [tokens.common.constructor]: '生成者',
    [tokens.common.document_upload]: '書類アップロード',
    [tokens.common.server_error]: 'サーバーエラー',
    [tokens.common.invalid_data_from_server]: 'サーバーから無効なデータを受信しました',
    [tokens.common.seo_hwaseong]: '西華城',
    [tokens.common.pre_order_inventory_deduction_period]: '先注文在庫差引期間',
    [tokens.common.pre_order_print]: '先注文印刷',
    [tokens.common.pre_order_inventory_deduction_period_setting]: '先注文在庫差引期間設定',
    [tokens.common.elected_high_school]: '先出庫',
    [tokens.common.inbound_expected_bulk_registration_limit]: '入庫予定の一括登録は、一度に最大{{cnt}}個まで可能です。',
    [tokens.common.warning_invalid_early_shipment_day_goods]: '[物流コード: {{logisticCodeForEarlyShipment}}] - 日在庫商品は先出しできません。',
    [tokens.common.elected_high_school_work_order]: '先出庫作業指示',
    [tokens.common.elected_high_school_instruction_completed]: '先出庫指示が完了しました',
    [tokens.common.elected_high_school_irreversible_warning]: '先出庫指示後は元に戻せず、当日の出庫作業に進みます',
    [tokens.common.notice_of_election]: '先出庫指示',
    [tokens.common.select]: '選択',
    [tokens.common.select_details]: '選択履歴',
    [tokens.common.not_selected_orders]: '選択されていない注文',
    [tokens.common.not_selected_order_check]: '選択されていない注文があります。再度確認してください',
    [tokens.common.no_selected_details]: '選択された履歴がありません',
    [tokens.common.selected_products_regulation_end]: '選択された商品が即時規制終了処理されます',
    [tokens.common.selected_departure_center_no_supplier]: '選択された出庫センターに関連する仕入先がありません',
    [tokens.common.selected_departure_center_no_products]: '選択された出庫センターに関連する商品がありません',
    [tokens.common.selected_product_exposure_switch_prompt]:
        '選択された {{totalGoodsExposureOrNo}} 個の商品を本当に {{exposureOrNo}} に切り替えますか？',
    [tokens.common.selected_total_goods_for_early_shipment]:
        '選択された {{totalGoodsForEarlyShipment}} 個の商品を先出荷指示してもよろしいですか？先出荷指示後は元に戻すことができず、本日の出荷作業段階に進みます。',
    [tokens.common.selected_product_label_print]: '選択した-個の商品についてラベルを印刷しますか？',
    [tokens.common.selected_product_label_printing]: '選択した{{totalGoodsForPrintingLabel}}個の商品についてラベルを印刷しますか？',
    [tokens.common.selected_product_total_quantity_picking]: '選択された {{totalGoods}} 個の注文について総量ピッキングリストを印刷しますか？',
    [tokens.common.selected_location_label_reprint]: '選択したロケーションラベルを再印刷しますか？',
    [tokens.common.selected_label_reprint]: 'すでに出力されているラベルです。その商品のラベルをもう一度印刷しますか？',
    [tokens.common.selected_supplier_exposure_switch_prompt]:
        '選択された{{totalPurchaserExposureOrNo}}件の仕入先を本当に{{exposureOrNo}}に切り替えますか？',
    [tokens.common.selected_order_handling_warning]:
        '選択された発注履歴は入荷処理され、入庫確認書が発行され、以後は修正できません。強制入庫を登録しますか？',
    [tokens.common.selected_purchase_price_change_date]: '選択された日付で仕入価格および推奨販売価格が自動的に変更されます',
    [tokens.common.selected_statement_update]: '選択された精算書を更新しますか？',
    [tokens.common.selected_statement_delete]: '選択された精算書を削除しますか？',
    [tokens.common.selected_statement_batch_confirm]: '選択された精算書を一括確定します',
    [tokens.common.selected_statement_confirm]: '選択された精算書を確定します',
    [tokens.common.selected_order_all_delivery_complete]: '選択された注文がすべて配送完了となり、元に戻せません',
    [tokens.common.selected_notice_password_entry]: '選択した{{totalSelectedNotice}}件の通知の表示を終了するには、パスワードを入力してください。',
    [tokens.common.setting_save]: '設定保存',
    [tokens.common.success]: '成功',
    [tokens.common.success_forced_entry_complete]: '強制入庫処理が成功しました',
    [tokens.common.sector]: 'セクター',
    [tokens.common.sector_select_prompt]: 'セクターを選択してください',
    [tokens.common.center]: 'センター',
    [tokens.common.center_selection]: 'センター選択',
    [tokens.common.center_lead_time]: 'センター入庫リードタイム',
    [tokens.common.center_registration_required]: 'センター入庫設定登録が必要です',
    [tokens.common.center_information]: 'センター情報',
    [tokens.common.center_info_retrieval]: 'センター情報を取得',
    [tokens.common.center_add_prompt]: 'センターを追加してください',
    [tokens.common.center_name]: 'センター名',
    [tokens.common.center_specific_conditions]: 'センターごとの詳細な出庫条件を設定してください',
    [tokens.common.center_new_product_storage_conditions]:
        'センターの新商品(保管在庫) の詳細入庫条件を設定してください。\n 時間当たりの入庫量は偶数で入力してください',
    [tokens.common.subcategory]: '小分類',
    [tokens.common.subcategory_addition_requirement]: '小分類カテゴリーを追加する場合、中分類、大分類は必須です',
    [tokens.common.subcategory_required]: '小分類カテゴリーは必須です',
    [tokens.common.subcategories_required]: '小分類は必須です',
    [tokens.common.consumption_period]: '賞味期限',
    [tokens.common.consumption_period_select]: '賞味期限を選択してください',
    [tokens.common.lot_no_select]: 'LOT番号を選択してください。',
    [tokens.common.expiration_date]: '賞味期限',
    [tokens.common.expiration_date_option]: '賞味期限の記載有無',
    [tokens.common.expiration_date_deadline]: '賞味期限の最終期限',
    [tokens.common.expiration_date_deadline_preorder]: '賞味期限の最終期限 先注文在庫差し引き',
    [tokens.common.expiration_date_adjustment_preorder_inventory]:
        '賞味期限の最終期限を変更すると、在庫ロスが発生する可能性があり、設定した期間に応じて先注文商品の可用在庫が差し引かれます',
    [tokens.common.expiration_date_deadline_preorder_period]: '賞味期限最終期限 先注文在庫差し引き期間',
    [tokens.common.expiration_date_input_required]: '賞味期限の入力 - を選択してください。選択された発注依頼書がありません',
    [tokens.common.expiration_date_remaining_days]: '賞味期限の残日数',
    [tokens.common.expiration_date_remaining_days_query]: '賞味期限の残日数を検索',
    [tokens.common.expiration_date_adjustment]: '賞味期限の調整',
    [tokens.common.expiration_date_addition]: '賞味期限の追加',
    [tokens.common.expiration_date_indicated]: '賞味期限記載有無',
    [tokens.common.consumption_period_limit]: '賞味期限最終期限',
    [tokens.common.expiration_date_specific_inventory]: '賞味期限別在庫の詳細',
    [tokens.common.time_taken]: '所要時間',
    [tokens.common.loss_recovery]: '損失回復',
    [tokens.common.loss_processing]: '損失処理',
    [tokens.common.loss_amount]: '損失金額',
    [tokens.common.number_2]: '数',
    [tokens.common.water_channel_select_required]: '水路の売上先選択は必須です',
    [tokens.common.manual_order]: '手動発注',
    [tokens.common.manual]: '手動',
    [tokens.common.quantity]: '数量',
    [tokens.common.quantity_unit_specification]: '数量 / 単位 / 規格',
    [tokens.common.quantity_input]: '数量入力',
    [tokens.common.quantity_required]: '数量は必須です',
    [tokens.common.enter_quantity]: '数量を入力',
    [tokens.common.recipient_or_storage_location_input]: '受取人または保管場所を入力',
    [tokens.common.reception_contact]: '受信連絡先',
    [tokens.common.recipient]: '受取人',
    [tokens.common.recipient_number]: '受取人番号',
    [tokens.common.recipient_selection]: '受取人選択',
    [tokens.common.recipient_max_limit]: '受取人は最大 {{recipientMaxCount}}名まで可能です',
    [tokens.common.recipient_required]: '受取人は必須です',
    [tokens.common.recipient_name]: '受取人名',
    [tokens.common.import_country_code]: '輸入国コード',
    [tokens.common.import_declaration_number]: '輸入申告番号',
    [tokens.common.modification]: '修正',
    [tokens.common.modification_completed]: '修正が完了しました',
    [tokens.common.modification_registration]: '修正登録',
    [tokens.common.modification_history]: '修正履歴',
    [tokens.common.modification_addition]: '修正追加',
    [tokens.common.modification_history_absent]: '修正履歴がありません',
    [tokens.common.modification_datetime]: '修正日時',
    [tokens.common.modifier]: '修正者',
    [tokens.common.edit_setting]: '修正情報のための設定',
    [tokens.common.edit_item]: '修正項目',
    [tokens.common.turn_order]: '順番',
    [tokens.common.enter_number]: '数字',
    [tokens.common.enter_number_prompt]: '数字で入力してください',
    [tokens.common.numbers_only_prompt]: '数字のみ入力してください',
    [tokens.common.enter_numbers_prompt]: '数字入力',
    [tokens.common.city]: '市',
    [tokens.common.enter_city_prompt]: '00 ~ 23市まで入力してください',
    [tokens.common.hour]: '時',
    [tokens.common.hourly_intake_even]: '時間当たりの入庫量は偶数である必要があります',
    [tokens.common.hourly_intake_required]: '時間当たりの入庫量は必須です',
    [tokens.common.system_default_setting]: 'システムの基本設定：D + {{shlfDay}} 日',
    [tokens.common.start_time_future_constraint]: '開始時間は終了時間の未来時間を選択できません',
    [tokens.common.start_date]: '開始日',
    [tokens.common.start_date_required]: '開始日は必須です',
    [tokens.common.report_date]: '報告日',
    [tokens.common.new_registration]: '新規登録',
    [tokens.common.reenter_new_password]: '新しいパスワードを再入力してください',
    [tokens.common.new_password]: '新しいパスワード',
    [tokens.common.enter_new_password]: '新しいパスワードを入力してください',
    [tokens.common.application_datetime]: '申請日時',
    [tokens.common.application_date]: '申請日',
    [tokens.common.actual_stock]: '実在庫',
    [tokens.common.actual_stock_quantity]: '実在庫数量',
    [tokens.common.actual_delivery]: '実配送数量',
    [tokens.common.actual_delivery_quantity]: '実配送数量',
    [tokens.common.real_picture_expiration]: '実賞味期限',
    [tokens.common.real_picture_quantity]: '実施数量',
    [tokens.common.room_temperature]: '室温',
    [tokens.common.actual_inventory]: '実在庫',
    [tokens.common.actual_inventory_quantity]: '実在庫数量',
    [tokens.common.actual_order_process]: '実際の発注は商品の販売単位で進行します',
    [tokens.common.actual_received_quantity]: '実入庫数量',
    [tokens.common.failure]: '失敗',
    [tokens.common.not_confirmed_statement_included]: '未確定決済ではなく精算書が含まれています。もう一度選択してください',
    [tokens.common.confirmed_statement_included]: '未確定精算書が含まれています。もう一度選択してください',
    [tokens.common.execution]: '実行',
    [tokens.common.print_all_labels_under_condition]: '以下の条件の注文ラベルをすべて印刷します',
    [tokens.common.release_all_orders_under_condition]: '以下の条件の注文がすべて出庫指示されます',
    [tokens.common.print_all_bulk_picking_under_condition]: '以下の条件の総量ピッキングリストをすべて印刷します',
    [tokens.common.guide]: '案内',
    [tokens.common.anpyeong]: '安平',
    [tokens.common.nighttime]: '夜間',
    [tokens.common.food_download_form]: '書式ダウンロード',
    [tokens.common.yesterday]: '昨日',
    [tokens.common.upload_success]: 'アップロード成功',
    [tokens.common.industry_is_required]: '業種は必須です',
    [tokens.common.industry_code]: '業種コード',
    [tokens.common.company_name]: '業者名',
    [tokens.common.company_type]: '業者タイプ',
    [tokens.common.company_code]: '業者コード',
    [tokens.common.business_status]: '業態 / 業種',
    [tokens.common.business_type_is_required]: '業態は必須です',
    [tokens.common.business_status_code]: '業態コード',
    [tokens.common.not_exist]: 'なし',
    [tokens.common.error]: 'エラー',
    [tokens.common.error_retrieving_virtual_account_list]: 'エラー 仮想口座リストの取得中に問題が発生しました',
    [tokens.common.error_occurred]: 'エラーが発生しました',
    [tokens.common.error_invalid_data_from_server]: 'エラー サーバーから無効なデータを受信しました',
    [tokens.common.excel_download_image]: 'エクセルダウンロード画像',
    [tokens.common.excel_file_download_request]: 'エクセルファイルのダウンロードは開発者に依頼してください',
    [tokens.common.excel_only]: 'エクセルのみ可能',
    [tokens.common.tsv_only]: 'TSVファイルのみアップロードできます (.tsv, .txt)',
    [tokens.common.goddess_credit_status]: '信用(債権)状態',
    [tokens.common.goddess_limit_adjustment_warning]: '信用限度の調整時に損失回収の可能性が発生するため注意してください',
    [tokens.common.goddess_credit_limit]: '信用限度金額',
    [tokens.common.goddess_insufficient_credit]:
        '信用が不足している売上先や、在庫が不足している商品が含まれています。再度確認してアップロードしてください',
    [tokens.common.credit_limit]: '信用限度',
    [tokens.common.credit_limit_amount_required]: '信用限度金額は必須です',
    [tokens.common.credit_limit_in_currency]: '信用限度（ウォン）',
    [tokens.common.connected_sales_source]: '接続された売上先',
    [tokens.common.consolidated_sales_source]: '接続された売上先',
    [tokens.common.related_code]: '関連コード',
    [tokens.common.related_code_length_limit]: '関連コードは何文字を超えることはできません',
    [tokens.common.contact]: '連絡先',
    [tokens.common.contact_information_required]: '連絡先は必須です',
    [tokens.common.enter_required_contact_information]: '連絡先を必ず入力してください',
    [tokens.common.heat]: '熱',
    [tokens.common.heat_column]: '熱 列',
    [tokens.common.key]: '鍵/カードキー',
    [tokens.common.sales_representative_corporate]: '営業担当者 / 取引法人',
    [tokens.common.sales_manager]: '営業担当者',
    [tokens.common.sales_manager_corporate]: '営業担当者 / 取引法人',
    [tokens.common.sales_manager_search]: '営業担当者検索',
    [tokens.common.sales_manager_selection_required]: '営業担当者の選択は必須です',
    [tokens.common.sales_manager_info]: '営業担当者情報',
    [tokens.common.sales_manager_not_found]: '営業担当者が存在しません',
    [tokens.common.select_sales_manager]: '営業担当者を検索して選択してください',
    [tokens.common.depositor]: '預金者',
    [tokens.common.depositor_required]: '預金者は必須です',
    [tokens.common.estimated_depletion_days]: '推定賞味日数',
    [tokens.common.reservation]: '予約',
    [tokens.common.reservation_details]: '予約履歴',
    [tokens.common.reservation_datetime]: '予約日時',
    [tokens.common.reservation_person]: '予約者',
    [tokens.common.reservation_pending]: '予約中',
    [tokens.common.reservation_confirmation]: '予約確認',
    [tokens.common.scheduled_product_info]: '予定商品情報',
    [tokens.common.scheduled_info]: '予定情報',
    [tokens.common.today]: '今日',
    [tokens.common.account_requirement]: 'アカウントの設定は必須です',
    [tokens.common.error_handling]: 'エラー処理',
    [tokens.common.temperature]: '温度',
    [tokens.common.options]: 'オプション',
    [tokens.common.complete]: '完了',
    [tokens.common.completion_time]: '完了時間',
    [tokens.common.except]: '外 {{totalExceptBasic}}除',
    [tokens.common.except_2]: '外 {{totalExceptBasic2}}件',
    [tokens.common.except_supplier]: '外 {{totalExceptPurchaser}}個の仕入先',
    [tokens.common.except_sales_source]: '外 {{totalExceptSales}}個の売上先',
    [tokens.common.except_product]: '外 {{totalExceptProduct}}個の商品',
    [tokens.common.except_product_lot]: '外 {{totalExceptProductLot}}つ',
    [tokens.common.rate]: '料率',
    [tokens.common.daily_landing_count]: '曜日別着地数',
    [tokens.common.request]: 'リクエスト事項',
    [tokens.common.request_quantity]: 'リクエスト数量',
    [tokens.common.execute_request]: 'リクエスト実行',
    [tokens.common.cancel_request]: 'リクエストキャンセル',
    [tokens.common.quantity_available_for_request]: 'リクエスト可能数量',
    [tokens.common.number_of_requests]: 'リクエスト件数',
    [tokens.common.reason_for_request]: 'リクエスト理由',
    [tokens.common.select_reason_for_request]: 'リクエスト理由選択',
    [tokens.common.additional_request_details]: 'リクエスト事項',
    [tokens.common.requested_quantity]: 'リクエスト数量',
    [tokens.common.request_date]: 'リクエスト日',
    [tokens.common.request_datetime]: 'リクエスト日時',
    [tokens.common.requester]: 'リクエスター',
    [tokens.common.search_requester]: 'リクエスター検索',
    [tokens.common.requester_info]: 'リクエスター情報',
    [tokens.common.select_requester]: 'リクエスターを検索して選択してください',
    [tokens.common.purpose]: '用途',
    [tokens.common.purpose_selection]: '用途選択',
    [tokens.common.zip_code]: '郵便番号',
    [tokens.common.zipcode_search]: '郵便番号検索',
    [tokens.common.zipcode_search_placeholder]: '郵便番号を入力 (例: 3591123)',
    [tokens.common.zipcode_no_result]: '検索結果がありません',
    [tokens.common.tiktok_order_receive_empty]: '取り込む店舗の設定がありません。channel-proxy.tiktok.stores を確認してください。',
    [tokens.common.outbound_request]: '出庫依頼',
    [tokens.common.outbound_request_confirm]: '選択した注文を出庫依頼します。在庫が確保され出荷管理に移ります。商品が一つでも足りない場合、その注文は残ります。',
    [tokens.common.tiktok_order_receive]: 'TikTok注文受付',
    [tokens.common.tiktok_order_receive_confirm]: 'TikTokの発送待ち注文を受け付けます。取得済みの注文はスキップします。',
    [tokens.common.collect_failure_list]: '取込失敗',
    [tokens.common.collect_failure_step]: '段階',
    [tokens.common.collect_failure_reason]: '理由',
    [tokens.common.collect_failure_resolved]: '解消',
    [tokens.common.collect_failure_show_resolved]: '解消済みも表示',
    [tokens.common.collect_failure_empty]: '取込失敗はありません',
    [tokens.common.collect_failure_guide]: '取込できなかった注文です。商品を登録して再取込すると入り、その時点で解消されます。',
    [tokens.common.external_order_no]: 'チャネル注文番号',
    [tokens.common.collected_at]: '取込日時',
    [tokens.common.store_id]: 'ストア',
    [tokens.common.tsv_upload]: 'TSVアップロード',
    [tokens.common.addr_lv1]: '都道府県',
    [tokens.common.addr_lv2]: '市区町村',
    [tokens.common.addr_area]: '町域',
    [tokens.common.operable_days_absent]: '運営可能な曜日がありません',
    [tokens.common.currency_unit]: '円',
    [tokens.common.origin]: '原産地',
    [tokens.common.origin_other_mandatory]: '原産地 その他の項目は必須です',
    [tokens.common.origin_other_input]: '原産地 その他入力',
    [tokens.common.origin_required]: '原産地は必須です',
    [tokens.common.month]: '月',
    [tokens.common.month_retrieve]: '月の照会',
    [tokens.common.month_week]: '月週',
    [tokens.common.month_sales_volume]: '月販売量',
    [tokens.common.month_average_order_amount]: '月平均注文金額',
    [tokens.common.month_average_order_frequency]: '月平均注文回数',
    [tokens.common.month_disposal_rate]: '月廃棄率',
    [tokens.common.month_meeting]: '月会',
    [tokens.common.distribution_identification_number]: '流通識別番号',
    [tokens.common.distribution_history_report]: '流通履歴申告情報',
    [tokens.common.type]: 'タイプ',
    [tokens.common.type_selection]: 'タイプ選択',
    [tokens.common.invalid_response_handling]: '無効な応答処理',
    [tokens.common.bank]: '銀行',
    [tokens.common.bank_virtual_account_error]: '銀行 仮想口座番号エラー',
    [tokens.common.bank_selection_required]: '銀行の選択は必須です',
    [tokens.common.search_results_by]: 'の検索結果です',
    [tokens.common.record_quantity]: '履歴数量',
    [tokens.common.record_report_number]: '履歴申告番号',
    [tokens.common.record_report_number_alternative]: '履歴申告番号',
    [tokens.common.history_classification]: '履歴区分',
    [tokens.common.name]: '名前',
    [tokens.common.enter_name_prompt]: '名前を入力してください',
    [tokens.common.email]: 'メールアドレス',
    [tokens.common.email_format_error]: 'メールアドレスの形式が正しくありません',
    [tokens.common.already_statement_generated]: '既に精算書が作成済みの履歴は重複作成できません。確認後、再度選択してください',
    [tokens.common.already_settled_statement_included]: '既に確定された精算書が含まれています。再度選択してください',
    [tokens.common.already_settled_statement_deletion]: '既に確定された精算書は削除できません。再度選択してください',
    [tokens.common.already_reserved_sale_change]: '既に販売予約済みの商品は、最終アップロード基準で変更されます',
    [tokens.common.already_picked]: '既にピッキングされています',
    [tokens.common.image_download]: '画像ダウンロード',
    [tokens.common.image_download_repeat]: '画像ダウンロード',
    [tokens.common.this_month]: '今月',
    [tokens.common.this_week]: '今週',
    [tokens.common.enter_amount_above]: '以上入力してください。',
    [tokens.common.enter_quantity_above]: '数量を入力してください',
    [tokens.common.issue]: 'イシュー',
    [tokens.common.issue_details]: 'イシューディテール',
    [tokens.common.issue_details_view_only]: 'イシューディテールのみ表示',
    [tokens.common.no_issues_found]: 'イシューディテールがありません',
    [tokens.common.issue_handling]: 'イシュー処理',
    [tokens.common.issue_handling_details]: 'イシュー処理の詳細',
    [tokens.common.issue_quantity]: 'イシュー数量',
    [tokens.common.issue_date]: 'イシュー日',
    [tokens.common.issue_handling_no_logistics_code]: 'イシュー処理 - 選択された物流コードがありません',
    [tokens.common.issue_handling_no_incoming_logistics_code]: 'イシュー処理 - 選択された入庫物流コードがありません',
    [tokens.common.issue_handling_no_outgoing_logistics_code]: 'イシュー処理 - 選択された出庫物流コードがありません',
    [tokens.common.issue_handling_no_logistics_code_found]: 'イシュー処理 - 検索された物流コード情報がありません',
    [tokens.common.issue_handling_datetime]: 'イシュー処理日時',
    [tokens.common.utilization]: '利用',
    [tokens.common.utilization_stop_with_password_prompt]: '利用停止処理を行う場合、パスワードを入力してください',
    [tokens.common.utilization_processing]: '利用処理を行いますか？',
    [tokens.common.utilization_completed]: '処理が完了しました',
    [tokens.common.stop_using]: '利用停止',
    [tokens.common.stop_using_completed]: '利用停止が完了しました',
    [tokens.common.profit_margin]: '利益率',
    [tokens.common.profit_margin_fixed_required]: '利益率 固定価格は必須です',
    [tokens.common.profit_margin_change]: '利益率の変更',
    [tokens.common.no_profit_margin_change_history]: '利益率の変更履歴が存在しません',
    [tokens.common.profit_margin_change_next_day_effect]: '利益率の変更は翌日から適用されます',
    [tokens.common.profit_margin_setting]: '利益率設定',
    [tokens.common.profit_margin_reservation_mandatory]: '利益率予約時、販売利益率と予定日は必須です',
    [tokens.common.profit_rate_required]: '利益率は必須です',
    [tokens.common.before]: '以前',
    [tokens.common.below]: '以下',
    [tokens.common.day]: '日',
    [tokens.common.day_payment]: '日決済',
    [tokens.common.day_sales]: '日売上',
    [tokens.common.day_less_than]: '{{lessDate}}日未満',
    [tokens.common.month_less_than]: '{{lessMonth}}月未満',
    [tokens.common.year_less_than]: '{{lessYear}}年未満',
    [tokens.common.day_more_than]: '{{moreDate}}日以上',
    [tokens.common.day_prior_product_disposal]: '日以前の商品廃棄',
    [tokens.common.day_prior_product_disposal_inventory_adjustment]: '日以前の注文商品の可用在庫調整',
    [tokens.common.day_day]: '日 日',
    [tokens.common.day_inventory]: '日在庫',
    [tokens.common.batch_exposure_setting]: '一括露出設定',
    [tokens.common.batch_registration_form_download]: '一括登録フォームのダウンロード',
    [tokens.common.batch_change]: '一括変更',
    [tokens.common.batch_edit_form_download]: '一括修正フォームのダウンロード',
    [tokens.common.batch_adjustment]: '一括調整',
    [tokens.common.batch_adjustment_irreversible_warning]: '一括調整時にはデータ復元が不可能となるため、慎重に確認した上で進行してください',
    [tokens.common.batch_adjustment_completed]: '一括調整が完了しました',
    [tokens.common.batch_confirmation]: '一括確定',
    [tokens.common.general_inquiry_details]: '一般問い合わせ詳細',
    [tokens.common.general_inquiry]: '一般問い合わせ',
    [tokens.common.date_time]: '日時',
    [tokens.common.date_2]: '日付',
    [tokens.common.daily_inventory]: '日在庫',
    [tokens.common.daily_inventory_product_selection]: '日在庫商品選択',
    [tokens.common.daily_inventory_individual_order_impossible]: '日在庫商品は個別発注が不可能です。発注商品を再確認してください',
    [tokens.common.daily_inventory_order_center_requirement]: '日在庫選択時、注文可能センターは1個以上入力される必要があります',
    [tokens.common.daily_inventory_only_disposal_possible]: '日在庫は廃棄のみ可能',
    [tokens.common.daily_inventory_no_joint_statement_with_storage]: '日在庫と保管在庫は一緒に精算書を作成できません。確認後、再選択してください',
    [tokens.common.daily_average_sales]: '日平均販売量',
    [tokens.common.average_daily_sales_volume]: '日平均販売量',
    [tokens.common.view_imminent_products_only]: '差し迫った商品だけ表示',
    [tokens.common.imminent_rate]: '差し迫り率',
    [tokens.common.temporary_adjustment_limit_amount]: '臨時調整限度金額',
    [tokens.common.temporary_adjustment_limit_required]: '臨時調整限度金額は必須です',
    [tokens.common.temporary_adjustment_limit_end_date]: '臨時調整限度適用終了日',
    [tokens.common.temporary_adjustment_limit_end_date_required]: '臨時調整限度適用終了日は必須です',
    [tokens.common.temporary_order_restriction_date_setting]: '臨時注文制限日設定',
    [tokens.common.all_products_order_prohibited_during_period]: '期間中はすべての商品が注文不可',
    [tokens.common.inbound.receiving]: '入庫',
    [tokens.common.inbound.receiving_management]: '入庫管理',
    [tokens.common.inbound.receiving_unit]: '入庫単位',
    [tokens.common.inbound.receiving_available_days]: '入庫可能曜日',
    [tokens.common.inbound.receiving_available_days_required]: '入庫可能曜日は必須です',
    [tokens.common.inbound.receiving_manager]: '入庫担当者',
    [tokens.common.inbound.receiving_manager_contact]: '入庫担当者連絡先',
    [tokens.common.inbound.waiting_for_receiving]: '入庫待ち',
    [tokens.common.inbound.no_receiving_waiting_tasks]: '入庫待ち作業がありません',
    [tokens.common.inbound.receiving_list]: '入庫リスト',
    [tokens.common.inbound.receiving_deadline_time]: '入庫締切時間',
    [tokens.common.inbound.receiving_deadline_time_required]: '入庫締切時間は必須です',
    [tokens.common.inbound.enter_receiving_deadline_time]: '入庫締切時間を入力してください',
    [tokens.common.inbound.receiving_shipping_info]: '入庫・配送情報',
    [tokens.common.inbound.receiving_settings]: '入庫設定',
    [tokens.common.inbound.receiving_center]: '入庫センター',
    [tokens.common.inbound.select_receiving_center]: '入庫センター選択',
    [tokens.common.inbound.number_of_receivings]: '入庫数',
    [tokens.common.inbound.receiving_slots]: '入庫スロット',
    [tokens.common.inbound.receiving_slot_list]: '入庫スロットリスト',
    [tokens.common.inbound.receiving_slot_list_product_details]: '入庫スロットリスト商品詳細',
    [tokens.common.inbound.receiving_slot_details]: '入庫スロット詳細',
    [tokens.common.inbound.receiving_slot_time]: '入庫スロット時間',
    [tokens.common.inbound.quantity_at_receiving]: '入庫時入数',
    [tokens.common.inbound.receiving_start_time]: '入庫開始時間',
    [tokens.common.inbound.receiving_expected_time]: '入庫予定時間',
    [tokens.common.inbound.receiving_start_time_fixed]: '入庫開始時間はに固定',
    [tokens.common.inbound.nighttime_receiving_slot]: '入庫夜間スロット',
    [tokens.common.inbound.scheduled_receiving]: '入庫予定',
    [tokens.common.inbound.scheduled_receiving_time]: '入庫予定時間',
    [tokens.common.inbound.scheduled_receiving_time_weekday_weekend]: '入庫予定時間(平日/週末)',
    [tokens.common.inbound.scheduled_receiving_date]: '入庫(予定)日',
    [tokens.common.inbound.scheduled_receiving_document_storage]: '入庫予定書保管',
    [tokens.common.inbound.scheduled_receiving_datetime]: '入庫予定日時',
    [tokens.common.inbound.receiving_quantity]: '入庫数量',
    [tokens.common.inbound.receiving_quantity_less_than_ordered]:
        '発注数量より実際の入庫数量が少ないです。選択された発注内訳が入荷処理され、入庫確認書が発行されます。その後は修正できません。本当に強制入庫を登録しますか？',
    [tokens.common.inbound.requested_receiving_date]: '入庫リクエスト日',
    [tokens.common.inbound.receiving_info]: '入庫情報',
    [tokens.common.inbound.receiving_expected_info]: '入荷予定情報',
    [tokens.common.inbound.weekly_receiving_slot]: '入庫週間スロット',
    [tokens.common.inbound.processed_receiving_quantity]: '入庫処理数量',
    [tokens.common.inbound.processed_receiving_datetime]: '入庫処理日時',
    [tokens.common.inbound.receiving_code]: '入庫コード',
    [tokens.common.inbound.receiving_confirmation_process]: '入庫確認処理',
    [tokens.common.inbound.receiving_confirmation_completed]: '入庫確認処理が完了しました',
    [tokens.common.inbound.receiving_confirmation_document]: '入庫確認書',
    [tokens.common.inbound.receiving_confirmation_final_document]: '入庫確認書 入庫確定書',
    [tokens.common.inbound.receiving_method]: '入庫方式',
    [tokens.common.inbound.completed_receiving_eligible_for_statement_creation]:
        '入庫が完了した履歴のみ精算書作成が可能です。確認後、再選択してください',
    [tokens.common.inbound.select_available_receiving_days]: '入庫可能曜日選択',
    [tokens.common.inbound.available_receiving_days_required]: '入庫可能曜日は必須です',
    [tokens.common.inbound.receiving_result]: '入庫結果',
    [tokens.common.inbound.waiting_for_receiving_status]: '入庫待ち',
    [tokens.common.inbound.emergency_release_disabled_in_waiting_for_receiving]: '入庫待ち状態では緊急出庫は無効です',
    [tokens.common.inbound.deadline_for_receiving]: '入庫締切',
    [tokens.common.inbound.deadline_minutes_for_receiving_required]: '入庫締切分は必須です',
    [tokens.common.inbound.deadline_time_for_receiving_required]: '入庫締切時間は必須です',
    [tokens.common.inbound.closing_time_for_receiving]: '入庫締切時間',
    [tokens.common.inbound.receiving_status]: '入庫状態',
    [tokens.common.inbound.receiving_settings_completed]: '入庫設定の登録が完了しました',
    [tokens.common.inbound.scheduled_receiving_center]: '入庫センター/入庫予定日',
    [tokens.common.inbound.scheduled_receiving_datetime_center]: '入庫センター/入庫日時',
    [tokens.common.inbound.receiving_center_required]: '入庫センターは必須です',
    [tokens.common.inbound.received_quantity]: '入庫数量',
    [tokens.common.inbound.received_quantity_unit]: '入庫数量／単位',
    [tokens.common.inbound.received_quantity_order_unit]: '入庫数量/発注単位',
    [tokens.common.inbound.stocking_slot_force_order_request_document_product_lookup]: '入庫スロット 強制入庫 発注リクエスト書 商品照会',
    [tokens.common.inbound.scheduled_to_be_in_stock]: '入庫予定',
    [tokens.common.inbound.expected_stock_quantity]: '入庫予定数量',
    [tokens.common.inbound.expected_stock_quantity_order_unit]: '入庫予定数量/発注単位',
    [tokens.common.inbound.expected_arrival_date]: '入庫予定日',
    [tokens.common.inbound.expected_arrival_time]: '入庫予定時間',
    [tokens.common.inbound.expected_plt_count]: 'PLT数',
    [tokens.common.inbound.expected_plt_count_time]: 'PLT数／入庫時間',
    [tokens.common.inbound.expected_arrival_date_time_count]: '入庫予定日 / 時間 / PLT数',
    [tokens.common.inbound.stock_completed]: '入庫完了',
    [tokens.common.inbound.receiving_request_more_than_stock_quantity]: '入庫リクエスト数量より実際の入庫数量が多いです。数量を調整してください',
    [tokens.common.inbound.stock_request_date]: '入庫リクエスト日',
    [tokens.common.inbound.select_stock_request_date]: '入庫リクエスト日選択',
    [tokens.common.inbound.date_of_receipt]: '入庫日',
    [tokens.common.inbound.date_of_receipt_period]: '入庫日 期間',
    [tokens.common.inbound.date_of_arrival]: '入庫日時',
    [tokens.common.inbound.place_of_receipt]: '入庫地',
    [tokens.common.inbound.receiving_processing]: '入庫処理',
    [tokens.common.inbound.receiver]: '入庫処理者',
    [tokens.common.inbound.receiving_invoice_no]: 'INVOICE NO',
    [tokens.common.inbound.receiving_invoice_no_input]: 'INVOICE NO 入力',
    [tokens.common.inbound.confirm_receipt]: '入庫確認',
    [tokens.common.inbound.receipt_confirmed_by]: '入庫確認者',
    [tokens.common.inbound.search_receipt_confirmer]: '入庫確認者 検索',
    [tokens.common.inbound.receipt_confirmer_info]: '入庫確認者 情報',
    [tokens.common.inbound.select_receipt_confirmer]: '入庫確認者を検索し/て選択してください',
    [tokens.common.inbound.confirmed_receipt]: '入庫確定',
    [tokens.common.inbound.confirmed_receipt_date]: '入庫確定日',
    [tokens.common.inbound.scheduled_receiving_quantity_input]: '入荷予定数量入力',
    [tokens.common.inbound.scheduled_receiving_quantity_unit]: '入荷予定数量 / 単位',
    [tokens.common.inbound.total_amount]: '総入庫金額',
    [tokens.common.inbound.receiving_expected_excel_registration]: '入荷予定書エクセル登録',
    [tokens.common.inbound.receiving_expected_lot_no]: '入荷予定LOT番号',
    [tokens.common.inbound.receiving_expected_lot_no_input]: '入荷予定LOT番号を入力',
    [tokens.common.inbound.receiving_expected_goods_remark]: '入荷商品の特記事項',
    [tokens.common.inbound.receiving_expected_goods_remark_input]: '入荷商品の特記事項を入力',

    [tokens.common.deposit]: '入金',
    [tokens.common.deposit_account_info]: '入金 口座情報',
    [tokens.common.deposit_processing]: '入金処理',
    [tokens.common.deposit_amount_processing]: '入金処理 金額',
    [tokens.common.deposit_reason]: '入金処理 理由',
    [tokens.common.deposit_immediate_reflection]: '入金処理時に即座に債権に反映されるため、確認後に適用してください',
    [tokens.common.location_label_print_for_input_quantity]: '入力数量分 ロケーションラベル 出力',
    [tokens.common.quantity_received]: '入数',
    [tokens.common.quantity_received_per_order_unit]: '入数 注文単位',
    [tokens.common.waiting_for_entry]: '入車 待機中',
    [tokens.common.entry_instructions_completed]: '入車指示が完了しました',
    [tokens.common.in_stock_processing]: '入荷処理',
    [tokens.common.in_stock_processing_completed]: '入荷処理が完了しました',
    [tokens.common.automatic]: '自動',
    [tokens.common.automatic_ordering]: '自動発注',
    [tokens.common.automatic_ordering_manual]: '自動発注 手動発注',
    [tokens.common.automatic_declaration_processing]: '自動申告処理',
    [tokens.common.automatic_refund]: '自動返金',
    [tokens.common.automatic_ordering_not_available]: '自動発注を選択できません',
    [tokens.common.seating_required]: '6席以上を入力してください',
    [tokens.common.frequently_asked_questions]: 'よくある質問',
    [tokens.common.faq_registration_completed]: 'よくある質問 登録が完了しました',
    [tokens.common.faq_deletion]: 'よくある質問 削除',
    [tokens.common.faq_details]: 'よくある質問 詳細',
    [tokens.common.faq_modification]: 'よくある質問 修正',
    [tokens.common.faq_registration]: 'よくある質問 登録',
    [tokens.common.self_disposal]: '自主廃棄',
    [tokens.common.no_work_without_history]: '作業履歴がない場合は実行されないように',
    [tokens.common.no_work_target_list]: '作業対象リストがありません',
    [tokens.common.work_completion_datetime]: '作業完了日時',
    [tokens.common.select_option_for_work_instruction]: '作業を指示するオプションを選択してください',
    [tokens.common.remaining_amount]: '残量',
    [tokens.common.remaining_days]: '残余日',
    [tokens.common.remaining_days_count]: '残余日数',
    [tokens.common.frequent_mass_data_upload_warning]:
        '頻繁な大量データのアップロードはサーバーに負荷をかけ、顧客の注文や出庫に影響を与える可能性があるため、ファイルを再度確認してください',
    [tokens.common.frequent_statement_creation_deletion_warning]:
        '頻繁な精算書の作成・削除はシステムの過負荷の主な原因となるため、再度確認し、慎重に処理してください',
    [tokens.common.re_recovery_status]: '(再)回収状態',
    [tokens.common.re_recovery_scheduled_date]: '(再)回収予定日',
    [tokens.common.re_recovery_completion_date]: '(再)回収完了日',
    [tokens.common.re_recovery_code]: '(再)回収コード',
    [tokens.common.contract_renewal]: '再契約',
    [tokens.common.contract_renewal_termination]: '契約終了',
    [tokens.common.contract_renewal_processed]: '再契約処理が完了しました',
    [tokens.common.contract_renewal_processing_warning]:
        '再契約処理時には新しい仮想口座番号が付与され、既存の契約情報が復元されるため、必ず再確認後に試してください。',
    [tokens.common.contract_renewal_confirmation]: '再契約処理を行いますか',
    [tokens.common.contract_renewal_completed]: '再契約処理が完了しました',
    [tokens.common.inventory_classification_1]: '在庫区分',
    [tokens.common.inventory_classification_2]: '在庫区分',
    [tokens.common.inventory_order_classification]: '在庫区分 / 発注区分',
    [tokens.common.inventory_list]: '在庫リスト',
    [tokens.common.inventory_snapshot_list]: '在庫リストのスナップショット',
    [tokens.common.inventory_list_details]: '在庫リスト詳細',
    [tokens.common.inventory_replenishment]: '在庫補充',
    [tokens.common.inventory_replenishment_order]: '在庫補充指示',
    [tokens.common.inventory_discrepancy_view_only]: '在庫不一致商品のみ表示',
    [tokens.common.inventory_depletion_view_only]: '在庫消尽商品のみ表示',
    [tokens.common.inventory_depletion_rate]: '在庫消尽率',
    [tokens.common.inventory_quantity]: '在庫数量',
    [tokens.common.inventory_ledger_finalization]: '在庫台帳確定',
    [tokens.common.inventory_ledger_finalization_confirmation]: '在庫台帳確定処理を行う場合、パスワードを入力してください',
    [tokens.common.inventory_information]: '在庫情報',
    [tokens.common.inventory_audit]: '在庫監査',
    [tokens.common.last_week_1]: '先週',
    [tokens.common.low_temperature]: '低温',
    [tokens.common.low_temperature_frozen]: '低温 冷凍',
    [tokens.common.save]: '保存',
    [tokens.common.save_register]: '登録',
    [tokens.common.save_add]: '保存追加',
    [tokens.common.save_confirm]: '保存·確定',
    [tokens.common.save_completed]: '保存が完了しました',
    [tokens.common.apply_period]: '適用期間',
    [tokens.common.apply_edit]: '適用修正',
    [tokens.common.apply_start_date]: '適用開始日',
    [tokens.common.apply_end_date]: '適用終了日',
    [tokens.common.select_apply_end_date]: '適用終了日選択',
    [tokens.common.number_of_applicable_products]: '適用商品数',
    [tokens.common.expected_date_of_application]: '適用予定日',
    [tokens.common.expected_date_of_application_required]: '適用予定日は必須です',
    [tokens.common.date_of_application]: '適用日',
    [tokens.common.until_the_date_of_application]: '適用日まで既存の与信限度額が臨時調整限度額に変更されます',
    [tokens.common.date_of_application_required]: '適用日は必須です',
    [tokens.common.applying]: '適用中',
    [tokens.common.accumulation_amount]: '積載 SKU 数',
    [tokens.common.accumulation_period]: '積載期間',
    [tokens.common.status_of_accumulation]: '積載状態',
    [tokens.common.accumulation_rate]: '積載率',
    [tokens.common.accumulation_rate_replenishment_order]: '積載率基準補充指示',
    [tokens.common.view_below_accumulation_rate]: '積載率 {{automaticReplenishmentLessPercent}}未満表示',
    [tokens.common.automatic_replenishment_below_accumulation_rate]:
        '*積載率が {{automaticReplenishmentLessPercent}}% 未満になると自動的に在庫補充が指示されます',
    [tokens.common.jeonnam]: '全南',
    [tokens.common.computation_expiration_date]: '計算 賞味期限',
    [tokens.common.computation_quantity]: '計算 数量',
    [tokens.common.forwarding]: '転送',
    [tokens.common.exclusive_products]: '専用商品',
    [tokens.common.entire]: '全体',
    [tokens.common.register_as_entire_exposure]: '全体露出状態で登録',
    [tokens.common.register_as_entire_non_exposure]: '全体未露出状態で登録',
    [tokens.common.entire_non_exposed_included]: '全体未露出商品が含まれています',
    [tokens.common.entire_non_exposed_product]: '全体未露出商品です',
    [tokens.common.view_all_products]: '全体商品を見る',
    [tokens.common.entire_receiving_results]: '全体入庫結果',
    [tokens.common.view_entire_receiving_history]: '全体入庫履歴を見る',
    [tokens.common.entire_receiving_status]: '全体入庫状態',
    [tokens.common.entire_receiving_slots]: '全体入庫スロット',
    [tokens.common.entire_picking_list]: '全体ピッキングリスト',
    [tokens.common.entire_total_amount]: '全体合計金額',
    [tokens.common.phone_number]: '電話番号',
    [tokens.common.enter_phone_number]: '電話番号を入力',
    [tokens.common.enter_phone_number_prompt]: '電話番号を入力してください',
    [tokens.common.enter_phone_number_please]: '電話番号を入力してください',
    [tokens.common.lunch]: '昼食時間',
    [tokens.common.lunch_start_time]: '昼食開始時間',
    [tokens.common.lunch_end_time]: '昼食終了時間',
    [tokens.common.lunch_time_required]: '昼食時間は必須設定で保存が可能です',
    [tokens.common.no_access_rights]: 'アクセス権限がありません',
    [tokens.common.receipt_reason]: '受付理由',
    [tokens.common.receipt_reason_required]: '受付理由は必須です',
    [tokens.common.receipt_quantity]: '受付数量',
    [tokens.common.acceptable_quantity]: '受付可能数量',
    [tokens.common.reason_for_submission]: '受付理由',
    [tokens.common.date_of_receipt]: '受付日',
    [tokens.common.confirm_receipt_change]: '受付した相談状態を変更しますか',
    [tokens.common.really_delete_reservation]: '本当に変更予約件を削除しますか',
    [tokens.common.really_delete]: '本当に削除しますか',
    [tokens.common.really_delete_holiday]: '本当に休日を削除しますか',
    [tokens.common.information]: '情報',
    [tokens.common.copy_information]: '情報コピー',
    [tokens.common.batch_edit_information]: '情報一括修正',
    [tokens.common.batch_edit_information_file]: '情報一括修正 - Excel ファイル',
    [tokens.common.payment_date]: '決済日',
    [tokens.common.settlement_payment_date]: '精算 決済日',
    [tokens.common.settlement_payment_date_required]: '精算 決済日は必須です',
    [tokens.common.settlement_base_date]: '精算基準日',
    [tokens.common.settlement_base_date_cannot_be_earlier]: '精算基準日は決済日より早くできません',
    [tokens.common.settlement_base_date_required]: '精算基準日は必須です',
    [tokens.common.settlement_edit]: '精算 修正',
    [tokens.common.settlement_total_amount]: '精算合計金額',
    [tokens.common.confirm_settlement]: '精算確定',
    [tokens.common.settlement_classification]: '精算区分',
    [tokens.common.settlement_period]: '精算期間',
    [tokens.common.settlement_standard_payment_date]: '精算基準(決済日)',
    [tokens.common.settlement_date]: '精算基準日',
    [tokens.common.settlement_year_and_month]: '精算年月',
    [tokens.common.settlement_status]: '精算状態',
    [tokens.common.settlement_document]: '精算書',
    [tokens.common.settlement_document_ID]: '精算書 ID',
    [tokens.common.renew_settlement_document]: '精算書 更新',
    [tokens.common.settlement_document_purchase_station]: '精算書 買い付け先',
    [tokens.common.view_uncreated_settlement_document]: '未作成の精算書の履歴のみ表示',
    [tokens.common.add_return_details_to_settlement_document]: '精算書に返品内訳を追加',
    [tokens.common.delete_settlement_document]: '精算書 削除',
    [tokens.common.create_settlement_document]: '精算書作成',
    [tokens.common.settlement_document_creation_completed]: '精算書作成が完了しました',
    [tokens.common.edit_settlement_document]: '精算書 修正',
    [tokens.common.resend_settlement_document_1]: '精算書 再送信',
    [tokens.common.settlement_document_modification_not_possible]: '精算書確定後は修正が不可能です',
    [tokens.common.settlement_document_modification_not_possible2]: '精算書が送信されます',
    [tokens.common.settlement_document_sent]: '精算書が送信されました',
    [tokens.common.settlement_document_modification_not_possible_due_to_creation]: '精算書が作成されているため、買い付け価格の修正が不可能です',
    [tokens.common.resend_settlement_document_2]: '精算書を再送信',
    [tokens.common.resend_settlement_document_prompt]: '精算書を再送信しますか？',
    [tokens.common.frequent_creation_deletion_of_settlement_document]:
        '精算書を再送信しますか。精算書の頻繁な作成・削除はシステムの過負荷の主な原因となるため、再度確認し、慎重に処理してください',
    [tokens.common.check_settlement_document]: '精算書確認',
    [tokens.common.settlement_date_required]: '精算日は必須です',
    [tokens.common.normal]: '正常',
    [tokens.common.normal_operation_close]: '正常動作したら閉じる',
    [tokens.common.normal_success]: '正常成功',
    [tokens.common.normal_shipping_processing]: '正常出庫処理',
    [tokens.common.normal_shipping_no_logistics_code]: '正常出庫処理 - 選択された物流コードがありません',
    [tokens.common.normal_shipping_completed]: '正常出庫処理が完了しました',
    [tokens.common.normal_shipping_confirm]: '正常出庫処理を行いますか',
    [tokens.common.order_transferred_normally]: '正常に注文が移管されました',
    [tokens.common.correction_request_management_return]: '訂正要請管理返品',
    [tokens.common.suspension_date]: '停止日',
    [tokens.common.warning_confirm_inout_history]: '在庫出納簿を最終確定処理しますか？確定処理後には修正できません。',
    [tokens.common.finalization_inout_history]: '在庫出納簿の確定',
    [tokens.common.completed_inout_history]: '在庫出納簿の確定が完了しました',
    [tokens.common.inout_history]: '在庫出納簿',
    [tokens.common.empty_page_inout_history]: '在庫出納簿の明細は存在しません。',
    [tokens.common.title]: 'タイトル',
    [tokens.common.title_required]: 'タイトルは必須です',
    [tokens.common.enter_title]: 'タイトルを入力してください',
    [tokens.common.product_inquiry]: '製品問い合わせ',
    [tokens.common.investigation_result_reflection]: '調査結果 反映有無',
    [tokens.common.select_investigation_result_reflection]: '調査結果 反映有無を選択してください',
    [tokens.common.select_investigation_year]: '調査年度選択',
    [tokens.common.investigation_year_query]: '調査年度 照会',
    [tokens.common.investigation_status_1]: '調査状態',
    [tokens.common.select_investigation]: '調査選択',
    [tokens.common.investigation_expiration_date]: '調査 賞味期限',
    [tokens.common.investigation_quantity]: '調査 数量',
    [tokens.common.investigation_lot]: '調査 LOT',
    [tokens.common.investigation_upload]: '調査 アップロード',
    [tokens.common.investigation_status_check_1]: '調査有無',
    [tokens.common.completed_investigation_unsurveyed]: '調査有無 完了 未調査',
    [tokens.common.investigation_completion_datetime]: '調査完了日時',
    [tokens.common.investigation_datetime]: '調査日時',
    [tokens.common.investigation_order_datetime]: '調査指示日時',
    [tokens.common.survey_year]: '調査年度',
    [tokens.common.investigation_status_2]: '調査状態',
    [tokens.common.investigation_status_check_2]: '調査有無',
    [tokens.common.adjustment]: '調整',
    [tokens.common.adjustment_classification]: '調整区分',
    [tokens.common.adjustment_classification_required]: '調整区分は必須です',
    [tokens.common.adjustment_amount]: '調整金額',
    [tokens.common.adjustment_date_1]: '調整年月日',
    [tokens.common.adjustment_reason]: '調整理由',
    [tokens.common.enter_adjustment_reason]: '調整理由を入力してください',
    [tokens.common.adjustment_reason_detailed]: '調整理由が詳細に記載されていない場合、調整内容が差し戻される可能性があります',
    [tokens.common.enter_adjustment_reason_prompt]: '調整理由を入力してください',
    [tokens.common.adjustment_expiration_date]: '調整 賞味期限 年月日',
    [tokens.common.adjustment_quantity]: '調整数量',
    [tokens.common.enter_adjustment_quantity]: '調整数量を入力してください',
    [tokens.common.enter_adjustment_lot_no]: '調整LOT入力',
    [tokens.common.prompt_adjustment_quantity]: '調整数量を入力してください',
    [tokens.common.adjustment_impacts_reservation]: '調整時、既存の予約情報は削除され、変更内容が一括で適用されます',
    [tokens.common.adjustment_type_1]: '調整タイプ',
    [tokens.common.select_adjustment_type]: '調整タイプを選択',
    [tokens.common.choose_adjustment_type]: '調整タイプを選択してください',
    [tokens.common.adjustment_effective_date]: '調整適用日',
    [tokens.common.adjustment_before_expiration]: '調整前の賞味期限',
    [tokens.common.adjustment_before_lot_no]: '調整前LOT',
    [tokens.common.adjustment_before_quantity]: '調整前数量',
    [tokens.common.adjustment_method_required]: '調整処理方式は必須です',
    [tokens.common.adjustment_confirm]: '調整確定',
    [tokens.common.adjustment_after_expiration]: '調整後の賞味期限',
    [tokens.common.adjustment_after_lot_no]: '調整後LOT',
    [tokens.common.adjustment_after_quantity]: '調整後数量',
    [tokens.common.adjustment_category]: '調整区分',
    [tokens.common.adjustment_fee]: '調整金',
    [tokens.common.adjustment_fee_details]: '調整金明細',
    [tokens.common.adjustment_fee_processing]: '調整金処理',
    [tokens.common.adjustment_fee_processing_query]: '調整金処理明細照会',
    [tokens.common.no_adjustment_fee_processing]: '調整金処理の明細がありません',
    [tokens.common.adjustment_fee_processing_target]: '調整金処理対象の中に前払い売上先が存在します',
    [tokens.common.adjustment_fee_processing_impact]:
        '調整金処理時、調整金額が即座に債権に反映され、精算書に反映されるため、再度確認後に処理してください',
    [tokens.common.no_adjustment_fee_details]: '調整金処理の明細がありません',
    [tokens.common.adjustment_fee_processing_unavailable]: '調整金処理を行うことができません',
    [tokens.common.select_adjustment_fee_liability]: '調整金処理による責任選択',
    [tokens.common.select_adjustment_fee_category]: '調整金処理によるカテゴリー選択',
    [tokens.common.adjustment_amount_added]: '調整金額の追加が完了しました',
    [tokens.common.reason_for_adjustment]: '調整理由',
    [tokens.common.adjusted_quantity]: '調整数量',
    [tokens.common.adjustment_type_2]: '調整タイプ',
    [tokens.common.adjustment_type_expiration_adjustment]: '調整タイプ 賞味期限調整',
    [tokens.common.adjustment_type_disposal_loss_recovery]: '調整タイプ 廃棄 損失処理 損失復旧',
    [tokens.common.adjustment_date_2]: '調整日',
    [tokens.common.coordinator]: '調整者',
    [tokens.common.search_coordinator]: '調整者検索',
    [tokens.common.coordinator_info]: '調整者情報',
    [tokens.common.select_coordinator]: '調整者を検索して選択してください',
    [tokens.common.adjustment_processing_datetime]: '調整処理年月日時分',
    [tokens.common.adjustment_processing_details]: '調整処理内容',
    [tokens.common.adjustment_processor]: '調整処理者',
    [tokens.common.approved_by_organization_leader]: '組織長 チーム長の承認が完了した件です',
    [tokens.common.calculate_date_from_today]: '照会日計算 現在基準で日',
    [tokens.common.search_basis]: '照会基準',
    [tokens.common.no_incoming_logistics_details_found]: '照会された幹線入庫明細がありません',
    [tokens.common.no_results_found]: '照会された結果がありません',
    [tokens.common.no_details_found]: '照会された明細がありません',
    [tokens.common.no_contents_found]: '照会された内容がありません',
    [tokens.common.no_inventory_info_found]: '照会された在庫情報がありません',
    [tokens.common.no_order_details_found]: '照会された注文明細がありません',
    [tokens.common.view_only_terminated_products]: '終結商品だけを見る',
    [tokens.common.terminated_products_included]: '終結商品が含まれています。発注商品を再確認してください',
    [tokens.common.end]: '終了',
    [tokens.common.end_date]: '終了日',
    [tokens.common.end_date_required]: '終了日は必須です',
    [tokens.common.imminent_termination]: '終了間近',
    [tokens.common.employee_id]: '従業者番号',
    [tokens.common.main_weekly_delivery]: '主 {{weeklyDeliveryCount}}日 配送',
    [tokens.common.weekly]: '週間',
    [tokens.common.day_night_cycle]: '昼夜サイクル',
    [tokens.common.weekend]: '週末',
    [tokens.common.weekend_closure]: '週末締め',
    [tokens.common.no_weekend]: '週末なし',
    [tokens.common.order]: '注文',
    [tokens.common.order_available_center]: '注文可能センター',
    [tokens.common.order_management]: '出荷管理',
    [tokens.common.order_received]: '注文受付',
    [tokens.common.order_management_excel_download]: '出荷管理 エクセルダウンロード',
    [tokens.common.order_management_detail_excel_download]: '出荷管理詳細Excelダウンロード',
    [tokens.common.order_management_excel_upload_failure]: '出荷管理 エクセルアップロード失敗',
    [tokens.common.order_amount]: '注文金額',
    [tokens.common.order_history]: '注文明細',
    [tokens.common.excel_month_limit]: 'Excelのダウンロードは最大31日まで可能です。照会期間を31日以内にもう一度選択してください。',
    [tokens.common.no_order_history]: '注文明細がありません',
    [tokens.common.order_download_limit]: '注文ダウンロードは {{totalOrderExcelDownload}} 件まで可能です',
    [tokens.common.order_unit]: '注文単位',
    [tokens.common.order_unit_specification]: '注文単位規格',
    [tokens.common.order_deadline]: '注文締め時間',
    [tokens.common.order_deadline_required]: '注文締め時間は必須です',
    [tokens.common.order_deadline_format_incorrect]: '注文締め時間の形式が正しくありません',
    [tokens.common.order_sales_selection]: '注文(売上)選択',
    [tokens.common.order_frequency]: '注文頻度',
    [tokens.common.order_detail]: '注文詳細',
    [tokens.common.order_products]: '注文商品',
    [tokens.common.order_quantity]: '注文数量',
    [tokens.common.order_upload]: '注文アップロード',
    [tokens.common.order_AdrVerify]: 'アドレス検証',
    [tokens.common.order_upload_limit]: '注文アップロードは一度に最大 {{orderUploadLimit}}件まで可能です',
    [tokens.common.order_upload_brand_warning]: '一つの受注番号には同一ブランドの商品のみアップロードしてください。',
    [tokens.common.order_moment]: '注文日時',
    [tokens.common.order_info_excel_file]: '注文情報 EXCELファイル',
    [tokens.common.order_content]: '注文内容',
    [tokens.common.cancel_order]: '注文キャンセル',
    [tokens.common.order_cancellation_process]: '注文キャンセル時',
    [tokens.common.order_cancellation_no_logistic_code]: '注文キャンセル - 選択された出荷物流コードがありません。',
    [tokens.common.order_cancellation_no_orders]: '選択した注文はありません。',
    [tokens.common.order_cancellation_immediate]:
        '注文キャンセル時、商品を即時に注文キャンセルします。注文キャンセル時、自動的に返金されるため、再度確認後に慎重に処理してください',
    [tokens.common.order_receive_cancellation]: '注文をキャンセルすると、商品をすぐに注文をキャンセルします。注文をキャンセルしますか？',
    [tokens.common.order_cancellation_completed]: '注文キャンセルが完了しました',
    [tokens.common.order_amount_vat_included]: '注文金額を VAT 含む',
    [tokens.common.order_unit_temperature]: '注文単位 / 品温',
    [tokens.common.order_deadline_minute_weekend]: '注文締め 分 週末 は 桁以内で入力してください',
    [tokens.common.order_deadline_minute_weekday]: '注文締め 分 平日は 桁以内で入力してください',
    [tokens.common.order_deadline_weekend]: '注文締め時間 週末',
    [tokens.common.order_deadline_weekend_required]: '注文締め時間 週末は 桁以内で入力してください',
    [tokens.common.order_deadline_weekday]: '注文締め時間 平日',
    [tokens.common.order_deadline_weekday_required]: '注文締め時間 平日は 桁以内で入力してください',
    [tokens.common.order_number]: '注文番号',
    [tokens.common.order_unavailable_days]: '注文不可曜日',
    [tokens.common.order_status]: '注文状態',
    [tokens.common.ordered_product_inventory_deduction]: '注文商品 使用可能在庫減算',
    [tokens.common.order_selection]: '注文選択',
    [tokens.common.order_date_query]: '注文日 照会',
    [tokens.common.order_date_and_time]: '注文日時',
    [tokens.common.receipt_date_and_time]: '受付日時',
    [tokens.common.receipt_date]: '受付日',
    [tokens.common.address_verification]: '住所検証',
    [tokens.common.address_verified]: '通過',
    [tokens.common.address_unverified]: '住所未検証',
    [tokens.common.outbound_requestable]: '依頼可能',
    [tokens.common.outbound_request_done]: '依頼済',
    [tokens.common.outbound_request_failed]: '依頼失敗',
    [tokens.common.outbound_fail_not_received]: '受付状態ではない',
    [tokens.common.outbound_fail_stock_shortage]: '在庫不足',
    [tokens.common.outbound_fail_invoice_rejected]: '送り状採番拒否',
    [tokens.common.outbound_fail_no_history]: '失敗履歴がありません',
    [tokens.common.outbound_fail_date]: '日時',
    [tokens.common.label_partially_printed]: '送り状 {{count}}件が出力されませんでした。一覧をファイルに保存しました。',
    [tokens.common.order_channel]: '注文チャンネル',
    [tokens.common.select_order_channel]: '注文チャンネルを選択',
    [tokens.common.withdraw_order]: '注文取消',
    [tokens.common.withdraw_order_no_logistics_code]: '注文取消 選択された出庫物流コードがありません',
    [tokens.common.order_code]: '注文コード',
    [tokens.common.purchase_code]: '発注コード',
    [tokens.common.search_order_code]: '注文コード検索',
    [tokens.common.order_code_sales_product_name]: '注文コード 売上先 商品 商品名',
    [tokens.common.order_confirmed]: '注文確定',
    [tokens.common.address]: '住所',
    [tokens.common.search_address]: '住所検索',
    [tokens.common.address_detail]: '住所詳細',
    [tokens.common.address_search]: '住所検索',
    [tokens.common.address_required]: '住所は必須です',
    [tokens.common.precautions_confirmed]: '注意事項を確認しました',
    [tokens.common.preparing]: '準備中',
    [tokens.common.current_excel_coming_soon]: '現在、Excelダウンロード機能を準備しています。',
    [tokens.common.duplicated_category_name]: '重複したカテゴリ名が存在します',
    [tokens.common.middle_classification]: '中分類',
    [tokens.common.select_middle_classification]: '中分類選択',
    [tokens.common.middle_classification_required_if_adding]: '中分類カテゴリー追加時、大分類は必須です',
    [tokens.common.middle_classification_required]: '中分類カテゴリーは必須です',
    [tokens.common.middle_classification_is_required]: '中分類は必須です',
    [tokens.common.immediate_regulation_termination]: '即時規制終了',
    [tokens.common.favorites_only]: 'お気に入りのみ表示',
    [tokens.common.payment_amount_3]: '支払額',
    [tokens.common.last_month]: '先月',
    [tokens.common.last_week_2]: '先週',
    [tokens.common.branch_line]: '支線',
    [tokens.common.branch_route]: '支線ルート',
    [tokens.common.branch_route_detail]: '支線ルート詳細',
    [tokens.common.adjust_feeder_route]: '支線ルート修正',
    [tokens.common.instruction]: '指示',
    [tokens.common.irreversible_instruction_warning]: '指示後は取り消せず、次の作業ステップに移行します',
    [tokens.common.no_inventory_replenishment_instruction]: '指示された在庫補充の内訳がありません',
    [tokens.common.indicator]: '指示者',
    [tokens.common.search_indicator]: '指示者検索',
    [tokens.common.indicator_info]: '指示者情報',
    [tokens.common.select_indicator]: '指示者を検索して選択してください',
    [tokens.common.designation_needed]: '指定必要',
    [tokens.common.direct_shipping]: '直送',
    [tokens.common.direct_shipping_order_impossible]: '直送商品は個別発注ができません。発注商品を再確認してください',
    [tokens.common.direct_shipping_receipt]: '直送 入庫確認書',
    [tokens.common.direct_input]: '直接入力',
    [tokens.common.direct_input_selection]: '直接入力選択の場合',
    [tokens.common.entry_method_details]: '進入方法詳細',
    [tokens.common.progress_status]: '進行状態',
    [tokens.common.in_progress]: '進行中 調査ロケーション数 総ロケーション数',
    [tokens.common.deducted]: '差し引き',
    [tokens.common.deducted_payment_amount]: '差し引き支払額',
    [tokens.common.vehicle]: '車両情報',
    [tokens.common.no_vehicle_information]: '車両情報がありません',
    [tokens.common.vehicle_classification_fixed_departures]: '車両区分 : 固定 / 出庫回数 : {{totalDlv}}',
    [tokens.common.vehicle_number]: '車両番号',
    [tokens.common.vehicle_number_more]: '車両番号 さらに',
    [tokens.common.vehicle_number_maximum_entries]: '車両番号 最大 10桁以内で入力してください',
    [tokens.common.vehicle_number_minimum_entries]: '車両番号 最小 7桁以内で入力してください',
    [tokens.common.vehicle_number_required]: '車両番号を必須で入力してください',
    [tokens.common.vehicle_cost]: '車両費用',
    [tokens.common.vehicle_information]: '車両情報',
    [tokens.common.vehicle_information_details]: '車両情報 詳細',
    [tokens.common.landing]: '着地',
    [tokens.common.select_landing]: '着地選択',
    [tokens.common.find]: '検索',
    [tokens.common.bonds]: '債権管理',
    [tokens.common.bonds_management_suspended]: '債権管理が停止され、限度額内で即時注文が可能です',
    [tokens.common.bonds_balance]: '債権残高',
    [tokens.common.no_bond_details]: '債権明細が存在しません',
    [tokens.common.bond_status]: '債権状態',
    [tokens.common.bond_balance_currency]: '債権残高',
    [tokens.common.treatment]: '処理',
    [tokens.common.treatable_quantity]: '処理可能数量',
    [tokens.common.treatment_result_search]: '処理結果検索 再照会',
    [tokens.common.treatment_result_warning]: '処理結果は修正ができませんので',
    [tokens.common.treatment_classification]: '処理区分',
    [tokens.common.treatment_amount]: '処理金額',
    [tokens.common.treatment_details]: '処理内容',
    [tokens.common.enter_treatment_details]: '処理内容入力',
    [tokens.common.treatment_details_required]: '処理内容は必須です',
    [tokens.common.detailed_treatment_required]: '処理内容は必須です。処理内容は 桁以内で入力してください',
    [tokens.common.enter_treatment_details_prompt]: '処理内容を入力してください',
    [tokens.common.treatment_method]: '処理方式',
    [tokens.common.treatment_reason]: '処理理由',
    [tokens.common.treatment_status_required]: '処理状態は必須です',
    [tokens.common.select_treatment_product]: '処理商品選択',
    [tokens.common.select_treatment]: '処理選択',
    [tokens.common.treatment_quantity_exceeds]: '処理数量は実配送数量を超えることはできません',
    [tokens.common.treatment_completed]: '処理完了',
    [tokens.common.treatment_request]: '処理要求',
    [tokens.common.treatment_type]: '処理タイプ',
    [tokens.common.treatment_datetime]: '処理日時',
    [tokens.common.treatment_date_required]: '処理適用日は必須です',
    [tokens.common.treatment_needed]: '処理必要',
    [tokens.common.quantity_that_can_be_processed]: '処理可能数量',
    [tokens.common.number_of_cases_processed]: '処理件数',
    [tokens.common.processing_result]: '処理結果',
    [tokens.common.address_delete_fail]: 'Etomars エラー：開発チームにお問い合わせください。',
    [tokens.common.processing_classification]: '処理区分',
    [tokens.common.select_processing_classification]: '処理区分を選択してください',
    [tokens.common.processing_details]: '処理内容',
    [tokens.common.processing_details_detail]: '処理内容詳細',
    [tokens.common.processing_details_limit]: '処理内容は{{processingDetail}}文字以内で入力してください',
    [tokens.common.processing_manager]: '処理担当者',
    [tokens.common.reason_for_processing]: '処理理由',
    [tokens.common.reason_for_processing_required]: '処理理由は選択必須です',
    [tokens.common.reason_for_processing_mandatory]: '処理理由は必須です',
    [tokens.common.processing_status]: '処理状態',
    [tokens.common.processing_status_mandatory]: '処理状態は必須です',
    [tokens.common.processing_quantity]: '処理数量',
    [tokens.common.enter_processing_quantity]: '処理数量を入力',
    [tokens.common.enter_processing_quantity_prompt]: '処理数量を入力してください',
    [tokens.common.processing_time]: '処理時点',
    [tokens.common.processing_confirmation]: '処理有無',
    [tokens.common.processing_completed]: '処理完了',
    [tokens.common.processing_type]: '処理タイプ',
    [tokens.common.processing_type_reason]: '処理タイプ / 理由',
    [tokens.common.processing_date]: '処理日',
    [tokens.common.processing_date_responsible_person]: '処理日 / 処理者',
    [tokens.common.processing_datetime]: '処理日時',
    [tokens.common.processing_date_query]: '処理日付',
    [tokens.common.processing_responsible]: '処理者',
    [tokens.common.search_processing_responsible]: '処理者検索',
    [tokens.common.select_processing_handler]: '処理者を検索して選択してください',
    [tokens.common.processing_in_progress]: '処理中',
    [tokens.common.processing_history_only]: '処理中の履歴のみ表示',
    [tokens.common.execute_processing]: '処理する',
    [tokens.common.cheonan]: '天安',
    [tokens.common.attach_contract_documents]: '添付契約書類',
    [tokens.common.attach_file]: '添付ファイル',
    [tokens.common.attachment]: '添付ファイル',
    [tokens.common.check_when_registering]: 'チェック時、該当アカウントで登録された履歴の中で処理中の明細のみ表示',
    [tokens.common.checkbox]: 'チェックボックス 良品化返品廃棄',
    [tokens.common.checked_amount_and_reason]: 'チェックした項目に対して金額と理由を入力してください',
    [tokens.common.initial_target_setting]: '初期対象設定',
    [tokens.common.initial_month]: '初期月',
    [tokens.common.reset]: '初期化',
    [tokens.common.initialization_processing]: '初期化処理',
    [tokens.common.total_1]: '総',
    [tokens.common.total_count_1]: '総 {{basicTotal}} 件',
    [tokens.common.total_route_count]: '総 {{totalRoute}} 件 ルート',
    [tokens.common.total_amount_in_thousands]: '総 {{totalAmountInThousands}} 件 万円',
    [tokens.common.total_sales_details]: '総 {{totalSalesDetails}} 件 売上明細',
    [tokens.common.total_sales_source]: '総 {{totalSalesSource}}件 売上先',
    [tokens.common.total_logistics_code_count]: '総 {{totalLogisticCode}}件 物流コード',
    [tokens.common.total_logistics_code_selection]: '総 {{totalLogisticCode}}件 物流コード選択',
    [tokens.common.total_products]: '総 {{totalProducts}} 件 商品',
    [tokens.common.total_packages]: '総 {{totalPackages}} 件 商品',
    [tokens.common.total_positive_records]: '総 {{totalPositive}} 件 陽性明細',
    [tokens.common.total_entries]: '総 件の',
    [tokens.common.total_trading_companies]: '総 {{tradingCompanies}}件の法人',
    [tokens.common.total_announcements]: '総 {{totalAnnouncements}} 件の告知事項',
    [tokens.common.total_urgent_dispatch_history]: '総 {{totalUrgent}} 件の緊急出庫履歴',
    [tokens.common.total_locations]: '総 {{totalLocation}}件のロケーション',
    [tokens.common.total_purchase_history]: '総 {{totalPurchaseHistory}} 件の仕入れ明細',
    [tokens.common.total_inbound_expected_qty]: '総 {{qty}} 個入荷予定数量',
    [tokens.common.total_inbound_qty]: '総 {{qty}} 個入荷数量',
    [tokens.common.total_inbound_history]: '総 {{totalPurchaseHistory}} 件の入庫履歴',
    [tokens.common.total_suppliers]: '総 {{totalPurchaser}}件の仕入先',
    [tokens.common.total_sales_outlets]: '総 {{totalCustomer}} 件の売上先',
    [tokens.common.total_sales_outlets_selection]: '総 {{totalSelectedSales}}件の売上先選択',
    [tokens.common.total_unassigned_sales_outlets]: '総 件の未配分売上先',
    [tokens.common.total_return_exchange_history]: '総 {{returnExchange}} 件の返品 & 交換履歴',
    [tokens.common.total_return_details]: '総 {{totalReturn}} 件の返品明細',
    [tokens.common.total_sale_history]: '総 {{totalSaleHistory}} 件の売上明細',
    [tokens.common.total_change_history]: '総 {{totalChangeHistory}}件の変更履歴',
    [tokens.common.total_sluggish_inventory]: '総 {{totalSluggishInventory}} 件の不振在庫',
    [tokens.common.total_brands]: '総 {{totalBrand}}件の取引先',
    [tokens.common.total_consultation_history]: '総 {{totalConsultationHistory}} 件の相談履歴',
    [tokens.common.total_items]: '総 {{totalGoods}} 件の商品',
    [tokens.common.total_modification_history]: '総 {{totalModificationHistory}}件の修正履歴',
    [tokens.common.total_modification_items]: '総 {{totalModificationItem}}件の修正項目',
    [tokens.common.total_issue_details]: '総 {{totalIssue}} 件の問題明細',
    [tokens.common.total_inventory_history]: '総 {{totalInventoryHistory}} 件の在庫履歴',
    [tokens.common.total_frequently_asked_questions]: '総 {{totalQuestions}} 件のよくある質問',
    [tokens.common.total_statements]: '総 {{settlementTotal}} 件の精算書',
    [tokens.common.total_adjustment_details]: '総 {{totalAdjustmentHistory}} 件の調整明細',
    [tokens.common.total_bonds]: '総 {{totalBonds}} 件の債権',
    [tokens.common.total_claim_history]: '総 {{totalClaimHistory}} 件のクレーム履歴',
    [tokens.common.total_recovery_details]: '総 {{totalRecoveryHistory}}件の回収明細',
    [tokens.common.total_cases]: '総 {{totalBasic2}} 件',
    [tokens.common.total_sum_qty]: '合計数量合計 {{totalQty}} EA',
    [tokens.common.total_box]: '総 {{totalBox}} ボックス',
    [tokens.common.confirm_total_case_download]: '総 {{totalHistory}} 件 の明細をダウンロードしますか',
    [tokens.common.confirm_total_order_details_download]: '総 {{totalOrderDetailExcelDownload}} 件の注文をダウンロードしますか',
    [tokens.common.total_urgent_dispatch_vehicle_cost]: '総 {{totalUrgent}} 件の緊急配車',
    [tokens.common.total_purchase_order_history]: '総 {{totalPurchaseOrderHistory}}件の発注明細',
    [tokens.common.total_labels]: '総 ラベル数',
    [tokens.common.total_sales_outlets_count]: '総 売上先数',
    [tokens.common.total_managers]: '総 {{totalManager}} 名のマネージャー',
    [tokens.common.total_order_amount]: '総 発注金額',
    [tokens.common.total_dispatch_cost]: '総 配車費用',
    [tokens.common.total_product_count]: '総 商品数',
    [tokens.common.total_count]: '総 数',
    [tokens.common.total_file_size_limit]: '総ファイルサイズは {{totalFileSizeLimit}}MBを超えることはできません',
    [tokens.common.total_refund_scheduled_amount]: '総 返金(予定)金額',
    [tokens.common.total_virtual_account_amount]: '合計 {{totalVirtualAccount}} 個の仮想口座',
    [tokens.common.total_sessions]: '総 {{totalCount}}回',
    [tokens.common.total_trading_volume]: '総取引量',
    [tokens.common.total_picking_output]: '総量ピッキング出力',
    [tokens.common.print_all_searched_list]: '検索されたリスト全体を出力しますか？',
    [tokens.common.recent_order_details_last_days]: '最近 {{recentOrderDay}} 日の注文明細が表示されます',
    [tokens.common.recent_order_amount_last_days]: '最近 30日の注文金額',
    [tokens.common.recent_order_frequency_last_days]: '最近 30日の注文頻度',
    [tokens.common.maximum_storage_capacity]: '最大保管量',
    [tokens.common.minimum_order]: '最小注文',
    [tokens.common.minimum_order_quantity]: '最小注文数量',
    [tokens.common.enter_minimum_order_quantity]: '最小注文数量を入力',
    [tokens.common.minimum_order_quantity_required]: '最小注文数量は必須です',
    [tokens.common.select_at_least_one_order_item]: '少なくとも1つの注文品目を選択してください',
    [tokens.common.final_fault]: '最終責任',
    [tokens.common.final_fault_required]: '最終責任は必須です',
    [tokens.common.final_end_of_period]: '最終期末',
    [tokens.common.final_consultation_type]: '最終相談タイプ',
    [tokens.common.final_consultation_type_required]: '最終相談タイプは必須です',
    [tokens.common.final_detail_type_required]: '最終詳細タイプは必須です',
    [tokens.common.final_modification]: '最終修正',
    [tokens.common.final_completion_date]: '最終処理完了日',
    [tokens.common.select_final_fault]: '最終責任を選択してください',
    [tokens.common.last_change_datetime]: '最終変更日時',
    [tokens.common.final_quantity]: '最終数量',
    [tokens.common.last_modified]: '最終修正',
    [tokens.common.initial_registration]: '初回登録',
    [tokens.common.initial_registration_last_modification]: '初回登録 / 最終修正',
    [tokens.common.initial_registrar]: '初回登録者',
    [tokens.common.addition]: '追加',
    [tokens.common.livestock_product_history_report_needed]: '畜産物履歴申告 必要有無',
    [tokens.common.livestock_product_history_reporting_required]: '畜産物履歴申告 必要有無',
    [tokens.common.livestock_product_history_report_number]: '畜産物履歴申告番号',
    [tokens.common.delivery_processing]: '出庫処理',
    [tokens.common.shipping_price_notice]: '出庫が不可能な場合は確認後、直接キャンセル処理してください',
    [tokens.common.in_shipment_quantity_note]: '出庫量に応じて多少の時間がかかる場合があります',
    [tokens.common.expected_to_be_shipped]: '出庫予定',
    [tokens.common.expected_warehouse_delivery_date]: '出庫予定日',
    [tokens.common.empty_page_expected_to_be_shipped]: '出荷予定の内訳がありません。',
    [tokens.common.delivery_warehouse_type]: '出庫タイプ',
    [tokens.common.shipping_issue_details]: '出庫問題詳細',
    [tokens.common.shipping_date_requirement]: '出庫日を変更する場合、出庫日は必須です',
    [tokens.common.change_delivery_date]: '出庫日変更',
    [tokens.common.delivery_datetime]: '出庫日時',
    [tokens.common.shipping_work_instruction]: '出庫作業',
    [tokens.common.shipping_work_in_progress]: '出庫作業指示中です',
    [tokens.common.shipping_work_progress_popup]: '出庫作業進行中ポップアップ',
    [tokens.common.shipping_order_instruction]: '出庫指示',
    [tokens.common.shipping_order_failure]: '出庫指示失敗',
    [tokens.common.shipping_processing_status]: '出庫処理',
    [tokens.common.shipping_processing_result]: '出庫処理されました (成功:{{successCount}} 失敗:{{failCount}})',
    [tokens.common.delivery_turn]: '出庫回',
    [tokens.common.select_delivery_turn]: '出庫回選択',
    [tokens.common.print_piece_picking_list]: '{{outboundCounts}}個の出庫回車の総量ピッキング紙を印刷しますか？',
    [tokens.common.print_piece_picking_list]: '{{outboundCounts}}個の出庫回車の個別のピッキング紙を印刷しますか？',
    [tokens.common.please_select_delivery_turn]: '出庫回を指定してください。',
    [tokens.common.please_select_only_one_delivery_turn]: 'ラベル出力時の出庫回差は1件のみ可能です。',
    [tokens.common.delivery_turn_format_example]: 'YYMM-n (例: 2511-1, 2511-2)',
    [tokens.common.output_of_power]: '出力',
    [tokens.common.output_of_power_quantity]: '出力ラベル数量',
    [tokens.common.to_print_no_shipping_work]: '出力する物流出庫作業がありません',
    [tokens.common.to_print_no_transaction_statement]: '出力する取引明細書がありません',
    [tokens.common.to_send_invoice_bulk]: '発行する送り状の注文を選択してください。',
    [tokens.common.to_print_no_picking_turn]: '出力するピッキング回がありません',
    [tokens.common.to_print_no_delivery_order]: '出力する納品書がありません',
    [tokens.common.to_print_no_outbound_label]: '出力するラベルがありません',
    [tokens.common.depart_from_location_code]: '出発ロケーションコード',
    [tokens.common.departure_center]: '出発センター',
    [tokens.common.origin_information]: '出発地情報',
    [tokens.common.exit_delivery_management]: '出庫配送管理',
    [tokens.common.exit_center]: '出庫センター',
    [tokens.common.change_exit_center]: '出庫センター変更',
    [tokens.common.exit_center_change_completed]: '出庫センター変更が完了しました',
    [tokens.common.batch_change_of_exit_center]: '出庫センター一括変更',
    [tokens.common.weekday_exit_center_input_time]: '出車 - {{inboundCenterName}} 入庫 (予定時間 : 平日 -',
    [tokens.common.outbound_delivery_management]: '出庫配送管理',
    [tokens.common.departure_center_update]: '出庫センター',
    [tokens.common.change_of_exit_center]: '出庫センター変更',
    [tokens.common.departure_center_code]: '出庫センターコード',
    [tokens.common.departure_datetime]: '出庫日時',
    [tokens.common.departure_point]: '出庫地',
    [tokens.common.select_departure_point]: '出庫地選択',
    [tokens.common.departure_center_point_required]: '出庫地センターは必須です',
    [tokens.common.cancellation]: '取消',
    [tokens.common.cancellation_warning]: '取消後は再処理ができません',
    [tokens.common.has_been_canceled]: '取消されました',
    [tokens.common.cancellation_status]: '取消状態',
    [tokens.common.cancellation_quantity]: '取消数量',
    [tokens.common.category]: 'カテゴリ',
    [tokens.common.category_management]: 'カテゴリ管理',
    [tokens.common.category_immutable_once_registered]: 'カテゴリ登録後は削除および修正ができません',
    [tokens.common.category_change]: 'カテゴリ変更',
    [tokens.common.category_change_area]: 'カテゴリ変更エリア',
    [tokens.common.category_change_completed]: 'カテゴリ変更が完了しました',
    [tokens.common.category_deletion]: 'カテゴリ削除',
    [tokens.common.category_deletion_completed]: 'カテゴリ削除が完了しました',
    [tokens.common.select_category]: 'カテゴリ選択',
    [tokens.common.category_selection_required]: 'カテゴリ選択は必須です',
    [tokens.common.add_category]: 'カテゴリ追加',
    [tokens.common.category_addition_completed]: 'カテゴリ追加が完了しました',
    [tokens.common.category_code]: 'カテゴリコード',
    [tokens.common.category_code_required]: 'カテゴリコードは必須です',
    [tokens.common.category_name]: 'カテゴリ名',
    [tokens.common.enter_and_add_category_name]: 'カテゴリ名を入力して追加してください',
    [tokens.common.enter_category_name]: 'カテゴリ名を入力してください',
    [tokens.common.please_enter_category_name]: 'カテゴリ名を入力してください',
    [tokens.common.category_name_code_duplicate]: 'カテゴリ名が重複しました。カテゴリコードが重複しました',
    [tokens.common.by_category_default_purchase_profit_rate]: 'カテゴリ別基本購入利益率',
    [tokens.common.by_category_set_profit_rate]: 'カテゴリ別設定された利益率に基づく販売価格',
    [tokens.common.category_profit_rate_setting]: 'カテゴリ別利益率設定',
    [tokens.common.code]: 'コード',
    [tokens.common.quick_cost]: 'クイック費用',
    [tokens.common.by_clicking]: 'クリックしてファイルを追加',
    [tokens.common.by_clicking_maximum_files]: 'クリックしてファイルを追加 最大 件まで',
    [tokens.common.by_clicking_drag_and_drop_maximum_files]:
        'クリックしてファイルを追加、またはここにドラッグ ({{lessCapacity}}以下、最大{{maxFileCount}}個)',
    [tokens.common.get_on]: '他システム連携情報',
    [tokens.common.get_on_required]: '他システム連携必要',
    [tokens.common.get_on_code_input]: '他システムコード入力',
    [tokens.common.other_computers_code_input]: 'バーコード入力',
    [tokens.common.classification_of_other_computer_systems]: '他システム区分',
    [tokens.common.other_computer_linkage_code]: '他システム連携コード',
    [tokens.common.other_computer_interconnection_codes_required]: '他システム連携コードは必須です',
    [tokens.common.whether_interconnection_with_other_computers_is_necessary]: '他システム連携必要かどうか',
    [tokens.common.other_computer_code]: '他システムコード',
    [tokens.common.goods_barcode_select]: '商品バーコードの選択',
    [tokens.common.duplicate_goods_barcode_select]: '重複商品バーコードの選択',
    [tokens.common.other_computer_code_duplicate]: '他システムコードが重複しました',
    [tokens.common.other_computer_codes_required]: '他システムコードは必須です',
    [tokens.common.other_computerized_item_code]: '他システム品目コード',
    [tokens.common.goods_barcode_required]: '商品バーコードは必須です',
    [tokens.common.other_item_code]: 'バーコード',
    [tokens.common.sales_code]: '売上先コード',
    [tokens.common.sales_code_input]: '売上先コード入力',
    [tokens.common.sales_code_required]: '売上先コードは必須です',
    [tokens.common.sales_code_duplicate]: '売上先コードが重複しました',
    [tokens.common.test]: 'テスト',
    [tokens.common.table]: 'テーブル',
    [tokens.common.table_area]: 'テーブルエリア',
    [tokens.common.significant]: '特記事項',
    [tokens.common.picking_delivery_statement_printYn]: '個別ピッキング納品書の出力有無',
    [tokens.common.print]: '出力',
    [tokens.common.not_print]: '未出力',
    [tokens.common.significant_input]: '特記事項入力',
    [tokens.common.team_come_id]: 'チームプロダID',
    [tokens.common.team_come_input]: 'チームプロダID入力',
    [tokens.common.team_come_id_required]: 'チームプロダIDは必須です',
    [tokens.common.file_limit]: 'ファイル件数は {{fileLimitCount}}件を超えることはできません',
    [tokens.common.file_data_entry_warning]: 'ファイル内のデータに誤入力がある場合、登録されませんので再確認をお願いします',
    [tokens.common.file_size_limit_per_file]: 'ファイルあたりのサイズは - MBを超えることはできません',
    [tokens.common.file_upload]: 'ファイルアップロード',
    [tokens.common.file_upload_status_window]: 'ファイルアップロードステータスウィンドウ',
    [tokens.common.file_too_large]: 'ファイルサイズが大きすぎます',
    [tokens.common.file_size_limit]: 'ファイルあたり {{fileSizeLimit}}MBを超えることはできません',
    [tokens.common.file_absent]: 'ファイルがありません',
    [tokens.common.sale_absent]: '販売明細がありません',
    [tokens.common.sale_delivery_day]: '販売(配送)日',
    [tokens.common.sale_conversion_quantity]: '販売時の変換数量',
    [tokens.common.sales_profit_margin_2]: '販売利益率',
    [tokens.common.sales_status]: '販売状況',
    [tokens.common.sale_price]: '販売価格',
    [tokens.common.sale_date]: '販売日',
    [tokens.common.sale_price_setting]: '販売価格設定',
    [tokens.common.sale_price_setting_required]: '販売価格設定は必須です',
    [tokens.common.reserved_sale_price_product]: '予約販売価格商品',
    [tokens.common.sale_price_ratio]: '販売価/格率',
    [tokens.common.sale_price_application_date]: '販売価格適用日',
    [tokens.common.sale_price_adjustment]: '販売価格調整',
    [tokens.common.sale_price_adjustment_including_reserved_product]: '販売価格調整 予約中の商品を含む',
    [tokens.common.sale_price_or_profit_margin_error]: '販売価格または利益率が正しくありません',
    [tokens.common.selling_price_required]: '販売価格は必須です',
    [tokens.common.sales_price_setting_classification]: '販売価格設定区分',
    [tokens.common.reservation_for_sale_price]: '販売価格予約',
    [tokens.common.sales_amount_exclusion]: '販売金額(VAT除外)',
    [tokens.common.sales_quantity]: '販売数量',
    [tokens.common.popup]: 'ポップアップ',
    [tokens.common.material_code]: '品目コード',
    [tokens.common.material_name]: '品目名',
    [tokens.common.popup_area_sales_outlet_search_popup]: 'ポップアップエリア 売上先検索ポップアップ',
    [tokens.common.password_change]: 'パスワード変更',
    [tokens.common.password_change_button]: 'パスワードを変更するにはこのボタンを押してください',
    [tokens.common.password_change_completed]: 'パスワード変更が完了しました',
    [tokens.common.password_reset_prompt]: 'パスワードをリセットしますか',
    [tokens.common.password_reset_completed]: 'パスワードのリセットが完了しました',
    [tokens.common.password_verification]: 'パスワード確認',
    [tokens.common.password_incorrect]: 'パスワードが正しくありません',
    [tokens.common.password_mismatch_2]: 'パスワードが一致しません',
    [tokens.common.password_match_2]: 'パスワードが一致しました',
    [tokens.common.password_required]: 'パスワードは必須です',
    [tokens.common.enter_password]: 'パスワードを入力してください',
    [tokens.common.please_enter_password]: 'パスワードを入力してください',
    [tokens.common.page_absent]: 'ページが存在しません',
    [tokens.common.average_order_amount]: '平均注文金額',
    [tokens.common.average_selling_price]: '平均販売価格',
    [tokens.common.weekdays]: '平日',
    [tokens.common.weekdays_closure]: '平日締め',
    [tokens.common.no_weekdays]: '平日なし',
    [tokens.common.dispose]: '廃棄',
    [tokens.common.scheduled_for_dispose]: '廃棄予定',
    [tokens.common.scheduled_for_disposal]: '廃棄予定',
    [tokens.common.stock_holding]: 'ホールド在庫',
    [tokens.common.disposal_processing]: '廃棄処理',
    [tokens.common.filter]: 'フィルター',
    [tokens.common.filter_area]: 'フィルターエリア',
    [tokens.common.filter_code]: 'フィルターコード',
    [tokens.common.filter_code_length_limit]: 'フィルターコードは {{filterCodeLengthLimit}}文字を超えることはできません',
    [tokens.common.bottom]: '下部',
    [tokens.common.bottom_reference]: '下部参照 入庫予定書参考',
    [tokens.common.down]: '下位カテゴリがある場合、カテゴリコードを削除できません',
    [tokens.common.piece]: ' 件以上の大企業を登録してください',
    [tokens.common.hangeon]: ' 件でも失敗があれば失敗を強調処理',
    [tokens.common.korean]: 'ハングル入力はできません',
    [tokens.common.limit]: '限度額超過時には注文ができません',
    [tokens.common.limit_amount]: '限度 元 債権残高 元',
    [tokens.common.temporary_limit_adjustment]: '限度額の一時調整',
    [tokens.common.the_limit_is_temporarily_adjusted]: '限度額が一時的に調整されました',
    [tokens.common.total_2]: '合計',
    [tokens.common.total_amount_2]: '合計金額',
    [tokens.common.total_amount_inclusive_of_tax]: '合計金額は消費税を含んだ金額です',
    [tokens.common.delete_virtual_account]: '該当仮想口座を削除しますか',
    [tokens.common.non_exposure_of_product_on_scheduled_delivery_date]: '該当期間の配送予定日には選択された商品が表示されません',
    [tokens.common.delete_menu]: '該当メニューを削除します。メニュー削除時、下位メニューも削除されます。進行しますか',
    [tokens.common.switch_product_require_password]: '該当商品を {{switchGoodsStatus}} 転換する場合、パスワードを入力してください',
    [tokens.common.data_irreversibility_after_approval]: '該当承認後にはデータ復元ができず、仮想口座番号が他の売上先に連動することがあります',
    [tokens.common.no_return_details_in_statement]: '該当精算書に含める返品明細がありません',
    [tokens.common.process_receipt_of_order]: '該当注文件に対して受付処理を行いますか',
    [tokens.common.filter_only_included_orders]: '該当注文に含まれていない値も一緒に移送されるため、該当注文の商品だけをフィルタリングします',
    [tokens.common.no_assigned_route_for_turn]: '該当回次に割り当てられたルートがありません',
    [tokens.common.not_applicable]: '該当なし',
    [tokens.common.no_individual_picking_paper_available]: '該当条件で出力可能な個別ピッキング紙がありません',
    [tokens.common.no_total_picking_paper_available]: '該当条件で出力可能な総量ピッキング紙がありません',
    [tokens.common.order_qty]: '注文数量',
    [tokens.common.lot]: 'LOT',
    [tokens.common.enter_individual_picking_code_to_search]: '個別ピッキングコードを入力して検品する商品を照会してください',
    [tokens.common.no_label_available]: '該当条件で出力可能なラベルがありません。参照しているセンターの基準と到着地が同一であってはなりません',
    [tokens.common.view_only_termination_approval_status]: '解約承認待ち状態のみ表示',
    [tokens.common.termination_approval_disconnection_of_virtual_account]:
        '解約承認時、該当売上先と仮想口座番号の連動が切断され、該当仮想口座の口座残高が -元に変更されます。',
    [tokens.common.termination_completed]: '解約完了',
    [tokens.common.termination_request_1]: '解約要請',
    [tokens.common.termination_status]: '解約状態',
    [tokens.common.termination_request_2]: '解約要請',
    [tokens.common.now]: '今日',
    [tokens.common.current_purchase_profit_rate]: '現在の購入利益率',
    [tokens.common.current_password_matches]: '現在のパスワードと同じです',
    [tokens.common.current_selling_price]: '現在販売価格',
    [tokens.common.home]: 'ホームへ',
    [tokens.common.check]: '確認',
    [tokens.common.proceed_with_care]: '確認後、慎重に進行してください',
    [tokens.common.confirmation_required]: '確認が必要です',
    [tokens.common.confirmed]: '確定',
    [tokens.common.undisposed_confirmed_quantity]: '[未廃棄]確定量',
    [tokens.common.confirmation_process]: '確定処理',
    [tokens.common.confirmation_processor]: '確定処理者',
    [tokens.common.post_confirmation_inventory_immediately_reflected]:
        '確定後、在庫簿に即時反映され、修正ができなくなりますので、再確認してください。',
    [tokens.common.confirmed_closing_date_and_time]: '確定締め日時',
    [tokens.common.confirmed_date_and_time]: '確定日時',
    [tokens.common.confirmed_date]: '確定日付',
    [tokens.common.confirmed_person]: '確定者',
    [tokens.common.refund_amount]: '払い戻し金額',
    [tokens.common.expected_refund_amount_including_request_amount]: '返金予定金額 (要請金額含む)',
    [tokens.common.episode]: '回',
    [tokens.common.company_name_required]: '会社名',
    [tokens.common.collection_and_processing_information]: '回収および処理情報',
    [tokens.common.collection_and_processing_information_details]: '回収および処理情報詳細',
    [tokens.common.collection_shipping_code_self_disposal]: '回収配送コード 自己廃棄',
    [tokens.common.select_collection_reason]: '回収理由選択',
    [tokens.common.please_select_a_collection_reason]: '回収理由を選択してください',
    [tokens.common.view_recovery_photos_1]: '回収写真を見る',
    [tokens.common.no_recovery_photos]: '回収写真がありません',
    [tokens.common.collection_quantity_order_unit]: '回収数量 / 注文単位',
    [tokens.common.collection_completed]: '回収完了',
    [tokens.common.collection_completed_quantity]: '回収完了数量',
    [tokens.common.collection_request_cancellation]: '回収要請取消',
    [tokens.common.collection_request_deleted_customer_refund_procedure_cancelled]: '回収要請が削除され、顧客の返金手続きがすべてキャンセルされます',
    [tokens.common.collection_incoming]: '回収入庫',
    [tokens.common.collection_receipt]: '回収/受付',
    [tokens.common.collection_progress_code_collection_completed]: '回収進行コード 回収完了',
    [tokens.common.collection_processing]: '回収処理',
    [tokens.common.select_collection_processing_type]: '回収処理タイプ選択',
    [tokens.common.please_select_a_collection_processing_type]: '回収処理タイプを選択してください',
    [tokens.common.collection_processing_code_partial_complete_complete]: '回収処理コード 部分完了 完了',
    [tokens.common.collection_processing_irreversible_post_processing_reflected_in_inventory]: '回収処理後には修正ができず、在庫簿に反映されます',
    [tokens.common.collection_processing_not_done]: '回収処理が完了していません',
    [tokens.common.collection_cancellation]: '回収取消',
    [tokens.common.collection_cancellation_proceed_with_caution]:
        '回収取消時、配送マネージャーの回収リストから即時削除され、該当売上先への返金が確定されますので、慎重に確認して進行してください。',
    [tokens.common.collection_required_quantity]: '回収必要数量',
    [tokens.common.number_of_collections]: '回収件数',
    [tokens.common.recovery_result]: '回収結果',
    [tokens.common.view_unprocessed_recovery_results_only]: '未処理の回収結果のみを見る',
    [tokens.common.collection_manager]: '回収マネージャー',
    [tokens.common.select_a_reason_for_recovery]: '回収理由を選択',
    [tokens.common.view_recovery_photos_2]: '回収写真を見る',
    [tokens.common.recovery_status]: '回収状態',
    [tokens.common.recovery_status_option]: '回収状況',
    [tokens.common.select_whether_to_recover]: '回収するかどうかを選択してください',
    [tokens.common.recovery_completed]: '回収完了',
    [tokens.common.recovery_completed_display]: '回収完了後、回収処理結果を表示',
    [tokens.common.recovery_request_immediate_refund]: '回収要請（即時返金）',
    [tokens.common.collection_date]: '回収日',
    [tokens.common.recovering]: '回収中',
    [tokens.common.cancel_request_during_recovery]: '回収中の要請取消',
    [tokens.common.cancel_possible_during_recovery]: '回収中は取消が可能',
    [tokens.common.recovery_processing_done]: '回収処理が完了しました',
    [tokens.common.recovery_processing_type_return_disposal_recovery]: '回収処理タイプ 良品化、返品、廃棄',
    [tokens.common.cancellation_of_collection]: '回収取消',
    [tokens.common.cancellation_of_collection_done]: '回収取消が完了しました',
    [tokens.common.recovery_code]: '回収コード',
    [tokens.common.recovery_code_details]: '回収コード 商品 商品名 売上先 回収マネージャー',
    [tokens.common.round]: '回次',
    [tokens.common.select_print_issue_for_round]: '[{{pickingRound}}回次]で既に発行された出力件を選択してください',
    [tokens.common.register_round]: '回次を登録してください',
    [tokens.common.select_round_mandatory]: '回次を必ず選択してください',
    [tokens.common.select_at_least_round]: '1回次以上を選択してください',
    [tokens.common.select_up_to_round]: '10回次以下を選択してください',
    [tokens.common.mobile_phone_number_entry]: '携帯電話番号',
    [tokens.common.enter_mobile_phone_number_digits]: '携帯電話番号の 11桁を入力してください',
    [tokens.common.enter_accurate_mobile_phone_number]: '携帯電話番号を正確に入力してください',
    [tokens.common.enter_id]: 'IDを入力してください',
    [tokens.common.excel_download_limit]: '{{maxExcelCount}}件以下でのみエクセルダウンロードが可能です',
    [tokens.common.enter_up_to_n_digits]: 'n桁以下で入力してください',
    [tokens.common.time]: '時間',
    [tokens.common.shipping_management]: '出荷管理(センター)',
    [tokens.common.shipping_wait]: '出荷待機',
    [tokens.common.shipping_work]: '出荷作業',
    [tokens.common.shipping_completed]: '出荷完了',
    [tokens.common.shipping_history_excel_download]: '出荷履歴のエクセルダウンロード',
    [tokens.common.shipping_date]: '出荷日',
    [tokens.common.shipping_history_inquiry]: '出荷履歴照会',
    [tokens.common.total_shipping_history]: '総 {{totalShippingHistory}} 件の出荷履歴',
    [tokens.common.empty_page_shipping_history]: '出荷履歴がありません',
    [tokens.common.history]: '履歴',
    [tokens.common.empty_page_order_by_goods_list]: '注文がありません。',
    [tokens.common.order_date]: '注文日',
    [tokens.common.view_unprocessed_only]: '未処理の履歴のみ表示',
    [tokens.common.inventory_history_inquiry]: '在庫履歴の照会',
    [tokens.common.inventory_audit_detail]: '在庫監査詳細',
    [tokens.common.inventory_audit_code]: '在庫監査コード',
    [tokens.common.inventory_audit_date_and_time]: '在庫監査日時',
    [tokens.common.inventory_audit_instruction]: '在庫調査指示',
    [tokens.common.inventory_no_matching_count]: '在庫不一致商品数',
    [tokens.common.inventory_no_matching_ratio]: '在庫不一致商品比率',
    [tokens.common.view_no_audit_location_only]: '未調査のロケーションのみ表示',
    [tokens.common.week]: '週',
    [tokens.common.warning_take_back_delete]: '回収依頼が削除され、キャンセル後は再処理ができません。',
    [tokens.common.shipping]: '出庫',
    [tokens.common.price]: '販売価格',
    [tokens.common.warning_no_purchase_price_cant_use_y]: '仕入価格が入力されていない商品は使用に転換できません',
    [tokens.common.unuse_conversion]: '未使用切替',
    [tokens.common.excel_download_unuse_conversion_order_goods]: '未使用切替商品注文履歴エクセルダウンロード',
    [tokens.common.image_bulk_upload]: '画像一括アップロード',
    [tokens.common.register_goods]: '商品登録',
    [tokens.common.update_goods]: '商品修正',
    [tokens.common.purchase_manager_automatic_input]: '購入担当者自動入力',
    [tokens.common.input_specifications_for_order_goods_unit]: ' 商品注文単位に関する仕様を入力してください',
    [tokens.common.necessary]: '必要',
    [tokens.common.concealment]: '非表示',
    [tokens.common.max]: '最大',
    [tokens.common.each]: '個',
    [tokens.common.now_price]: '現在の販売価格',
    [tokens.common.please_enter]: '入力してください',
    [tokens.common.include]: '含む',
    [tokens.common.sales_settlement_adjustment_handling]: '売上精算調整金の処理',
    [tokens.common.info_previous_month_sales_settlement_process_1]: '売上精算書の調整金は、該当精算書の内容に反映されるため、',
    [tokens.common.info_previous_month_sales_settlement_process_2]: '「前月」基準のみ可能で、売上反映Yで自動適用されます。',
    [tokens.common.view_non_exposure_purchaser]: '非表示の仕入先を見る',
    [tokens.common.register_or_cancel_favorite]: 'お気に入り{{favoriteRegisterOrCancel}}が完了しました。',
    [tokens.common.view_non_exposed_product]: '非表示商品を見る',
    [tokens.common.not_confirmed]: '未確定',
    [tokens.common.settlement_adjustment_price]: '精算調整金',
    [tokens.common.payment]: '精算',
    [tokens.common.person_in_charge_of_sales]: '売上先担当者',
    [tokens.common.approve]: '承認',
    [tokens.common.error_message]: 'エラーメッセージ',
    [tokens.common.file]: 'ファイル',
    [tokens.common.virtual_account]: 'バーチャル口座',
    [tokens.common.warning_purchase_order_request_update_1]: '発注依頼書を修正すると、該当商品の仕入先に',
    [tokens.common.warning_purchase_order_request_update_2]: '修正された発注依頼書',
    [tokens.common.warning_purchase_order_request_update_3]: 'が送信されます。',
    [tokens.common.warning_purchase_order_request_update_4]: '送信後はキャンセルできませんので、',
    [tokens.common.warning_purchase_order_request_update_5]: '確認の上、慎重に発注',
    [tokens.common.warning_purchase_order_request_update_6]: 'を行ってください。',
    [tokens.common.warning_inbound_expected_request_update_1]: '入庫予定書を登録した後はキャンセルできませんので、',
    [tokens.common.warning_inbound_expected_request_update_2]: 'ご確認の上、慎重に入庫を',
    [tokens.common.warning_inbound_expected_request_update_3]: 'お願いいたします。',
    [tokens.common.warning_inbound_expected_request_update_4]: '総入庫予定数量は、下記の数量を登録すると合算して表示されます。',
    [tokens.common.warning_create_settlement_without_return_goods]: '返品履歴を選択せずに、精算書を作成しますか？',
    [tokens.common.reflect]: '反映',
    [tokens.common.not_reflect]: '未反映',
    [tokens.common.unsettled_return_goods_history]: '未精算返品内訳',
    [tokens.common.total_return_history]: '返品履歴の件数',
    [tokens.common.total_return_amount]: '返品総額',
    [tokens.common.departure_place]: '発送地',
    [tokens.common.validate_required_logistic_code_1]: '物流コードは必須です。',
    [tokens.common.validate_required_logistic_code_2]: '物流コードは1つ以上必須です。',
    [tokens.common.validate_change_outbound_date]: '出荷変更日は今日以降の日付でなければなりません。',
    [tokens.common.re_shipping_order_instruction_complete]: '再出荷指示が完了しました。',
    [tokens.common.re_shipping_order_instruction]: '再出荷指示',
    [tokens.common.notice_to_customer_complete]: '顧客への案内が完了した件です。',
    [tokens.common.warn_cancel_order_1]: '注文をキャンセルする場合、商品を',
    [tokens.common.warn_cancel_order_2]: '即時に注文キャンセル',
    [tokens.common.warn_cancel_order_3]: 'します。',
    [tokens.common.warn_cancel_order_4]: '注文キャンセル時',
    [tokens.common.warn_cancel_order_5]: '自動返金 ',
    [tokens.common.warn_cancel_order_6]: 'されるため慎重に',
    [tokens.common.warn_cancel_order_7]: '確認の上処理 ',
    [tokens.common.warn_cancel_order_8]: 'してください。',
    [tokens.common.piece_picking_label_printing]: '個別ピッキングラベル出力',
    [tokens.common.not_need_trunk_plt_label_printing]: '幹線 PLT出力が不要な対象です。（支線出荷のみです）',
    [tokens.common.search_logistic_code_information]: '物流コード情報の照会',
    [tokens.common.empty_page_list]: 'リストが存在しません。',
    [tokens.common.empty_page_shipping_completed]: '出荷完了履歴がありません。',
    [tokens.common.register_outbound_setting_completed]: '出荷設定の登録が完了しました。',
    [tokens.common.setting]: '設定',
    [tokens.common.picking_zone]: 'ピッキングゾーン',
    [tokens.common.ignore_picking_zone_inventory]: 'ピッキングゾーン在庫を無視',
    [tokens.common.check_picking_zone_inventory]: 'ピッキングゾーン在庫を確認',
    [tokens.common.instruct_shipping_work_completed]: '出荷作業の指示が出されました。',
    [tokens.common.instruct_shipping_work]: '出庫作業指示。',
    [tokens.common.shipping_setting]: '出荷設定',
    [tokens.common.empty_page_shipping_wait]: '出荷待機作業がありません。',
    [tokens.common.select_picking_turn]: 'ピッキング回数選択',
    [tokens.common.create_picking]: 'ピッキング生成',
    [tokens.common.picking_round]: 'ピッキング回数',
    [tokens.common.picking_round_format_example]: 'MMDD-n (例: 1125-1, 1125-2)',
    [tokens.common.empty_page_outbound_work]: '出荷作業がありません',
    [tokens.common.picking_quantity]: 'ピッキング数量',
    [tokens.common.print_picking_list_no_outbound_logistics_code]: 'ピッキングリスト出力 - 選択された出庫物流コードがありません',
    [tokens.common.print_picking_list]: 'ピッキングリスト出力',
    [tokens.common.order_registration_completed]: '注文登録が完了しました。',
    [tokens.common.sales_channel_code]: '販売チャンネルコード',
    [tokens.common.sales_channel_name]: '販売チャンネル名',
    [tokens.common.other_system_sales_channel_code]: '他のシステム販売先コード',
    [tokens.common.other_system_product_code]: '他のシステム商品コード',
    [tokens.common.title_2]: 'タイトル',
    [tokens.common.app]: 'アプリ',
    [tokens.common.folder]: 'フォルダ',
    [tokens.common.link]: 'リンク',
    [tokens.common.child_app]: '子アプリ',
    [tokens.common.monday]: '月曜日',
    [tokens.common.tuesday]: '火曜日',
    [tokens.common.wednesday]: '水曜日',
    [tokens.common.thursday]: '木曜日',
    [tokens.common.friday]: '金曜日',
    [tokens.common.saturday]: '土曜日',
    [tokens.common.sunday]: '日曜日',
    [tokens.common.monday_short]: '月',
    [tokens.common.tuesday_short]: '火',
    [tokens.common.wednesday_short]: '水',
    [tokens.common.thursday_short]: '木',
    [tokens.common.friday_short]: '金',
    [tokens.common.saturday_short]: '土',
    [tokens.common.sunday_short]: '日',
    [tokens.common.january]: '1月',
    [tokens.common.february]: '2月',
    [tokens.common.march]: '3月',
    [tokens.common.april]: '4月',
    [tokens.common.may]: '5月',
    [tokens.common.june]: '6月',
    [tokens.common.july]: '7月',
    [tokens.common.august]: '8月',
    [tokens.common.september]: '9月',
    [tokens.common.october]: '10月',
    [tokens.common.november]: '11月',
    [tokens.common.december]: '12月',
    [tokens.common.adjustment_inventory_confirmed]: '在庫調整確定',
    [tokens.common.ask_adjustment_inventory_confirmed]: '在庫調整を確定しますか？',
    [tokens.common.adjustment_inventory_required_quantity]: '在庫調整数量は0 ({{cancel}})または{{adjustmentQuantity}}数量で処理してください。',
    [tokens.common.upload_batch_adjustment_inventory]: '在庫調整一括アップロード',
    [tokens.common.center_parameter]: 'センターパラメータ',
    [tokens.common.no_center_parameter]: 'センターパラメータがありません',
    [tokens.common.total_goods_selected]: '{{totalSelectedGoods}}個の商品が選択されました',
    [tokens.common.inventory_audit_confirmation_1]: '在庫調査反映/確定処理時に在庫調整リストに反映されます。',
    [tokens.common.inventory_audit_confirmation_2]: '損失処理',
    [tokens.common.inventory_audit_confirmation_3]: '処理者の名前とともに',
    [tokens.common.inventory_audit_confirmation_4]: '在庫帳に反映されます。',
    [tokens.common.inventory_audit_confirmation_5]: '確定後は',
    [tokens.common.inventory_audit_confirmation_6]: 'キャンセルが不可能です。',
    [tokens.common.inventory_audit_confirmation_7]: '誤処理の場合、',
    [tokens.common.inventory_audit_confirmation_8]: '直接在庫調整を通じて',
    [tokens.common.inventory_audit_confirmation_9]: '再調整を行う必要がありますので、',
    [tokens.common.inventory_audit_confirmation_10]: '慎重に処理してください。',
    [tokens.common.inventory_audit_confirmation_11]: '(未反映の場合、在庫調査は終了しますが、結果は反映されません。)',
    [tokens.common.inventory_audit_confirmed]: '在庫調査確定処理',
    [tokens.common.success_inventory_audit_confirmed]: '在庫調査確定処理成功',
    [tokens.common.warn_inventory_investigation_1]: '在庫調査を指示する場合、作業者WEBに在庫調査の指示が通知され、',
    [tokens.common.warn_inventory_investigation_2]: 'センターの入出庫作業がすべて中断されますので、慎重に指示してください。',
    [tokens.common.success_inventory_investigation_instruction]: '在庫調査の指示が完了しました。',
    [tokens.common.fail_inventory_investigation_instruction]: '在庫調査の指示が失敗しました。',
    [tokens.common.in_progress_inventory_investigation_instruction]: '在庫調査が進行中です。',
    [tokens.common.inventory_investigation_upload]: '在庫調査のアップロード',
    [tokens.common.download_inventory_investigation_upload_form]: '在庫調査のフォームをダウンロード',
    [tokens.common.inventory_investigation_information_excel_file]: '在庫調査情報のExcelファイル',
    [tokens.common.required_purchase_request_form]: '発注依頼書の選択が必要です',
    [tokens.common.confirmed_receiving_document]: '入庫確定書',
    [tokens.common.scheduled_receiving_document]: '入庫予定書',
    [tokens.common.scheduled_receiving_document_registration]: '入庫予定書登録',
    [tokens.common.hourly_receiving_quantity]: '時間当たり入庫量',
    [tokens.common.check_return_detail]: '返品内容を確認',
    [tokens.common.return]: '返品',
    [tokens.common.adjustment_inventory_detail]: '在庫調整の詳細',
    [tokens.common.small]: '小',
    [tokens.common.success_upload]: 'アップロードが完了しました。',
    [tokens.common.fail_upload]: 'アップロードに失敗しました。',
    [tokens.common.expiration_date_adjustment_preorder_inventory_1]: '賞味期限の変更時に在庫ロスが発生する可能性があるため、',
    [tokens.common.expiration_date_adjustment_preorder_inventory_2]: '設定した期間に応じて先行注文商品の在庫が差し引かれます。',
    [tokens.common.expiration_date_adjustment_preorder_inventory_3]: '再度慎重に、',
    [tokens.common.expiration_date_adjustment_preorder_inventory_4]: '確認後に進行',
    [tokens.common.expiration_date_adjustment_preorder_inventory_5]: 'してください。',
    [tokens.common.excel_download]: 'Excelのダウンロード',
    [tokens.common.pre_order_inventory_deduction]: '先注文在庫差引',
    [tokens.common.tax_exemption]: '非課税',
    [tokens.common.manual_ordering]: '手動発注',
    [tokens.common.resend]: '再送信',
    [tokens.common.exit_delivery_count]: '出庫回数',
    [tokens.common.designation]: '指定',
    [tokens.common.success_resend_url]: 'URLの再送信に成功しました。',
    [tokens.common.click_for_resend_url]: 'URLを再送信するには送信ボタンを押してください。',
    [tokens.common.send_url]: 'URL送信',
    [tokens.common.exposure_announcement]: '通知の表示',
    [tokens.common.final_detail_type]: '最終詳細タイプ',
    [tokens.common.first_consultation_type]: '第1次相談タイプ',
    [tokens.common.first_detail_type]: '第1次詳細タイプ',
    [tokens.common.claim_content]: 'クレーム内容',
    [tokens.common.claim_amount]: 'クレーム金額',
    [tokens.common.claim_detail]: 'クレーム詳細',
    [tokens.common.prompt_claim_quantity]: 'クレーム数量を入力してください',
    [tokens.common.claim_quantity]: 'クレーム数量',
    [tokens.common.missing_treatment_classification]: '処理区分の値が不足しています。',
    [tokens.common.missing_attribution]: '帰責値が不足しています。',
    [tokens.common.missing_recovery_status]: '回収の有無の値が不足しています。',
    [tokens.common.missing_attribution_amount]: '帰責金額の値が不足しています。',
    [tokens.common.missing_treatment_quantity]: '処理数量の値が不足しています。',
    [tokens.common.missing_customer_refund_amount]: '顧客返金金額の値が不足しています。',
    [tokens.common.register_return_exchange]: '返品＆交換の受付',
    [tokens.common.processing_return_exchange]: '返却 & 交換処理',
    [tokens.common.success_register_return_exchange]: '返品＆交換の申請が完了しました。',
    [tokens.common.no_delivery]: '未配送',
    [tokens.common.order_timing]: '注文時点',
    [tokens.common.tax_goods_include_vat]: "'課税'商品については、賞味税が含まれて計算されます。",
    [tokens.common.collection_cancellation_proceed_with_caution_1]: '回収キャンセル時、配送マネージャーの回収リストから',
    [tokens.common.collection_cancellation_proceed_with_caution_2]: '即時に削除され、該当の売上先に返金が確定',
    [tokens.common.collection_cancellation_proceed_with_caution_3]: 'しますので、慎重に',
    [tokens.common.collection_cancellation_proceed_with_caution_4]: '確認の上、進めて',
    [tokens.common.collection_cancellation_proceed_with_caution_5]: 'ください。',
    [tokens.common.counselor_memo_delete]: '相談時のメモ削除',
    [tokens.common.counselor_memo]: '相談者メモ',
    [tokens.common.prompt_memo]: 'メモする内容を入力してください。',
    [tokens.common.empty_page_counselor_memo_history]: '相談者メモの履歴がありません。',
    [tokens.common.ask_counselor_memo_delete]: '登録されたメモを削除しますか？',
    [tokens.common.receipt]: '受付',
    [tokens.common.approve_return]: '返却承認',
    [tokens.common.reject]: '返却却下',
    [tokens.common.return_exchange_detail]: '返却 & 交換詳細',
    [tokens.common.return_exchange_goods]: '返却 & 交換商品',
    [tokens.common.empty_page_return_exchange_history]: '返却 & 交換の履歴がありません。',
    [tokens.common.return_status]: '返却状態',
    [tokens.common.recovery_request]: '回収リクエスト',
    [tokens.common.immediate_refund]: '即時返金',
    [tokens.common.maximum_memo_prompt_over]: '最大文字数を超えているため、保存できません（2000文字）',
    [tokens.common.save_memo]: 'メモ保存',
    [tokens.common.expected_refund_amount]: '返金予定額',
    [tokens.common.including_vat_request_amount]: '請求額（VAT含む）',
    [tokens.common.request_1]: 'リクエスト',
    [tokens.common.except_1]: '外',
    [tokens.common.claim]: 'クレーム',
    [tokens.common.send_date_time]: '送信日時',
    [tokens.common.sender]: '送信者',
    [tokens.common.view_send_screen]: '送信画面を表示',
    [tokens.common.success_send_message]: 'メッセージが送信されました',
    [tokens.common.send_message]: 'メッセージ送信',
    [tokens.common.order_cancellation_immediate_1]: '注文をキャンセルすると、商品が',
    [tokens.common.order_cancellation_immediate_2]: '即座に注文がキャンセルされます。',
    [tokens.common.order_cancellation_immediate_3]: '注文をキャンセルすると',
    [tokens.common.order_cancellation_immediate_4]: '自動的に返金',
    [tokens.common.order_cancellation_immediate_5]: 'されるので慎重に',
    [tokens.common.order_cancellation_immediate_6]: '確認してから進めてください',
    [tokens.common.order_cancellation_immediate_7]: 'ください。',
    [tokens.common.total_urgent_delivery_vehicle_amount]: '総緊急出庫車両費用',
    [tokens.common.batch_adjustment_irreversible_warning_1]: '一括調整時にはデータの復元が不可能ですので、',
    [tokens.common.batch_adjustment_irreversible_warning_2]: '再度慎重に、',
    [tokens.common.batch_adjustment_irreversible_warning_3]: '確認後に進めてください。',
    [tokens.common.batch_adjustment_irreversible_warning_4]: 'お願い致します。',
    [tokens.common.purchase.order_request_date_time]: '発注要求日時',
    [tokens.common.adjustment_fee_processing_impact_1]: '調整金の処理時に調整金額が',
    [tokens.common.adjustment_fee_processing_impact_2]: '即座に債権に反映され、',
    [tokens.common.adjustment_fee_processing_impact_3]: '精算書に反映請求されますので',
    [tokens.common.adjustment_fee_processing_impact_4]: 'もう一度確認の上処理してください。',
    [tokens.common.product_adjustment_by_item]: '商品別調整金額',
    [tokens.common.update_contract_information]: '契約情報の修正',
    [tokens.common.pre_pay]: '前払い',
    [tokens.common.post_pay]: '後払い',
    [tokens.common.notice_sales_contract_type_update_1]: '販売先契約形態の修正に関する内容は必ず',
    [tokens.common.notice_sales_contract_type_update_2]: '事前確認後に進めてください。',
    [tokens.common.notice_sales_contract_type_update_3]: 'お願いいたします。',
    [tokens.common.select_japanese]: '選択（日本語）',
    [tokens.common.sprout_customer]: 'スプラウト顧客',
    [tokens.common.weekend_closure_time]: '週末の締切時間',
    [tokens.common.weekday_closure_time]: '平日の締切時間',
    [tokens.common.order_info]: '注文情報',
    [tokens.common.modify_information]: '情報修正',
    [tokens.common.temporary_credit_limit]: '一時的な信用限度',
    [tokens.common.limit_1]: '限度',
    [tokens.common.customer_contact_name_1]: '顧客担当者 1) 名前',
    [tokens.common.customer_contact_phone_1]: '顧客担当者 1) 連絡先',
    [tokens.common.customer_contact_email_1]: '顧客担当者 1) メール',
    [tokens.common.customer_contact_name_2]: '顧客担当者 2) 名前',
    [tokens.common.customer_contact_phone_2]: '顧客担当者 2) 連絡先',
    [tokens.common.customer_contact_email_2]: '顧客担当者 2) メール',
    [tokens.common.transaction_statement_receipt_time]: '取引明細書の受取時間',
    [tokens.common.contract_start_date]: '契約開始日',
    [tokens.common.departure_center_id]: '出発センターID',
    [tokens.common.order_id]: '注文ID',
    [tokens.common.order_content_2]: '注文内容',
    [tokens.common.sales_transfer_irreversible_1]: '売上移管が完了した場合、',
    [tokens.common.sales_transfer_irreversible_2]: '元に戻すことはできません。',
    [tokens.common.sales_transfer_irreversible_3]: '受管の売上先精算内に反映・請求されますので、',
    [tokens.common.sales_transfer_irreversible_4]: '再度確認の上、処理してください。',
    [tokens.common.sales_transfer_irreversible_5]: 'お願いいたします。',
    [tokens.common.sales_transfer_max_logistic_code]:
        '{{salesTransferRound}}回の移管処理時、最大{{salesTransferLogisticCodeLimit}}個の物流コードのみ可能です',
    [tokens.common.receive_sales_select]: '受管売上先選択',
    [tokens.common.warn_upload_batch_sales_price_reservation_1]: '頻繁な大量データのアップロードはサーバー負荷を引き起こし、',
    [tokens.common.warn_upload_batch_sales_price_reservation_2]: '顧客の注文や出庫に影響を与える可能性があるため、再度ファイルを確認してください。',
    [tokens.common.warn_upload_batch_sales_price_reservation_3]: '既に価格予約が行われている商品の場合、最終アップロード基準で変更されます。',
    [tokens.common.contract_renewal_processing_warning_1]: '再契約の処理時には',
    [tokens.common.contract_renewal_processing_warning_2]: '新しい仮想口座番号が付与され、',
    [tokens.common.contract_renewal_processing_warning_3]: '既存の契約情報が元に戻されるため、',
    [tokens.common.contract_renewal_processing_warning_4]: '必ず再確認',
    [tokens.common.contract_renewal_processing_warning_5]: 'を行ってください。',
    [tokens.common.max_code_group_name]: 'コードグループ名は{{maxCodeGroupName}}文字を超えることはできません。',
    [tokens.common.password_2]: 'パスワード',
    [tokens.common.re_enter_password]: '再入力 パスワード',
    [tokens.common.select_purchase_manager]: '購買担当者 選択',
    [tokens.common.upload_failure]: 'アップロード失敗',
    [tokens.common.code_id]: 'コードID',
    [tokens.common.code_group_id]: 'コードグループID',
    [tokens.common.required_code_id]: 'コードIDは必須です。',
    [tokens.common.code_group_id_length_limit]: 'コードグループIDは{{codeGroupIdLengthLimit}}文字を超えることはできません。',
    [tokens.common.code_group_name_length_limit]: 'コードグループ名は{{codeGroupNameLengthLimit}}文字を超えることはできません。',
    [tokens.common.chain_code_length_limit]: '関連コードは{{chainCodeLengthLimit}}文字を超えることはできません。',
    [tokens.common.korean_code_name_required]: 'コード名（韓国語）は必須です。',
    [tokens.common.japanese_code_name_required]: 'コード名（日本語）は必須です。',
    [tokens.common.korean_code_display_name_length_limit]:
        'コード表示名（韓国語）は{{koreanCodeDisplayNameLengthLimit}}文字を超えることはできません。',
    [tokens.common.japanese_code_display_name_length_limit]:
        'コード表示名（日本語）は{{japaneseCodeDisplayNameLengthLimit}}文字を超えることはできません。',
    [tokens.common.add_code]: 'コード追加',
    [tokens.common.korean_code_name]: 'コード名（韓国語）',
    [tokens.common.japanese_code_name]: 'コード名（日本語）',
    [tokens.common.korean_display_code_name]: 'コード表示名（韓国語）',
    [tokens.common.japanese_display_code_name]: 'コード表示名（日本語）',
    [tokens.common.add_code_group]: 'コードグループ追加',
    [tokens.common.modify_code_group]: 'コードグループ修正',
    [tokens.common.code_group_name]: 'コードグループ名',
    [tokens.common.code_group_explain]: 'コードグループ説明',
    [tokens.common.code_group_explain_length_limit]: 'コードグループ説明は{{codeGroupExplainLengthLimit}}文字を超えることはできません。',
    [tokens.common.code_group_id_required]: 'コードグループIDは必須です。',
    [tokens.common.korean_code_group_name_required]: 'コードグループ名（韓国語）は必須です。',
    [tokens.common.japanese_code_group_name_required]: 'コードグループ名（日本語）は必須です。',
    [tokens.common.korean_code_group_explain_required]: 'コードグループ説明（韓国語）は必須です。',
    [tokens.common.japanese_code_group_explain_required]: 'コードグループ説明（日本語）は必須です。',
    [tokens.common.statement]: '精算',
    [tokens.common.total_sales_amount_percentage]: '全体の販売先売上高の{{totalSalesAmountPercentage}}',
    [tokens.common.months]: 'ヶ月',
    [tokens.common.post_number_is_required]: '郵便番号は必須です。',
    [tokens.common.adjustment_inventory]: '在庫調整',
    [tokens.common.enter]: '入力',
    [tokens.common.select_return_process_result]: '返品処理結果を選択',
    [tokens.common.circulation_sales]: '流通売上',
    [tokens.common.logistic_sales]: '物流売上',
    [tokens.common.no_settlement]: '精算なし',
    [tokens.common.monthly_settlement]: '月次精算',
    [tokens.common.monthly_installment_settlement]: '月割り精算',
    [tokens.common.next_month]: '翌月',
    [tokens.common.not_received]: '未入庫',
    [tokens.common.terminated]: '終了',
    [tokens.common.last_short]: '末',
    [tokens.common.ten_thousand_currency_unit]: '万円',
    [tokens.common.total_order_count]: '総注文数',
    [tokens.common.total_box_count]: '総箱数',
    [tokens.common.total_box_count_question]: '総箱数',
    [tokens.common.enter_total_box_count]: '総箱数を入力してください',
    [tokens.common.total_box_count_required]: 'まず総箱数を入力してください',
    [tokens.common.count_unit]: '個',
    [tokens.common.issue_processing]: 'イシュー処理',
    [tokens.common.outbound_completed]: '出荷完了',
    [tokens.common.pending_outbound]: '未出荷',
    [tokens.common.not_inspected]: '未検査',
    [tokens.common.location_row]: '行',
    [tokens.common.location_col]: '列',
    [tokens.common.select_file]: 'ファイル選択',
    [tokens.common.empty_selected_file]: '選択したファイルがありません。',
    [tokens.common.network_error]: 'ネットワークエラー',
    [tokens.common.cannot_connect_server]: 'サーバーに接続できませんでした。後でもう一度お試しください。',
    [tokens.common.barcode]: '商品バーコード',
    [tokens.common.enter_barcode]: '商品バーコード入力',
    [tokens.common.enter_sku_code]: 'SKUコード入力',
    [tokens.common.enter_goodsIrCd]: 'センター管理コード入力',
    [tokens.common.order_client_nm]: '売上先名',
    [tokens.common.mall_order_no]: 'モール受注番号',
    [tokens.common.slip_no]: '伝票番号',
    [tokens.common.ship_scheduled_dt]: '出荷予定日',
    [tokens.common.delivery_request_dt]: '指定納品日',
    [tokens.common.delivery_request_tm]: '指定納品時間',
    [tokens.common.delivery_nm]: '配送先氏名',
    [tokens.common.delivery_zip]: '配送先郵便番号',
    [tokens.common.delivery_prefecture]: '都道府県',
    [tokens.common.delivery_addr_rest]: '詳細住所',
    [tokens.common.delivery_tel]: '配送先電話番号',
    [tokens.common.order_goods_barcode]: '商品コード',
    [tokens.common.product_nm]: '商品名',
    [tokens.common.order_upload_quantity]: '数量',
    [tokens.common.order_upload_unit_price]: '単価',
    [tokens.common.total_price]: '明細合計金額',
    [tokens.common.processing_div]: '加工区分※ラベル貼付の場合、1と入力',
    [tokens.common.note_1]: '記事欄１',
    [tokens.common.note_2]: '記事欄２',
    [tokens.common.sku_code]: 'SKUコード',
    [tokens.common.goodsIrCd]: 'センター管理コード',
    [tokens.common.address_valid_yn]: '住所検証に失敗した注文のみ表示',
    [tokens.common.address_edit]: '住所変更',
    [tokens.common.address_edit_success]: '住所の変更が完了しました。',
    [tokens.common.address_valid_warning]: '出庫予定日が今日以前の注文は住所検証にはなりません。\n' + ' 住所確認を進めますか？',

    [tokens.code.brd_stl_stt_cd_ny]: '未確定',
    [tokens.code.brd_stl_stt_cd_cf]: '確定',
    [tokens.code.brd_stl_stt_cd_er]: '精算エラー',
    [tokens.code.brd_stl_typ_cd_dist]: '流通売上',
    [tokens.code.brd_stl_typ_cd_logi]: '物流売上',
    [tokens.code.brd_stl_typ_cd_none]: '精算なし',
    [tokens.code.gd_typ_e]: '専用',
    [tokens.code.gd_typ_g]: '汎用',
    [tokens.code.invn_typ_day]: '日在庫',
    [tokens.code.invn_typ_direct]: '直送',
    [tokens.code.invn_typ_keep]: '保管在庫',
    [tokens.code.gd_tmp_typ_c]: '冷蔵',
    [tokens.code.gd_tmp_typ_f]: '冷凍',
    [tokens.code.gd_tmp_typ_r]: '常温',
    [tokens.code.orgn_typ_d]: '日本産',
    [tokens.code.orgn_typ_i]: '輸入品',
    [tokens.code.orgn_typ_o]: 'その他',
    [tokens.code.sls_stt_bfe]: '終了差し迫った',
    [tokens.code.sls_stt_con]: '契約中',
    [tokens.code.sls_stt_end]: '終了',
    [tokens.code.sls_stt_stp]: '利用停止',
    [tokens.code.sls_rtt_asign]: '割当',
    [tokens.code.sls_rtt_unasign]: '未割当',
    [tokens.code.gd_use_typ_end]: '終結',
    [tokens.code.gd_use_typ_unuse]: '未使用',
    [tokens.code.gd_use_typ_use]: '使用',
    [tokens.code.nation_ae]: 'united arab emirates',
    [tokens.code.nation_am]: 'USA',
    [tokens.code.nation_an]: 'Argentina',
    [tokens.code.nation_as]: 'Austria',
    [tokens.code.nation_au]: 'Australia',
    [tokens.code.nation_bg]: 'Belgium',
    [tokens.code.nation_br]: 'Bahrain',
    [tokens.code.nation_bz]: 'Brazil',
    [tokens.code.nation_ca]: 'Canada',
    [tokens.code.nation_cb]: 'Colombia',
    [tokens.code.nation_ch]: 'Chile',
    [tokens.code.nation_cn]: 'China',
    [tokens.code.nation_cr]: 'Costa Rica',
    [tokens.code.nation_dm]: 'Denmark',
    [tokens.code.nation_dn]: 'Dominica',
    [tokens.code.nation_eg]: 'Egypt',
    [tokens.code.nation_etc]: 'Foreign Product',
    [tokens.code.nation_fg]: 'Fiji',
    [tokens.code.nation_fl]: 'Finland',
    [tokens.code.nation_fr]: 'France',
    [tokens.code.nation_gm]: 'Germany',
    [tokens.code.nation_gn]: 'Guinea',
    [tokens.code.nation_gr]: 'Greece',
    [tokens.code.nation_hk]: 'Hong Kong',
    [tokens.code.nation_id]: 'India',
    [tokens.code.nation_idn]: 'Indonesia',
    [tokens.code.nation_il]: 'Ireland',
    [tokens.code.nation_ir]: 'Iran',
    [tokens.code.nation_is]: 'Israel',
    [tokens.code.nation_it]: 'Italy',
    [tokens.code.nation_jp]: 'Japan',
    [tokens.code.nation_mc]: 'Mexico',
    [tokens.code.nation_mgc]: 'Madagascar',
    [tokens.code.nation_mn]: 'Monaco',
    [tokens.code.nation_mr]: 'Morocco',
    [tokens.code.nation_ms]: 'Malaysia',
    [tokens.code.nation_mt]: 'Mauritania',
    [tokens.code.nation_my]: 'Myanmar',
    [tokens.code.nation_nd]: 'Netherlands',
    [tokens.code.nation_ng]: 'Nigeria',
    [tokens.code.nation_nw]: 'Norway',
    [tokens.code.nation_nz]: 'New Zealand',
    [tokens.code.nation_pc]: 'Pakistan',
    [tokens.code.nation_pf]: 'Pacific',
    [tokens.code.nation_pfc]: 'Pacific',
    [tokens.code.nation_pg]: 'Paraguay',
    [tokens.code.nation_pl]: 'Poland',
    [tokens.code.nation_pp]: 'Philippines',
    [tokens.code.nation_pr]: 'Peru',
    [tokens.code.nation_pt]: 'Portugal',
    [tokens.code.nation_rsa]: 'South Africa',
    [tokens.code.nation_ru]: 'Russia',
    [tokens.code.nation_sb]: 'Serbia',
    [tokens.code.nation_sd]: 'Saudi Arabia',
    [tokens.code.nation_sea]: 'Ocean',
    [tokens.code.nation_sg]: 'Senegal',
    [tokens.code.nation_sgp]: 'Singapore',
    [tokens.code.nation_sl]: 'Sri Lanka',
    [tokens.code.nation_sp]: 'Spain',
    [tokens.code.nation_ss]: 'Switzerland',
    [tokens.code.nation_sw]: 'Sweden',
    [tokens.code.nation_tk]: 'Turkey',
    [tokens.code.nation_tl]: 'Thailand',
    [tokens.code.nation_ts]: 'Tunisia',
    [tokens.code.nation_tw]: 'Taiwan',
    [tokens.code.nation_ub]: 'Uzbekistan',
    [tokens.code.nation_uk]: 'United Kingdom',
    [tokens.code.nation_vt]: 'Vietnam',
    [tokens.code.brd_stat_ei]: '終了差し迫った',
    [tokens.code.brd_stat_en]: '終了',
    [tokens.code.brd_stat_st]: 'ノーマル',
    [tokens.code.sls_ctt_postpay]: '後払い',
    [tokens.code.sls_ctt_prepay]: '前払い',
    [tokens.code.pc_grnt_typ_e]: '終了',
    [tokens.code.pc_grnt_typ_i]: '終了差し迫った',
    [tokens.code.pc_grnt_typ_n]: 'ノーマル',
    [tokens.code.pc_grnt_typ_none]: '状態なし',
    [tokens.code.pr_stt_direct]: '自己配送',
    [tokens.code.pr_stt_ic]: '入荷完了',
    [tokens.code.pr_stt_if]: '入庫確認',
    [tokens.code.pr_stt_ik]: '入庫確認',
    [tokens.code.pr_stt_iw]: '入庫待機',
    [tokens.code.pr_stt_pr]: '発注リクエスト',
    [tokens.code.pr_stt_px]: '発注キャンセル',
    [tokens.code.rtrn_prog_ab]: '廃棄処理',
    [tokens.code.rtrn_prog_rx]: '返品キャンセル',
    [tokens.code.rtrn_prog_rr]: '返品受付',
    [tokens.code.rtrn_prog_rc]: '返品リクエスト（確定）',
    [tokens.code.rtrn_typ_bd]: '商品不良',
    [tokens.code.rtrn_typ_bk]: '商品破損',
    [tokens.code.rtrn_typ_sp]: '賞味期限経過',
    [tokens.code.pc_stl_typ_cf]: '確定完了',
    [tokens.code.pc_stl_typ_ny]: '未確定',
    [tokens.code.bond_pay_stt_npaid]: '未払',
    [tokens.code.bond_pay_stt_paid]: '返済済み',
    [tokens.code.crdt_stt_cd_e]: '終了',
    [tokens.code.crdt_stt_cd_n]: '正常',
    [tokens.code.crdt_stt_cd_s]: '停止',
    [tokens.code.adj_price_category_bond_adj]: '債権調整',
    [tokens.code.adj_price_category_claim]: 'クレーム',
    [tokens.code.adj_price_category_coast]: '費用請求',
    [tokens.code.adj_price_category_etc]: 'その他',
    [tokens.code.adj_price_category_purchase]: '仕入費',
    [tokens.code.adj_price_category_quick]: 'クイック費',
    [tokens.code.adj_price_category_quick_purchase]: 'クイック/仕入れ',
    [tokens.code.adj_price_category_sales_adj]: '売上調整',
    [tokens.code.sbjct_rspns_center_mng]: 'センター管理者',
    [tokens.code.sbjct_rspns_consultant]: 'コンサルタント',
    [tokens.code.sbjct_rspns_dlvr_mng]: '配送マネージャー',
    [tokens.code.sbjct_rspns_inbound]: '入庫地センター',
    [tokens.code.sbjct_rspns_logistics]: '物流社',
    [tokens.code.sbjct_rspns_outbound]: '出車地センター',
    [tokens.code.sbjct_rspns_pc_mng]: '購入担当者',
    [tokens.code.sbjct_rspns_purchase]: '仕入れ先',
    [tokens.code.sbjct_rspns_sales]: '売上先',
    [tokens.code.sbjct_rspns_sales_mng]: '営業担当者',
    [tokens.code.sls_stl_typ_cf]: '確定完了',
    [tokens.code.sls_stl_typ_er]: '精算エラー',
    [tokens.code.sls_stl_typ_ff]: '強制確定',
    [tokens.code.sls_stl_typ_ny]: '未確定',
    [tokens.code.pr_stt_direct]: '自社配送',
    [tokens.code.pr_stt_ic]: '入庫完了',
    [tokens.code.pr_stt_if]: '入庫確定',
    [tokens.code.pr_stt_ik]: '入庫確認',
    [tokens.code.pr_stt_iw]: '入庫待機',
    [tokens.code.pr_stt_pr]: '発注リクエスト',
    [tokens.code.pr_stt_px]: '発注キャンセル',
    [tokens.code.po_inb_stt_fi]: '強制入庫',
    [tokens.code.po_inb_stt_mi]: '未入庫',
    [tokens.code.po_inb_stt_ni]: '正常入庫',
    [tokens.code.po_inb_stt_pi]: '部分入庫',
    [tokens.code.rqsts_bad_02]: '商品不良',
    [tokens.code.rqsts_bad_break]: '商品不良破損',
    [tokens.code.rqsts_brk_crm_2]: '破損',
    [tokens.code.rqsts_chn_mind]: '単純な心変わり',
    [tokens.code.rqsts_cop_crm_2]: 'コンピュータに関する問い合わせ',
    [tokens.code.rqsts_cor_dlvr_02]: '対応配送',
    [tokens.code.rqsts_cre_crm_2]: '決済に関する問い合わせ',
    [tokens.code.rqsts_dlvr_crm_2]: '配送に関する問い合わせ',
    [tokens.code.rqsts_dmg_py_2]: '財産破損',
    [tokens.code.rqsts_doc_crm_2]: '書類要求',
    [tokens.code.rqsts_dor_lck_2]: '出入口の未施行',
    [tokens.code.rqsts_err_code_02]: 'エラーコード',
    [tokens.code.rqsts_err_stack_02]: '誤積載',
    [tokens.code.rqsts_error]: '誤配送',
    [tokens.code.rqsts_etc]: 'その他',
    [tokens.code.rqsts_etc_02]: 'その他の問い合わせ',
    [tokens.code.rqsts_expired]: '賞味期限',
    [tokens.code.rqsts_miss]: '未配送',
    [tokens.code.rqsts_no_st_crm2]: '未入庫',
    [tokens.code.rqsts_open_clo_2]: '冷蔵庫の開閉',
    [tokens.code.rqsts_ord_crm_02]: '発注に関する問い合わせ',
    [tokens.code.rqsts_over_st_2]: '過入庫',
    [tokens.code.rqsts_pro_crm_2]: '製品に関する問い合わせ',
    [tokens.code.rqsts_sup_data_02]: '証拠資料',
    [tokens.code.rqsts_unrecover2]: '未回収',
    [tokens.code.rqsts_wrg_ord_2]: '誤発注',
    [tokens.code.rqsts_wrg_sto_2]: '誤入庫',
    [tokens.code.tkbck_prog_tc]: '回収完了',
    [tokens.code.tkbck_prog_tg]: '回収中',
    [tokens.code.tkbck_prog_tx]: '回収キャンセル',
    [tokens.code.tkbck_prcsn_done]: '回収正常終了',
    [tokens.code.tkbck_prcsn_fc]: '完了',
    [tokens.code.tkbck_prcsn_n]: '未処理',
    [tokens.code.tkbck_prcsn_pc]: '部分完了',
    [tokens.code.tkbck_prcsn_r]: '待機中',
    [tokens.code.tkbck_inb_ab]: '廃棄',
    [tokens.code.tkbck_inb_gq]: '良品化',
    [tokens.code.tkbck_inb_qw]: '良品待機',
    [tokens.code.tkbck_inb_ret]: '返品',
    [tokens.code.tkbck_dlv_ab]: '自主廃棄',
    [tokens.code.tkbck_dlv_c]: 'センター回収',
    [tokens.code.mdlml_inb_stt_ic]: '入庫完了',
    [tokens.code.mdlml_inb_stt_in_dlv]: '配送中',
    [tokens.code.mdlml_inb_stt_iw]: '入庫待機',
    [tokens.code.mdlml_inb_stt_prtl_dlv]: '部分配送',
    [tokens.code.mdlml_inb_stt_xi]: '未入庫',
    [tokens.code.ord_prog_dc]: '配送完了',
    [tokens.code.ord_prog_dd]: '配送遅延',
    [tokens.code.ord_prog_dw]: '配送中',
    [tokens.code.ord_prog_oc]: '注文確定',
    [tokens.code.ord_prog_or]: '注文受付',
    [tokens.code.ord_prog_ox]: '注文キャンセル',
    [tokens.code.ord_prog_pd]: '部分配送',
    [tokens.code.ord_prog_sw]: '出荷中',
    [tokens.code.ord_prog_pc]: '梱包完了',
    [tokens.code.ord_prog_sc]: '出荷完了',
    [tokens.code.ord_prog_address_fail]: 'アドレスエラー',
    [tokens.code.ord_cancel_ok]: '正常',
    [tokens.code.ord_cancel_ox]: '全体キャンセル',
    [tokens.code.ord_cancel_pc]: '部分キャンセル',
    [tokens.code.outb_stt_e]: '未出',
    [tokens.code.outb_stt_el]: '未積載',
    [tokens.code.outb_stt_k]: '確認必要',
    [tokens.code.outb_stt_n]: '正常',
    [tokens.code.outb_stt_pd]: '部分配送',
    [tokens.code.outb_stt_q]: '先出庫',
    [tokens.code.outb_stt_ro]: '再出庫',
    [tokens.code.outb_stt_x]: 'キャンセル',
    [tokens.code.outb_typ_emrg]: '緊急出庫',
    [tokens.code.outb_typ_last]: '支線',
    [tokens.code.outb_typ_mid]: '幹線',
    [tokens.code.issu_src_e]: '未出',
    [tokens.code.issu_src_el]: '未積載',
    [tokens.code.issu_src_k]: '要確認',
    [tokens.code.issu_src_n]: '正常',
    [tokens.code.issu_src_pd]: '部分配送',
    [tokens.code.issu_src_q]: '先出庫',
    [tokens.code.issu_src_ro]: '再出庫',
    [tokens.code.issu_src_x]: 'キャンセル',
    [tokens.code.center_issu_e]: '緊急出庫',
    [tokens.code.center_issu_o]: '出庫指示',
    [tokens.code.center_issu_r]: 'リクエストキャンセル',
    [tokens.code.center_issu_ro]: '再出庫指示',
    [tokens.code.center_issu_x]: '注文キャンセル',
    [tokens.code.issu_prcsn_cr]: '顧客リクエスト',
    [tokens.code.issu_prcsn_dd]: '配送遅延',
    [tokens.code.issu_prcsn_et]: 'その他',
    [tokens.code.issu_prcsn_gb]: '商品不良、破損',
    [tokens.code.issu_prcsn_ie]: '在庫不足',
    [tokens.code.invn_adjs_typ_ab]: '廃棄',
    [tokens.code.invn_adjs_typ_defective]: '不良',
    [tokens.code.invn_adjs_typ_los]: '損失処理',
    [tokens.code.invn_adjs_typ_ml]: '未上架',
    [tokens.code.invn_adjs_typ_rcv]: '損失回復',
    [tokens.code.invn_adjs_typ_shl]: '賞味期限調整',
    [tokens.code.invn_adjs_typ_lot]: 'LOT番号修正',
    [tokens.code.invnsu_prog_c]: '完了',
    [tokens.code.invnsu_prog_f]: '確定',
    [tokens.code.invnsu_prog_w]: '進行中',
    [tokens.code.invn_prcsn_ab]: '廃棄',
    [tokens.code.invn_prcsn_ci]: '創刊入庫',
    [tokens.code.invn_prcsn_co]: '創刊出庫',
    [tokens.code.invn_prcsn_defective]: '不良',
    [tokens.code.invn_prcsn_in]: '入庫',
    [tokens.code.invn_prcsn_los]: '損失処理',
    [tokens.code.invn_prcsn_mov]: '移動',
    [tokens.code.invn_prcsn_out]: '出庫',
    [tokens.code.invn_prcsn_rcv]: '損失復旧',
    [tokens.code.invn_prcsn_ret]: '返品',
    [tokens.code.invn_prcsn_shl]: '賞味期限調整',
    [tokens.code.invn_prcsn_tb]: '回収',
    [tokens.code.lct_typ_bd]: '調整ゾーン',
    [tokens.code.lct_typ_db]: '配分ゾーン',
    [tokens.code.lct_typ_et]: 'その他',
    [tokens.code.lct_typ_in]: '入庫ゾーン',
    [tokens.code.lct_typ_jb]: '作業ゾーン',
    [tokens.code.lct_typ_kp]: '保管ゾーン',
    [tokens.code.lct_typ_mv]: '移動ゾーン',
    [tokens.code.lct_typ_ot]: '出庫ゾーン',
    [tokens.code.lct_typ_pk]: 'ピッキングゾーン',
    [tokens.code.lct_typ_rt]: '返品ゾーン',
    [tokens.code.lct_typ_tk]: '回収ゾーン',
    [tokens.code.tm_dlv_stat_dlv_cpl]: '配送完了',
    [tokens.code.tm_dlv_stat_in_dlv]: '配送中',
    [tokens.code.tm_dlv_stat_inb_wait]: '入車待機中',
    [tokens.code.tm_dlv_stat_load_inspc]: '積載検査中',
    [tokens.code.tm_dlv_stat_load_wait]: '積載待機中',
    [tokens.code.dlv_ml_last]: '支線',
    [tokens.code.dlv_ml_mid]: '幹線',
    [tokens.code.tm_biz_type_prsnl]: '個人',
    [tokens.code.tm_biz_type_trnsp]: '運送業者',
    [tokens.code.tm_cntr_stat_cntr_end]: '契約終了',
    [tokens.code.tm_cntr_stat_under_cntr]: '契約中',
    [tokens.code.stlprg_mnt_next_mth]: '翌月',
    [tokens.code.stand_dt_1]: '1',
    [tokens.code.stand_dt_10]: '10',
    [tokens.code.stand_dt_15]: '15',
    [tokens.code.stand_dt_20]: '20',
    [tokens.code.stand_dt_25]: '25',
    [tokens.code.stand_dt_5]: '5',
    [tokens.code.stand_dt_last]: '末日',
    [tokens.code.cnsln_typ_cd_claim]: 'クレーム',
    [tokens.code.cnsln_typ_cd_common]: '一般',
    [tokens.code.cnsln_typ_cd_issue]: '出荷問題',
    [tokens.code.cnsln_typ_cd_msg]: 'メッセージ送信',
    [tokens.code.cnsln_typ_cd_recall]: '返品/交換',
    [tokens.code.cnsln_typ_cd_urgnt_dlvr]: '緊急出荷',
    [tokens.code.crm_gnr_inq_break_crm_01]: '破損',
    [tokens.code.crm_gnr_inq_comp_crm_01]: 'コンピュータ問い合わせ',
    [tokens.code.crm_gnr_inq_cr_dlvr_1]: '対応配送',
    [tokens.code.crm_gnr_inq_cred_crm_01]: '決済問い合わせ',
    [tokens.code.crm_gnr_inq_dlvr_crm_01]: '配送問い合わせ',
    [tokens.code.crm_gnr_inq_dlvr_rt]: '配送 • 回収 問い合わせ',
    [tokens.code.crm_gnr_inq_dmg_py_01]: '再貨破損',
    [tokens.code.crm_gnr_inq_docu_crm_01]: '書類要求',
    [tokens.code.crm_gnr_inq_door_lo_1]: '出入り口未施行',
    [tokens.code.crm_gnr_inq_er_code_1]: 'エラーコード',
    [tokens.code.crm_gnr_inq_err_st_1]: '誤積載',
    [tokens.code.crm_gnr_inq_etc]: 'その他問い合わせ',
    [tokens.code.crm_gnr_inq_etc_01]: 'その他の問い合わせ',
    [tokens.code.crm_gnr_inq_goods_inq]: '商品問い合わせ',
    [tokens.code.crm_gnr_inq_no_st_cr_1]: '未入庫',
    [tokens.code.crm_gnr_inq_open_cl_1]: '冷蔵庫開閉',
    [tokens.code.crm_gnr_inq_ord_crm_01]: '発注問い合わせ',
    [tokens.code.crm_gnr_inq_ord_stl]: '注文 • 精算 問い合わせ',
    [tokens.code.crm_gnr_inq_over_st_1]: '過剰入庫',
    [tokens.code.crm_gnr_inq_prod_crm_01]: '製品問い合わせ',
    [tokens.code.crm_gnr_inq_sup_da_01]: '証明資料',
    [tokens.code.crm_gnr_inq_sys]: 'システム問い合わせ',
    [tokens.code.crm_gnr_inq_unrecover_01]: '未回収',
    [tokens.code.crm_gnr_inq_wng_or_1]: '誤発注',
    [tokens.code.crm_gnr_inq_wng_st_1]: '誤入庫',
    [tokens.code.crm_dtl_ty_bad]: '商品不良',
    [tokens.code.crm_dtl_ty_bad_pack]: '包装不良',
    [tokens.code.crm_dtl_ty_break]: '商品破損',
    [tokens.code.crm_dtl_ty_break_crm]: '破損',
    [tokens.code.crm_dtl_ty_comp_crm]: 'コンピュータ問い合わせ',
    [tokens.code.crm_dtl_ty_cor_dlvr]: '対応配送',
    [tokens.code.crm_dtl_ty_cred_crm]: '決済問い合わせ',
    [tokens.code.crm_dtl_ty_dlvr_crm]: '配送問い合わせ',
    [tokens.code.crm_dtl_ty_dly_dlvr]: '遅延配送',
    [tokens.code.crm_dtl_ty_dmg_pry]: '再貨破損',
    [tokens.code.crm_dtl_ty_docu_crm]: '書類要求',
    [tokens.code.crm_dtl_ty_door_lock]: '出入り口未施行',
    [tokens.code.crm_dtl_ty_err_code]: 'エラーコード',
    [tokens.code.crm_dtl_ty_err_ln_bd]: '与信・債権 エラー',
    [tokens.code.crm_dtl_ty_err_ord]: '注文不可エラー',
    [tokens.code.crm_dtl_ty_err_price]: '精算金額 エラー',
    [tokens.code.crm_dtl_ty_err_recall]: '再回収',
    [tokens.code.crm_dtl_ty_err_stack]: '誤積載',
    [tokens.code.crm_dtl_ty_etc]: 'その他',
    [tokens.code.crm_dtl_ty_expired_dt]: '賞味期限',
    [tokens.code.crm_dtl_ty_misdlvr]: '誤配送',
    [tokens.code.crm_dtl_ty_no_st_cr]: '未入庫',
    [tokens.code.crm_dtl_ty_open_close]: '冷蔵庫開閉',
    [tokens.code.crm_dtl_ty_ord_crm]: '発注問い合わせ',
    [tokens.code.crm_dtl_ty_over_st]: '過剰入庫',
    [tokens.code.crm_dtl_ty_prod_crm]: '製品問い合わせ',
    [tokens.code.crm_dtl_ty_sup_da]: '証明資料',
    [tokens.code.crm_dtl_ty_undlvr]: '未配送',
    [tokens.code.crm_dtl_ty_unrecover]: '未回収',
    [tokens.code.crm_dtl_ty_wrg_ord]: '誤発注',
    [tokens.code.crm_dtl_ty_wrg_st]: '誤入庫',
    [tokens.code.return_stt_cd_approve]: '返品承認',
    [tokens.code.return_stt_cd_receipt]: '受付',
    [tokens.code.return_stt_cd_reject]: '返却',
    [tokens.code.prcsn_stt_cd_done]: '完了',
    [tokens.code.prcsn_stt_cd_incomplete]: '未完了',
    [tokens.code.prcsn_stt_cd_rc]: 'リクエストキャンセル',
    [tokens.code.crm_process_type_e]: '交換',
    [tokens.code.crm_process_type_r]: '返品',
    [tokens.code.crm_type_basc_ask]: '一般問い合わせ',
    [tokens.code.crm_type_break_bad]: '商品破損・不良',
    [tokens.code.crm_type_claim_ask]: 'クレーム',
    [tokens.code.crm_type_dlvr_rt]: '配送・回収',
    [tokens.code.crm_type_etc_ask]: 'その他',
    [tokens.code.crm_type_ord_stl]: '注文・精算',
    [tokens.code.noti_state_noti]: '通知中',
    [tokens.code.noti_state_noti_end]: '通知終了',
    [tokens.code.notice_ctg_brand_cal]: '債権・清算',
    [tokens.code.notice_ctg_etc]: 'その他',
    [tokens.code.notice_ctg_goods]: '商品',
    [tokens.code.notice_ctg_ord_deli]: '注文・配送',
    [tokens.code.notice_ctg_system]: 'システム',
    [tokens.code.grnt_typ_cash]: '現金',
    [tokens.code.grnt_typ_credit]: '信用',
    [tokens.code.grnt_typ_pgrnt]: '履行保証保険',
    [tokens.code.tm_dlv_cpl_stat_dlv_cpl]: '配送完了',
    [tokens.code.tm_dlv_cpl_stat_in_dlv]: '配送中',
    [tokens.code.tm_dlv_cpl_stat_no_dlv]: '未配送',
    [tokens.code.tm_dlv_cpl_stat_prtl_dlv]: '部分配送',
    [tokens.code.bond_typ_cd_adj]: '調整金',
    [tokens.code.bond_typ_cd_en]: '解約',
    [tokens.code.bond_typ_cd_in]: '入金',
    [tokens.code.bond_typ_cd_mig]: '売上移管',
    [tokens.code.bond_typ_cd_out]: '出金',
    [tokens.code.bond_typ_cd_st]: '生成',
    [tokens.code.parcel]: '宅配',
    [tokens.code.truck]: 'トラック',
    [tokens.code.ft20]: '20FT',
    [tokens.code.ft40]: '40FT',
    [tokens.code.invn_splm_stt_c]: '補足完了',
    [tokens.code.invn_splm_stt_o]: '補足指示',
    [tokens.code.invn_splm_stt_r]: '補充待機',
    [tokens.code.inb_method_typ_receipt_official]: '正規入荷',
    [tokens.code.inb_method_typ_rt_vendor]: '取引先返品',
    [tokens.code.inb_method_typ_rt_amazon]: 'アマゾン返品',
    [tokens.code.inb_method_typ_rt_jojo]: 'ジョジョ返品',
    [tokens.code.inb_method_typ_rt_popup]: 'ポップアップ返品',
    [tokens.code.inb_method_typ_rt_head_of]: '本社返品',
    [tokens.code.inb_method_typ_rt_qt]: 'Qoo10返品',
    [tokens.common.invoice_bulk_down]: '送り状番号発行',
    [tokens.common.invoice_re_print]: '送り状番号再発行',
    [tokens.common.invoice_print]: '送り状番号出力',
    [tokens.common.invoice_bulk_down_description]: '同じサイズで選択した注文の送り状番号を発行します。',
    [tokens.common.invoice_list_not_found]: '出力可能な送り状番号がありません。',
    [tokens.common.print_option]: '出力オプション',
    [tokens.common.selected_order_print]: '選択した注文の送り状番号全部出力',
    [tokens.common.selected_invoice_number_print]: '送り状番号選択で出力',
    [tokens.common.invoice_down]: '納品書ダウンロード',
    [tokens.common.ida_invoice_down]: 'IDA納品書ダウンロード',
    [tokens.common.other_invoice_down]: 'その他納品書ダウンロード',
    [tokens.common.packing_start]: 'パッキング開始',
    [tokens.common.packing_inspection]: 'パッキング検品',
    [tokens.common.individual_picking_code]: '個別ピッキングコード',
    [tokens.common.purchaser_name]: '発注先名',
    [tokens.common.goods_barcode]: 'バーコード',
    [tokens.common.goods_barcode_scan]: '商品バーコードスキャン',
    [tokens.common.packing_complete]: 'パッキング完了',
    [tokens.common.next_box_packing]: '次のボックスパッキング',
    [tokens.common.box_packing]: 'ボックスパッキング',
    [tokens.common.total_picking_code]: 'トータルピッキングコード',
    [tokens.common.packed_quantity]: 'パッキング数量',
    [tokens.common.input_quantity]: '入数',
    [tokens.common.box_code]: 'ボックスコード',
    [tokens.common.packaging_box]: '包装箱',
    [tokens.common.box_modification]: 'ボックス変更',
    [tokens.common.box_barcode]: 'ボックスバーコード',
    [tokens.common.enter_box_barcode]: 'ボックスバーコードを入力してください',
    [tokens.common.invoice_number]: '送り状番号',
    [tokens.common.status]: '状態',
    [tokens.common.expiry_date]: '賞味期限',
    [tokens.common.area]: 'エリア',
    [tokens.common.select_area]: 'エリア選択',
    [tokens.common.total_packed_quantity]: '完了数量',
    [tokens.common.packing_status]: 'パッキング状態',
    [tokens.common.quantity_input]: '数量入力',
    [tokens.common.box_size]: '包装箱サイズ',
    [tokens.common.now_box_size]: '現在包装箱サイズ',
    [tokens.common.goods_name]: '商品名',
    [tokens.common.order_qty]: '注文数量',
    [tokens.common.inspection_quantity]: '検品数量',
    [tokens.common.packing_work_end]: 'パッキング作業終了',
    [tokens.common.packing_work_end_confirm_message_1]: 'ページを離れる場合',
    [tokens.common.packing_work_end_confirm_message_2]: 'パッキング完了されていない商品は検収が初期化されます。',
    [tokens.common.packing_work_end_confirm_message_3]: 'ボックスに入っている商品を取り出してください。',
    [tokens.common.packing_incomplete_items]: 'まだ検収されていない商品があります。それでも終了しますか？',
    [tokens.common.packing_incomplete_items_for_invoice]: '検収が完了していない商品があります。',
    [tokens.common.packing_inspection_reset]: 'パッキング検収初期化',
    [tokens.common.packing_inspection_reset_confirm]: '⚠️ 検収履歴がすべて初期化されます。\nこの作業は元に戻すことができません。\n続行しますか？',
    [tokens.common.packing_inspection_reset_success]: 'パッキング検収が正常に初期化されました。',
    [tokens.common.individual_picking_code_required_for_reset]: '初期化するには個別ピッキングコードを先に入力してください。',
    [tokens.common.inspection_completed]: '検収完了',
    [tokens.common.already_inspected_product]: '既に検収完了された商品です。',
    [tokens.common.packing_exceeded]: 'パッキング超過',
    [tokens.common.packing_quantity_exceeds_order_quantity]: 'パッキング数量が注文数量を超過することはできません。',
    [tokens.common.inspection_update_error]: '検収更新中にエラーが発生しました。',
    [tokens.common.barcode_error]: 'バーコードエラー',
    [tokens.common.product_not_found_for_barcode]: '該当バーコードの商品が見つかりません',
    [tokens.common.packing_complete_auto]: 'パッキング完了',
    [tokens.common.packing_complete_auto_message]: 'すべての商品が検収完了されました。パッキング完了処理します。',
    [tokens.common.packing_already_completed]: '既に完了したパッキング',
    [tokens.common.packing_complete_confirm_info]: '実際のボックス数量と一致するか確認してから確認を押してください。',
    [tokens.common.packing_already_completed_message]: '既に送り状番号とボックス番号が発番されたパッキングです。初期画面に戻ります。',
    [tokens.common.cargo_outbound_no_invoice_print]: '貨物出荷として処理します。送り状は印刷されません。',
    [tokens.common.bulk_inspection_complete]: '一括検収完了',
    [tokens.common.bulk_inspection_confirm]: '選択した注文を一括検収処理します。\n本当に進めますか？',
    [tokens.common.cargo_outbound]: '貨物出荷',
    [tokens.common.inspection_start]: '検品開始',
    [tokens.common.cargo_complete_with_box_count]: 'パッキング完了・箱数入力',
    [tokens.common.batch_inspection_reinspection_not_allowed]: '一括検収完了の注文は再検品できません',
    [tokens.common.individual_picking_code_length_error]: '個別ピッキングコードを10桁または14桁で入力してください',
    [tokens.common.cancel]: 'キャンセル',
    [tokens.common.confirm]: '確認',
    [tokens.common.location_alias_modification_message]: 'ロケーション名を編集しますか？',
    [tokens.common.location_alias_modification_success_message]: 'ロケーション名の変更が完了しました。',
    [tokens.common.location_alias_modification_error_message]: 'ロケーション名の変更に失敗しました。',
    [tokens.common.outbound_pending]: '出荷待機',
    [tokens.common.outbound_work]: '出荷作業',
    [tokens.common.outbound_complete]: '出荷完了',
    [tokens.common.outbound_complete_old]: '出荷完了_old',
    [tokens.common.invoice_number]: '送り状番号',
    [tokens.common.purchaser]: '仕入先',
    [tokens.common.logistics_number]: '物流番号',
    [tokens.common.goods_id]: '商品ID',
    [tokens.common.product_name]: '商品名',
    [tokens.common.order_quantity]: '注文数量',
    [tokens.common.loading_quantity]: '積載数量',
    [tokens.common.unit]: '単位',
    [tokens.common.outbound_date]: '出荷日',
    [tokens.common.packing_complete]: 'パッキング終了',
    [tokens.common.packing_start_date]: 'パッキング開始日時',
    [tokens.common.start_date]: '開始日',
    [tokens.common.end_date]: '終了日',
    [tokens.common.inspection_status]: '検品状態',
    [tokens.common.partial_inspection]: '部分検品',
    [tokens.common.inspection_complete]: '検品完了',
    [tokens.common.box_cnt]: 'ボックス数',
    [tokens.common.total_qty]: '合計数量',
    [tokens.common.urgent_outbound]: '緊急出荷',
    [tokens.common.urgent_outbound_type]: '緊急出荷タイプ',
    [tokens.common.type]: 'タイプ',
    [tokens.common.cargo]: '貨物',
    [tokens.common.parcel]: '宅配便',
    [tokens.common.delivery_status]: '配送状態',
    [tokens.common.delivery_in_progress]: '配送中',
    [tokens.common.delivery_completed]: '配送完了',
    [tokens.common.invoice_registration]: '送状受付',
    [tokens.common.packing_completion_date]: 'パッキング完了日',
    [tokens.common.individual_picking_code]: '個別ピッキングコード',
    [tokens.common.product]: '商品',
    [tokens.common.scheduled_outbound_date]: '出荷予定日',
    [tokens.common.one_or_more]: '1個以上',
    [tokens.common.three_or_more]: '3個以上',
    [tokens.common.five_or_more]: '5個以上',
    [tokens.common.ten_or_more]: '10個以上',
    [tokens.common.all]: 'すべて',
    [tokens.common.canceled]: 'キャンセル',
    [tokens.common.region]: '地域',
    [tokens.common.select_region]: '地域選択',
    [tokens.common.outbound_complete_processing]: '出荷完了処理',
    [tokens.common.selected_orders_outbound_complete_processing]: '選択された{{count}}件の注文の出荷完了処理を進行します',
    [tokens.common.outbound_complete_processing_under_conditions]: '以下の条件の出荷完了処理を進行します',
    [tokens.common.sales_partner]: '売上先',
    [tokens.common.select_sales_partner]: '売上先選択',
    [tokens.common.outbound_complete_processing_according_to_selected_conditions]: '選択された条件に従って出荷完了処理が進行されます',
    [tokens.common.completion]: '完了',
    [tokens.common.individual_order_code]: '個別注文コード',
    [tokens.common.invoice_registration_status]: '送状受付状態',
    [tokens.common.not_registered]: '未受付',
    [tokens.common.partial_registration]: '部分受付',
    [tokens.common.registration_complete]: '受付',
    [tokens.common.individual_order_code]: '個別注文コード',
    [tokens.common.sender_name]: '送信者名',
    [tokens.common.sender_address]: '送り先住所',
    [tokens.common.sender_tel]: '発送人の電話番号',
    [tokens.common.inventory_snapshot_excel_down]: 'SKU 可用在庫リスト',
    [tokens.common.inventory_snapshot_detail_excel_down]: '在庫詳細(ロケーション, LOT, EXP)',
    [tokens.common.inventory_excel_down]: 'SKU 可用在庫リスト',
    [tokens.common.inventory_detail_excel_down]: '在庫詳細(ロケーション, LOT, EXP)',
    [tokens.common.packing_inspection_data_fetch_failed]: 'パッキング検数データ取得失敗: {{error}}',
    [tokens.common.no_items_available_for_assignment]: '割り当て可能な商品がありません',
    [tokens.common.server_connection_error]: 'サーバーに接続できません。ネットワーク状態を確認してください。',
    [tokens.common.next_box_packing_failed]: '次のボックスパッキング失敗: {{error}}',
    [tokens.common.packing_complete_failed]: 'パッキング完了失敗: {{error}}',
    [tokens.common.quantity_must_be_at_least_one]: '数量は1以上でなければなりません',
    [tokens.common.over_packing_not_allowed]:
        'オーバーパッキング不可！注文数量({{orderQty}}) - 現在検数数量({{currentPackedQty}}) = 残り検数可能数量({{remainingQty}})個です。',
    [tokens.common.packing_inspection_reset_failed]: 'パッキング検数リセット失敗: {{error}}',
    [tokens.common.box_reset]: 'ボックス初期化',
    [tokens.common.box_reset_confirm]: 'Box {{boxSeq}}を初期化しますか？\nこの作業は元に戻すことができません。',
    [tokens.common.box_reset_success]: 'ボックスが初期化されました。',
    [tokens.common.inspection_qty_edit]: '検数数量修正',
    [tokens.common.box_reset_select]: 'ボックス初期化 - ボックス選択',
    [tokens.common.inspection_qty_edit_select]: '検数数量修正 - ボックス選択',
    [tokens.common.no_box_found]: '照会されたボックスがありません。',
    [tokens.common.please_scan_picking_code]: '個別ピッキングコードを先にスキャンしてください。',
    [tokens.common.inspection_qty_edit_success]: '検数数量が修正されました。',
    [tokens.common.same_quantity_warning]: '現在と同じ数量です。',
    [tokens.common.max_modifiable_qty_warning]: '最大修正可能数量は{{max}}個です。',
    [tokens.common.modify_quantity]: '修正数量',
    [tokens.common.current_assigned_qty]: '現在の割当数量',
    [tokens.common.max_modifiable_qty]: '最大修正可能数量',
    [tokens.common.packing_re_inspection]: 'パッキング再検数',
    [tokens.common.packing_re_inspection_complete]: 'パッキング再検数完了',
    [tokens.common.re_inspection_incomplete_warning]: '全ての数量がボックスに割り当てられていません。割り当て完了後に終了してください。',
    [tokens.common.box_barcode_required]: 'ボックスバーコードをスキャンしてください。',
    [tokens.common.re_inspection_must_complete]: 'ボックス修正または数量修正の履歴があるため、パッキング再検数完了が必要です。',
    [tokens.common.re_inspection_reprint_confirm]: 'パッキング再検数時、送り状をすべて再出力して新しく貼り付ける必要があります。',
    [tokens.common.inquiry]: '照会',
    [tokens.common.scan_goods_barcode]: '商品バーコードをスキャンしてください',
    [tokens.common.enter_inspection_quantity]: '検数する数量を入力してください',
    [tokens.common.packing_status_not_started]: '未開始',
    [tokens.common.packing_status_complete]: '完了',
    [tokens.common.packing_status_in_progress]: '進行中',
    [tokens.common.inspection_status_not_inspected]: '未検数',
    [tokens.common.inspection_status_partial]: '部分検数',
    [tokens.common.inspection_status_complete]: '検数完了',
}
